(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/base64-js/index.js":
/*!*****************************************!*\
  !*** ./node_modules/base64-js/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/buffer/index.js":
/*!**************************************!*\
  !*** ./node_modules/buffer/index.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(/*! base64-js */ "./node_modules/base64-js/index.js")
var ieee754 = __webpack_require__(/*! ieee754 */ "./node_modules/ieee754/index.js")
var isArray = __webpack_require__(/*! isarray */ "./node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}


/***/ }),

/***/ "./node_modules/ieee754/index.js":
/*!***************************************!*\
  !*** ./node_modules/ieee754/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/isarray/index.js":
/*!***************************************!*\
  !*** ./node_modules/isarray/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"content\">\r\n    <router-outlet></router-outlet>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/admin/admin.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/admin/admin.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-layout class=\"app-layout\" style=\"max-width: 100vw;\">\r\n  <nz-sider class=\"menu-sidebar\" nzCollapsible nzWidth=\"256px\" nzBreakpoint=\"md\" [(nzCollapsed)]=\"isCollapsed\"\r\n    [nzTrigger]=\"null\">\r\n    <div class=\"sidebar-logo\">\r\n      <a href=\"https://www.laica.it\" target=\"_blank\">\r\n        <img src=\"../assets/logo-laica-white.png\" alt=\"logo\" *ngIf=\"!isCollapsed\">\r\n        <img src=\"../favicon.ico\" alt=\"logo\" *ngIf=\"isCollapsed\">\r\n      </a>\r\n    </div>\r\n    <div class=\"sidebar-title-header\" *ngIf=\"!isCollapsed\">\r\n      <h1>Management</h1>\r\n    </div>\r\n    <ul nz-menu nzTheme=\"dark\" nzMode=\"inline\" [nzInlineCollapsed]=\"isCollapsed\" *ngIf=\"!isCollapsed\">\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./categories\"><i nz-icon nzType=\"appstore\" nzTheme=\"outline\"></i>Categories</a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./products\"><i nz-icon nzType=\"unordered-list\" nzTheme=\"outline\"></i>Products</a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./users\"><i nz-icon nzType=\"user\" nzTheme=\"outline\"></i>Users</a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./adv\"><i nz-icon nzType=\"notification\" nzTheme=\"outline\"></i>Advertising</a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./filters\"><i nz-icon nzType=\"filter\" nzTheme=\"outline\"></i>Filters</a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./filters-notifications\"><i nz-icon nzType=\"bell\" nzTheme=\"outline\"></i>Filters Notification</a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./livings\"><i nz-icon nzType=\"inbox\" nzTheme=\"outline\"></i>Livings</a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./livings-notifications\"><i nz-icon nzType=\"bell\" nzTheme=\"outline\"></i>Livings Notification</a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./faq\"><i nz-icon nzType=\"exception\" nzTheme=\"outline\"></i>Faq</a>\r\n      </li>\r\n    </ul>\r\n    <ul nz-menu nzTheme=\"dark\" nzMode=\"inline\" [nzInlineCollapsed]=\"isCollapsed\" *ngIf=\"isCollapsed\">\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./categories\"><i nz-icon nzType=\"appstore\" nzTheme=\"outline\"></i></a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./products\"><i nz-icon nzType=\"unordered-list\" nzTheme=\"outline\"></i></a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./users\"><i nz-icon nzType=\"user\" nzTheme=\"outline\"></i></a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./adv\"><i nz-icon nzType=\"notification\" nzTheme=\"outline\"></i></a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./filters\"><i nz-icon nzType=\"filter\" nzTheme=\"outline\"></i></a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./filters-notifications\"><i nz-icon nzType=\"bell\" nzTheme=\"outline\"></i></a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./livings\"><i nz-icon nzType=\"inbox\" nzTheme=\"outline\"></i></a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./livings-notifications\"><i nz-icon nzType=\"bell\" nzTheme=\"outline\"></i></a>\r\n      </li>\r\n      <li nz-menu-item nzMatchRouter>\r\n        <a routerLink=\"./faq\"><i nz-icon nzType=\"exception\" nzTheme=\"outline\"></i></a>\r\n      </li>\r\n    </ul>\r\n  </nz-sider>\r\n  <nz-layout>\r\n    <nz-header>\r\n      <div class=\"app-header\">\r\n        <span class=\"header-trigger\" (click)=\"isCollapsed = !isCollapsed\">\r\n          <i class=\"trigger\" nz-icon [nzType]=\"isCollapsed ? 'menu-unfold' : 'menu-fold'\"></i>\r\n        </span>\r\n        <span class=\"logout-trigger\" (click)=\"onSubmitLogout()\">\r\n          <i class=\"poweroff\" nz-icon nzType=\"poweroff\" nzTheme=\"outline\"></i>\r\n        </span>\r\n      </div>\r\n    </nz-header>\r\n    <nz-content>\r\n      <div class=\"inner-content\">\r\n        <router-outlet></router-outlet>\r\n      </div>\r\n    </nz-content>\r\n    <nz-footer>{{appVersion}} Copyright ©2019 Ocalab By PromoInVideo S.r.l</nz-footer>\r\n  </nz-layout>\r\n</nz-layout>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/adv/adv.component.html":
/*!************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/adv/adv.component.html ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<button nz-button nzType=\"primary\" (click)=\"showForm = !showForm\" [ngClass]=\"showForm ? 'showBtn' : 'hideBtn'\">Add record</button> <br/>\r\n<nz-card class=\"addCard\" *ngIf=\"showForm\">\r\n    <h3>Add product</h3>\r\n    <form [formGroup]=\"advGroup\" (ngSubmit)=\"addRow()\">\r\n        <div class=\"gutter-example\">\r\n            <div nz-row [nzGutter]=\"16\">\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Title* : <input nz-input formControlName=\"title\" />\r\n                </div>\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Language :\r\n                    <nz-select nzPlaceHolder=\"Select a language\" formControlName=\"languageCode\">\r\n                        <nz-option *ngFor=\"let item of listOfLanguages\" nzLabel=\"{{item.text}}\"\r\n                            nzValue=\"{{item.value}}\">\r\n                        </nz-option>\r\n                    </nz-select>\r\n                </div>\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Start date* :\r\n                    <br/>\r\n                    <nz-date-picker formControlName=\"dateStart\"></nz-date-picker>\r\n                </div>\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    End date* :\r\n                    <br/>\r\n                    <nz-date-picker formControlName=\"dateEnd\"></nz-date-picker>\r\n                </div>\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Link : <input nz-input formControlName=\"link\" />\r\n                </div>\r\n                <br />\r\n                <button nz-button nzType=\"primary\" [disabled]=\"advGroup.invalid\" class=\"addBtn\">Add adv</button>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</nz-card>\r\n<button nz-button nzType=\"primary\" (click)=\"resetFilters()\" class=\"resetBtn\">Clear filters</button>\r\n<nz-table #dataTable nzBordered nzSize=\"middle\" [nzData]=\"displayedData\" [nzPageSize]=\"7\" [nzLoading]=\"loading\"\r\n    nzPaginationPosition=\"both\">\r\n    <thead>\r\n        <tr>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\">Code</th>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\">Title</th>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\" nzShowFilter [nzFilters]=\"listOfLanguages\"\r\n                (nzFilterChange)=\"filter($event, searchStatus)\">Language</th>\r\n            <th nzAlign=\"center\" nzWidth=\"200px\">Start date</th>\r\n            <th nzAlign=\"center\" nzWidth=\"200px\">End date</th>\r\n            <th nzAlign=\"center\" nzWidth=\"50px\">Image</th>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\">Link</th>\r\n            <th nzAlign=\"center\" nzWidth=\"200px\" nzShowFilter [nzFilters]=\"listOfStatus\" [nzFilterMultiple]=\"false\"\r\n                (nzFilterChange)=\"filter(listOfSearchLanguages, $event)\">Status</th>\r\n            <th nzAlign=\"center\" nzWidth=\"200px\">Actions</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr *ngFor=\"let data of dataTable.data; let i = index\" [ngClass]=\"data.status ? 'row-on' : 'row-off'\">\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.code}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else titleInputTpl\">\r\n                    {{data.title}}\r\n                </ng-container>\r\n                <ng-template #titleInputTpl>\r\n                    <textarea rows=\"3\" type=\"text\" nzSize=\"default\" nz-input\r\n                        [(ngModel)]=\"editCache[data.code].data.title\"></textarea>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else languageSelectTpl\">\r\n                    <span *ngIf=\"data.languageCode\">{{data.languageCode}}</span>\r\n                    <span  *ngIf=\"!data.languageCode\">ALL LANGUAGES</span>\r\n                </ng-container>\r\n                <ng-template #languageSelectTpl>\r\n                    <nz-select class=\"editSelect\" nzPlaceHolder=\"Select a language\"\r\n                        [(ngModel)]=\"editCache[data.code].data.languageCode\">\r\n                        <nz-option *ngFor=\"let item of listOfLanguages\" nzLabel=\"{{item.text}}\"\r\n                            nzValue=\"{{item.value}}\">\r\n                        </nz-option>\r\n                    </nz-select>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else dateStartInputTpl\">\r\n                    {{data.dateStart | date: 'dd/MM/yyyy'}}\r\n                </ng-container>\r\n                <ng-template #dateStartInputTpl>\r\n                    <nz-date-picker [(ngModel)]=\"editCache[data.code].data.dateStart\" nzFormat=\"dd/MM/yyyy\">\r\n                    </nz-date-picker>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else dateEndInputTpl\">\r\n                    {{data.dateEnd | date: 'dd/MM/yyyy'}}\r\n                </ng-container>\r\n                <ng-template #dateEndInputTpl>\r\n                    <nz-date-picker [(ngModel)]=\"editCache[data.code].data.dateEnd\" nzFormat=\"dd/MM/yyyy\">\r\n                    </nz-date-picker>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <nz-upload nzAction=\"{{uploadURL}}\" nzListType=\"picture-card\"\r\n                    (nzChange)=\"handleChange($event, data.code)\" [nzName]=\"data.code\" [nzCustomRequest]=\"customReq\"\r\n                    [nzBeforeUpload]=\"beforeUpload\" [nzShowUploadList]=\"false\"\r\n                    [nzType]=\"data.loading ? 'loading' : 'plus'\" width=\"64\" height=\"64\">\r\n                    <ng-container *ngIf=\"!data.image\">\r\n                        <i class=\"upload-icon\" nz-icon [nzType]=\"loading ? 'loading' : 'plus'\"></i>\r\n                        <div class=\"ant-upload-text\">Upload</div>\r\n                    </ng-container>\r\n                    <img *ngIf=\"data.image\" [src]=\"imgPath + data.image\" height=\"64\" />\r\n                </nz-upload>\r\n                <a *ngIf=\"data.image\" (click)=\"editCache[data.code].visibleImage = true\"><i nz-icon nzType=\"eye\"\r\n                        nzTheme=\"outline\"></i> Zoom</a>\r\n                <nz-modal [(nzVisible)]=\"editCache[data.code].visibleImage\" [nzFooter]=\"null\"\r\n                    (nzOnCancel)=\"editCache[data.code].visibleImage=false\" nzWidth=\"770\">\r\n                    <img [src]=\"imgPath + data.image\" width=\"700\">\r\n                </nz-modal>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else linkInputTpl\">\r\n                    <a *ngIf=\"data.link\" target=\"_blank\" href=\"{{data.link}}\">Link</a>\r\n                </ng-container>\r\n                <ng-template #linkInputTpl>\r\n                    <textarea rows=\"7\" type=\"text\" nzSize=\"default\" nz-input\r\n                        [(ngModel)]=\"editCache[data.code].data.link\"></textarea>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <nz-switch (click)=\"onClickSwitch(data.code)\" [nzControl]=\"true\" [(ngModel)]=\"data.status\"></nz-switch>\r\n            </td>\r\n            <td nzAlign=\"center\">\r\n                <a nz-popconfirm nzTitle=\"Sure to delete?\" (nzOnConfirm)=\"deleteRow(data.code)\" class=\"actionLink\">\r\n                    <i nz-icon nzType=\"delete\" nzTheme=\"outline\"></i>\r\n                </a>\r\n                <br />\r\n                <div class=\"editable-row-operations\">\r\n                    <ng-container *ngIf=\"!editCache[data.code].edit; else saveTpl\">\r\n                        <a (click)=\"startEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"edit\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-container>\r\n                    <ng-template #saveTpl>\r\n                        <a (click)=\"saveEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"save\" nzTheme=\"outline\"></i><br />\r\n                        </a>\r\n                        <a nz-popconfirm nzTitle=\"Sure to cancel?\" (nzOnConfirm)=\"cancelEdit(data.code)\"\r\n                            class=\"actionLink\">\r\n                            <i nz-icon nzType=\"rollback\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-template>\r\n                </div>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/categories/categories.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/categories/categories.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<button nz-button nzType=\"primary\" (click)=\"showForm = !showForm\" [ngClass]=\"showForm ? 'showBtn' : 'hideBtn'\">Add record</button>\r\n<nz-card class=\"addCard\" *ngIf=\"showForm\">\r\n    <h3>Add category</h3>\r\n    <form [formGroup]=\"categoryGroup\" (ngSubmit)=\"addRow()\">\r\n        <div class=\"gutter-example\">\r\n            <div nz-row [nzGutter]=\"16\">\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Code* : <input nz-input formControlName=\"code\" />\r\n                </div>\r\n                <div formGroupName=\"title\">\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        de* : <input nz-input formControlName=\"de\" />\r\n                        el* : <input nz-input formControlName=\"el\" />\r\n                        en* : <input nz-input formControlName=\"en\" />\r\n                        vn* : <input nz-input formControlName=\"vn\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        es* : <input nz-input formControlName=\"es\" />\r\n                        fr* : <input nz-input formControlName=\"fr\" />\r\n                        hu* : <input nz-input formControlName=\"hu\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        it* : <input nz-input formControlName=\"it\" />\r\n                        pl* : <input nz-input formControlName=\"pl\" />\r\n                        pt* : <input nz-input formControlName=\"pt\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        ro* : <input nz-input formControlName=\"ro\" />\r\n                        zh* : <input nz-input formControlName=\"zh\" />\r\n                        zs* : <input nz-input formControlName=\"zs\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        ar* : <input nz-input formControlName=\"ar\" />\r\n                        cs* : <input nz-input formControlName=\"cs\" />\r\n                        sk* : <input nz-input formControlName=\"sk\" />\r\n                        <button nz-button nzType=\"primary\" [disabled]=\"categoryGroup.invalid\" class=\"addBtn\">Add category</button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</nz-card>\r\n<nz-table #dataTable nzBordered nzSize=\"middle\" [nzData]=\"dataResult\" [nzPageSize]=\"3\" [nzLoading]=\"loading\" nzPaginationPosition=\"both\">\r\n    <thead>\r\n        <tr>\r\n            <th rowspan=\"2\">Code</th>\r\n            <th colspan=\"2\">Title</th>\r\n            <th nzWidth=\"200px\" rowspan=\"2\">Icon</th>\r\n            <th nzWidth=\"200px\" rowspan=\"2\">Image</th>\r\n            <th nzWidth=\"200px\" rowspan=\"2\">Status</th>\r\n            <th nzWidth=\"200px\" rowspan=\"2\">Actions</th>\r\n        </tr>\r\n        <tr>\r\n            <th>ID</th>\r\n            <th>Name</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr *ngFor=\"let data of dataTable.data; let i = index\" [ngClass]=\"data.status ? 'row-on' : 'row-off'\">\r\n            <td nzLeft=\"0px\">\r\n                {{data.code}}\r\n            </td>\r\n            <td nzLeft=\"0px\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.title\" [nzRenderItem]=\"keyTmpl\" nzSize=\"small\">\r\n                    <ng-template #keyTmpl let-item>\r\n                        <nz-list-item nzAlign=\"center\">\r\n                            {{item.key}}\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.title\" [nzRenderItem]=\"valueTmpl\" nzSize=\"small\">\r\n                    <ng-template #valueTmpl let-item>\r\n                        <nz-list-item *ngIf=\"item.value\">\r\n                            {{item.value}}\r\n                        </nz-list-item>\r\n                        <nz-list-item *ngIf=\"!item.value\">\r\n                            -\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td colspan=\"2\" *ngIf=\"editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"editCache[data.code].data.title\" [nzRenderItem]=\"inputTmpl\" nzSize=\"small\">\r\n                    <ng-template #inputTmpl let-item>\r\n                        <nz-list-item>\r\n                            {{item.key}}:\r\n                            <input nz-input nzSize=\"default\" class=\"inputValue\" [(ngModel)]=\"item.value\" />\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td>\r\n                <nz-upload nzAction=\"{{uploadURL}}\" nzListType=\"picture-card\" (nzChange)=\"handleChange($event, data.code, 'icon')\" [nzName]=\"data.code\" [nzCustomRequest]=\"customIconReq\" [nzBeforeUpload]=\"beforeUpload\" [nzShowUploadList]=\"false\" [nzType]=\"data.loading ? 'loading' : 'plus'\">\r\n                    <ng-container *ngIf=\"!data.icon\">\r\n                        <i class=\"upload-icon\" nz-icon [nzType]=\"loading ? 'loading' : 'plus'\"></i>\r\n                        <div class=\"ant-upload-text\">Upload</div>\r\n                    </ng-container>\r\n                    <img *ngIf=\"data.icon\" [src]=\"imgPath + data.icon\" width=\"200\" height=\"200\" />\r\n                </nz-upload>\r\n                <a *ngIf=\"data.icon\" (click)=\"editCache[data.code].visibleIcon = true\"><i nz-icon nzType=\"eye\" nzTheme=\"outline\"></i> Zoom</a>\r\n                <nz-modal [(nzVisible)]=\"editCache[data.code].visibleIcon\" [nzFooter]=\"null\" (nzOnCancel)=\"editCache[data.code].visibleIcon=false\">\r\n                    <img [src]=\"imgPath + data.icon\">\r\n                </nz-modal>\r\n            </td>\r\n            <td>\r\n                <nz-upload nzAction=\"{{uploadURL}}\" nzListType=\"picture-card\" (nzChange)=\"handleChange($event, data.code, 'image')\" [nzName]=\"data.code\" [nzCustomRequest]=\"customImageReq\" [nzBeforeUpload]=\"beforeUpload\" [nzShowUploadList]=\"false\" [nzType]=\"data.loading ? 'loading' : 'plus'\" width=\"200\" height=\"200\">\r\n                    <ng-container *ngIf=\"!data.image\">\r\n                        <i class=\"upload-icon\" nz-icon [nzType]=\"loading ? 'loading' : 'plus'\"></i>\r\n                        <div class=\"ant-upload-text\">Upload</div>\r\n                    </ng-container>\r\n                    <img *ngIf=\"data.image\" [src]=\"imgPath + data.image\" width=\"200\" height=\"200\" />\r\n                </nz-upload>\r\n                <a *ngIf=\"data.image\" (click)=\"editCache[data.code].visibleImage = true\"><i nz-icon nzType=\"eye\" nzTheme=\"outline\"></i> Zoom</a>\r\n                <nz-modal [(nzVisible)]=\"editCache[data.code].visibleImage\" [nzFooter]=\"null\" (nzOnCancel)=\"editCache[data.code].visibleImage=false\">\r\n                    <img [src]=\"imgPath + data.image\">\r\n                </nz-modal>\r\n            </td>\r\n            <td>\r\n                <nz-switch (click)=\"onClickSwitch(data.code)\" [nzControl]=\"true\" [(ngModel)]=\"data.status\"></nz-switch>\r\n            </td>\r\n            <td nzAlign=\"center\">\r\n                <a nz-popconfirm nzTitle=\"Sure to delete?\" (nzOnConfirm)=\"deleteRow(data.code)\" class=\"actionLink\">\r\n                    <i nz-icon nzType=\"delete\" nzTheme=\"outline\"></i>\r\n                </a>\r\n                <br />\r\n                <div class=\"editable-row-operations\">\r\n                    <ng-container *ngIf=\"!editCache[data.code].edit; else saveTpl\">\r\n                        <a (click)=\"startEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"edit\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-container>\r\n                    <ng-template #saveTpl>\r\n                        <a (click)=\"saveEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"save\" nzTheme=\"outline\"></i><br />\r\n                        </a>\r\n                        <a nz-popconfirm nzTitle=\"Sure to cancel?\" (nzOnConfirm)=\"cancelEdit()\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"rollback\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-template>\r\n                </div>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/faq/faq.component.html":
/*!************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/faq/faq.component.html ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<button nz-button nzType=\"primary\" (click)=\"showForm = !showForm\" [ngClass]=\"showForm ? 'showBtn' : 'hideBtn'\">\r\n    Add record\r\n</button>\r\n<nz-card class=\"addCard\" *ngIf=\"showForm\">\r\n    <h3>Add category</h3>\r\n    <form [formGroup]=\"faqGroup\" (ngSubmit)=\"addRow()\">\r\n        Code* (Max 10 characters):\r\n        <div class=\"inputRow\">\r\n            <div nz-row [nzGutter]=\"16\">\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"20\">\r\n                    <input nz-input formControlName=\"code\" />\r\n                </div>\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"4\">\r\n                    <button nz-button nzType=\"primary\" [disabled]=\"faqGroup.invalid\" class=\"addBtn\">\r\n                        Add faq\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <nz-tabset nzTabPosition=\"top\" nzShowPagination=\"true\">\r\n            <nz-tab *ngFor=\"let l of globalService.allLanguages\" nzTitle=\"{{l.value}}\">\r\n                <div formGroupName=\"question\">\r\n                    Question: <input nz-input formControlName=\"{{l.value}}\" class=\"langQuestion\" />\r\n                </div>\r\n                <div formGroupName=\"answer\">\r\n                    Answer: <quill-editor class=\"answerText\" formControlName=\"{{l.value}}\"></quill-editor>\r\n                </div>\r\n            </nz-tab>\r\n        </nz-tabset>\r\n    </form>\r\n</nz-card>\r\n\r\n\r\n<nz-table #dataTable nzBordered nzSize=\"middle\" [nzData]=\"dataResult\" [nzPageSize]=\"2\" [nzLoading]=\"loading\"\r\n    nzPaginationPosition=\"both\">\r\n    <thead>\r\n        <tr>\r\n            <th nzAlign=\"center\" nzWidth=\"120px\">Code</th>\r\n            <th nzAlign=\"center\">Question</th>\r\n            <th nzAlign=\"center\" nzWidth=\"50px\">Actions</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr *ngFor=\"let data of dataTable.data; let i = index\">\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.code}}\r\n            </td>\r\n            <td style=\"max-width: 600px;\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-tabset nzTabPosition=\"top\" nzShowPagination=\"true\">\r\n                    <nz-tab *ngFor=\"let l of data.question; let j = index\" nzTitle=\"{{l.key}}\" class=\"tabtabtab\">\r\n                        <div>\r\n                            Question: \r\n                            <br/>\r\n                            <h3>{{data.question[j].value}}</h3>\r\n                        </div>\r\n                        <div>\r\n                            Answer: <quill-editor disabled class=\"answerText\" [(ngModel)]=\"data.answer[j].value\"></quill-editor> \r\n                        </div>\r\n                    </nz-tab>\r\n                </nz-tabset>\r\n            </td>\r\n            <td style=\"max-width: 600px;\" *ngIf=\"editCache[data.code].edit\">\r\n                <nz-tabset nzTabPosition=\"top\" nzShowPagination=\"true\">\r\n                    <nz-tab *ngFor=\"let l of data.question; let j = index\" nzTitle=\"{{l.key}}\">\r\n                        <div>\r\n                            Question: <input nz-input [(ngModel)]=\"editCache[data.code].data.question[j].value\" class=\"langQuestion\" />\r\n                        </div>\r\n                        <div>\r\n                            Answer: <quill-editor class=\"answerText\" [(ngModel)]=\"editCache[data.code].data.answer[j].value\"></quill-editor> \r\n                        </div>\r\n                    </nz-tab>\r\n                </nz-tabset>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <a nz-popconfirm nzTitle=\"Sure to delete?\" (nzOnConfirm)=\"deleteRow(data.code)\" class=\"actionLink\">\r\n                    <i nz-icon nzType=\"delete\" nzTheme=\"outline\"></i>\r\n                </a>\r\n                <br />\r\n                <div class=\"editable-row-operations\">\r\n                    <ng-container *ngIf=\"!editCache[data.code].edit; else saveTpl\">\r\n                        <a (click)=\"startEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"edit\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-container>\r\n                    <ng-template #saveTpl>\r\n                        <a (click)=\"saveEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"save\" nzTheme=\"outline\"></i><br />\r\n                        </a>\r\n                        <a nz-popconfirm nzTitle=\"Sure to cancel?\" (nzOnConfirm)=\"cancelEdit()\"\r\n                            class=\"actionLink\">\r\n                            <i nz-icon nzType=\"rollback\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-template>\r\n                </div>\r\n            </td>\r\n        </tr>\r\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/filters/filters.component.html":
/*!********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/filters/filters.component.html ***!
  \********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<button nz-button nzType=\"primary\" (click)=\"showForm = !showForm\" [ngClass]=\"showForm ? 'showBtn' : 'hideBtn'\">Add record</button>\r\n<nz-card class=\"addCard\" *ngIf=\"showForm\">\r\n    <h3>Add filter</h3>\r\n    <form [formGroup]=\"filterGroup\" (ngSubmit)=\"addRow()\">\r\n        <div class=\"gutter-example\">\r\n            <div nz-row [nzGutter]=\"16\">\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Code* : <input nz-input formControlName=\"code\" />\r\n                    Qr* : <input nz-input formControlName=\"qr\" />\r\n                </div>\r\n                <div formGroupName=\"title\">\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        de* : <input nz-input formControlName=\"de\" />\r\n                        el* : <input nz-input formControlName=\"el\" />\r\n                        en* : <input nz-input formControlName=\"en\" />\r\n                        vn* : <input nz-input formControlName=\"vn\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        es* : <input nz-input formControlName=\"es\" />\r\n                        fr* : <input nz-input formControlName=\"fr\" />\r\n                        hu* : <input nz-input formControlName=\"hu\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        it* : <input nz-input formControlName=\"it\" />\r\n                        pl* : <input nz-input formControlName=\"pl\" />\r\n                        pt* : <input nz-input formControlName=\"pt\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        ro* : <input nz-input formControlName=\"ro\" />\r\n                        zh* : <input nz-input formControlName=\"zh\" />\r\n                        zs* : <input nz-input formControlName=\"zs\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        ar* : <input nz-input formControlName=\"ar\" />\r\n                        cs* : <input nz-input formControlName=\"cs\" />\r\n                        sk* : <input nz-input formControlName=\"sk\" />\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <hr color=\"#e8e8e8\">\r\n            <div formArrayName=\"param_1\">\r\n                <div *ngFor=\"let item of param1.controls; let par=index\" [formGroupName]=\"par\" nz-row [nzGutter]=\"16\">\r\n                    <div nz-col class=\"gutter-row add-filter-label\" [nzSpan]=\"24 / 6\">\r\n                        <label>Parameter 1 - Row {{par+1}}: </label>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Active: <br /> <label nz-checkbox formControlName=\"active\"></label>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Country:\r\n                        <nz-select nzPlaceHolder=\"Select a country\" formControlName=\"key\">\r\n                            <nz-option *ngFor=\"let country of listOfCountries\" nzLabel=\"{{country.text}}\"\r\n                                nzValue=\"{{country.value}}\">\r\n                            </nz-option>\r\n                        </nz-select>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Multiplier: <input nz-input formControlName=\"multiplier\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Duration: <input nz-input formControlName=\"duration\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        <br>\r\n                        <i *ngIf=\"param1.length < 5\" nz-icon nzType=\"plus-circle\" nzTheme=\"outline\"\r\n                            (click)=\"addParamToForm('param_1')\" class=\"delete-par-row\"></i>\r\n                        <br>\r\n                        <i *ngIf=\"param1.length > 1\" nz-icon nzType=\"delete\" nzTheme=\"outline\" class=\"delete-par-row\"\r\n                            (click)=\"deleteParamToForm(par, 'param_1')\"></i>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <hr color=\"#e8e8e8\">\r\n            <div formArrayName=\"param_2\">\r\n                <div *ngFor=\"let item of param2.controls; let par=index\" [formGroupName]=\"par\" nz-row [nzGutter]=\"16\">\r\n                    <div nz-col class=\"gutter-row add-filter-label\" [nzSpan]=\"24 / 6\">\r\n                        <label>Parameter 2 - Row {{par+1}}: </label>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Active: <br /> <label nz-checkbox formControlName=\"active\"></label>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Country:\r\n                        <nz-select nzPlaceHolder=\"Select a country\" formControlName=\"key\">\r\n                            <nz-option *ngFor=\"let country of listOfCountries\" nzLabel=\"{{country.text}}\"\r\n                                nzValue=\"{{country.value}}\">\r\n                            </nz-option>\r\n                        </nz-select>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Multiplier: <input nz-input formControlName=\"multiplier\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Duration: <input nz-input formControlName=\"duration\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        <br>\r\n                        <i nz-icon nzType=\"plus-circle\" nzTheme=\"outline\" (click)=\"addParamToForm('param_2')\"\r\n                            class=\"delete-par-row\"></i>\r\n                        <br>\r\n                        <i *ngIf=\"param2.length > 1\" nz-icon nzType=\"delete\" nzTheme=\"outline\" class=\"delete-par-row\"\r\n                            (click)=\"deleteParamToForm(par, 'param_2')\"></i>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <hr color=\"#e8e8e8\">\r\n            <div formArrayName=\"param_3\">\r\n                <div *ngFor=\"let item of param3.controls; let par=index\" [formGroupName]=\"par\" nz-row [nzGutter]=\"16\">\r\n                    <div nz-col class=\"gutter-row add-filter-label\" [nzSpan]=\"24 / 6\">\r\n                        <label>Parameter 3 - Row {{par+1}}: </label>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Active: <br /> <label nz-checkbox formControlName=\"active\"></label>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Country:\r\n                        <nz-select nzPlaceHolder=\"Select a country\" formControlName=\"key\">\r\n                            <nz-option *ngFor=\"let country of listOfCountries\" nzLabel=\"{{country.text}}\"\r\n                                nzValue=\"{{country.value}}\">\r\n                            </nz-option>\r\n                        </nz-select>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Multiplier: <input nz-input formControlName=\"multiplier\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Duration: <input nz-input formControlName=\"duration\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        <br>\r\n                        <i nz-icon nzType=\"plus-circle\" nzTheme=\"outline\" (click)=\"addParamToForm('param_3')\"\r\n                            class=\"delete-par-row\"></i>\r\n                        <br>\r\n                        <i *ngIf=\"param3.length > 1\" nz-icon nzType=\"delete\" nzTheme=\"outline\" class=\"delete-par-row\"\r\n                            (click)=\"deleteParamToForm(par, 'param_3')\"></i>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <hr color=\"#e8e8e8\">\r\n            <div formArrayName=\"param_4\">\r\n                <div *ngFor=\"let item of param4.controls; let par=index\" [formGroupName]=\"par\" nz-row [nzGutter]=\"16\">\r\n                    <div nz-col class=\"gutter-row add-filter-label\" [nzSpan]=\"24 / 6\">\r\n                        <label>Parameter 4 - Row {{par+1}}: </label>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Active: <br /> <label nz-checkbox formControlName=\"active\"></label>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Country:\r\n                        <nz-select nzPlaceHolder=\"Select a country\" formControlName=\"key\">\r\n                            <nz-option *ngFor=\"let country of listOfCountries\" nzLabel=\"{{country.text}}\"\r\n                                nzValue=\"{{country.value}}\">\r\n                            </nz-option>\r\n                        </nz-select>\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Multiplier: <input nz-input formControlName=\"multiplier\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        Duration: <input nz-input formControlName=\"duration\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        <br>\r\n                        <i nz-icon nzType=\"plus-circle\" nzTheme=\"outline\" (click)=\"addParamToForm('param_4')\"\r\n                            class=\"delete-par-row\"></i>\r\n                        <br>\r\n                        <i *ngIf=\"param4.length > 1\" nz-icon nzType=\"delete\" nzTheme=\"outline\" class=\"delete-par-row\"\r\n                            (click)=\"deleteParamToForm(par, 'param_4')\"></i>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <button nz-button nzType=\"primary\" class=\"addBtn\" [disabled]=\"filterGroup.invalid\" style=\"float: right;\">Add filter</button>\r\n        </div>\r\n    </form>\r\n</nz-card>\r\n\r\n\r\n<nz-table #dataTable nzBordered nzSize=\"middle\" [nzData]=\"dataResult\" [nzPageSize]=\"2\" [nzLoading]=\"loading\"\r\n    nzPaginationPosition=\"both\">\r\n    <thead>\r\n        <tr>\r\n            <th nzAlign=\"center\" rowspan=\"2\" nzWidth=\"120px\">Code <br /> <br /> Status <br/> <br/> Qr</th>\r\n            <th nzAlign=\"center\" colspan=\"2\" >Title</th>\r\n            <th nzAlign=\"center\" rowspan=\"2\" nzWidth=\"64px\">Image <br /><br /> Icon</th>\r\n            <th nzAlign=\"center\" colspan=\"2\" nzWidth=\"50px\">Parameter 1</th>\r\n            <th nzAlign=\"center\" colspan=\"2\" nzWidth=\"50px\">Parameter 2</th>\r\n            <th nzAlign=\"center\" colspan=\"2\" nzWidth=\"50px\">Parameter 3</th>\r\n            <th nzAlign=\"center\" colspan=\"2\" nzWidth=\"50px\">Parameter 4</th>\r\n            <th nzAlign=\"center\" rowspan=\"2\" nzWidth=\"50px\">Countries</th>\r\n            <th nzAlign=\"center\" rowspan=\"2\" nzWidth=\"50px\">Actions</th>\r\n        </tr>\r\n        <tr>\r\n            <th nzAlign=\"center\" nzWidth=\"50px\">ID</th>\r\n            <th nzAlign=\"center\" nzWidth=\"50px\">Name</th>\r\n            <th nzAlign=\"center\" nzWidth=\"50px\">Active <br /> Country</th>\r\n            <th nzAlign=\"center\" nzWidth=\"50px\">Multiplier <br /> Duration</th>\r\n            <th nzAlign=\"center\" nzWidth=\"50px\">Active <br /> Country</th>\r\n            <th nzAlign=\"center\">Multiplier <br /> Duration</th>\r\n            <th nzAlign=\"center\">Active <br /> Country</th>\r\n            <th nzAlign=\"center\">Multiplier <br /> Duration</th>\r\n            <th nzAlign=\"center\">Active <br /> Country</th>\r\n            <th nzAlign=\"center\">Multiplier <br /> Duration</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr *ngFor=\"let data of dataTable.data; let i = index\" [ngClass]=\"data.status ? 'row-on' : 'row-off'\">\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.code}}\r\n                <br />\r\n                <br />\r\n                <br />\r\n                <nz-switch (click)=\"onClickSwitch(data.code)\" [nzControl]=\"true\" [(ngModel)]=\"data.status\"></nz-switch>\r\n                <br />\r\n                <br />\r\n                <br />\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else qrInputTpl\">\r\n                    {{data.qr}}\r\n                </ng-container>\r\n                <ng-template #qrInputTpl>\r\n                    <textarea rows=\"3\" type=\"text\" nzSize=\"default\" nz-input\r\n                        [(ngModel)]=\"editCache[data.code].data.qr\"></textarea>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.title\" [nzRenderItem]=\"keyTmpl\" nzSize=\"small\">\r\n                    <ng-template #keyTmpl let-item>\r\n                        <nz-list-item nzAlign=\"center\">\r\n                            {{item.key}}\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td nzAlign=\"center\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.title\" [nzRenderItem]=\"valueTmpl\" nzSize=\"small\">\r\n                    <ng-template #valueTmpl let-item>\r\n                        <nz-list-item *ngIf=\"item.value\">\r\n                            {{item.value}}\r\n                        </nz-list-item>\r\n                        <nz-list-item *ngIf=\"!item.value\">\r\n                            -\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td colspan=\"2\" *ngIf=\"editCache[data.code].edit\">\r\n                <div>\r\n                    <div *ngFor=\"let entry of editCache[data.code].data.title; let j=index\">\r\n                        {{entry.key}}:\r\n                        <input nz-input nzSize=\"default\" class=\"inputValue\" [(ngModel)]=\"entry.value\" />\r\n                    </div>\r\n                </div>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\">\r\n                <nz-upload nzAction=\"{{uploadURL}}\" nzListType=\"picture-card\"\r\n                    (nzChange)=\"handleChange($event, data.code, 'image')\" [nzName]=\"data.code\"\r\n                    [nzCustomRequest]=\"customReq\" [nzBeforeUpload]=\"beforeUpload\" [nzShowUploadList]=\"false\"\r\n                    [nzType]=\"data.loading ? 'loading' : 'plus'\" width=\"64\" height=\"64\">\r\n                    <ng-container *ngIf=\"!data.image\">\r\n                        <i class=\"upload-icon\" nz-icon [nzType]=\"loading ? 'loading' : 'plus'\"></i>\r\n                        <div class=\"ant-upload-text\">Upload</div>\r\n                    </ng-container>\r\n                    <img *ngIf=\"data.image\" [src]=\"imgPath + data.image\" height=\"64\" />\r\n                </nz-upload>\r\n                <a *ngIf=\"data.image\" (click)=\"editCache[data.code].visibleImage = true\"><i nz-icon nzType=\"eye\"\r\n                        nzTheme=\"outline\"></i> Zoom</a>\r\n                <nz-modal [(nzVisible)]=\"editCache[data.code].visibleImage\" [nzFooter]=\"null\"\r\n                    (nzOnCancel)=\"editCache[data.code].visibleImage=false\" nzWidth=\"770\">\r\n                    <img [src]=\"imgPath + data.image\" width=\"700\">\r\n                </nz-modal>\r\n                <br />\r\n                <br />\r\n                <br />\r\n                <nz-upload nzAction=\"{{uploadURL}}\" nzListType=\"picture-card\"\r\n                    (nzChange)=\"handleChange($event, data.code, 'icon')\" [nzName]=\"data.code\"\r\n                    [nzCustomRequest]=\"customIconReq\" [nzBeforeUpload]=\"beforeUploadIcon\" [nzShowUploadList]=\"false\"\r\n                    [nzType]=\"data.loading ? 'loading' : 'plus'\" width=\"64\" height=\"64\">\r\n                    <ng-container *ngIf=\"!data.icon\">\r\n                        <i class=\"upload-icon\" nz-icon [nzType]=\"loading ? 'loading' : 'plus'\"></i>\r\n                        <div class=\"ant-upload-text\">Upload</div>\r\n                    </ng-container>\r\n                    <img *ngIf=\"data.icon\" [src]=\"imgPath + data.icon\" height=\"64\" />\r\n                </nz-upload>\r\n                <a *ngIf=\"data.icon\" (click)=\"editCache[data.code].visibleIcon = true\"><i nz-icon nzType=\"eye\"\r\n                        nzTheme=\"outline\"></i> Zoom</a>\r\n                <nz-modal [(nzVisible)]=\"editCache[data.code].visibleIcon\" [nzFooter]=\"null\"\r\n                    (nzOnCancel)=\"editCache[data.code].visibleIcon=false\" nzWidth=\"550\">\r\n                    <img [src]=\"imgPath + data.icon\" width=\"500\">\r\n                </nz-modal>\r\n            </td>\r\n            <!--Par1.active & par1.key-->\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.par1\" [nzRenderItem]=\"par1ActiveTmpl\" nzSize=\"small\">\r\n                    <ng-template #par1ActiveTmpl let-item>\r\n                        <nz-list-item [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"activekeyItem\">\r\n                            <label nz-checkbox [(ngModel)]=\"item.active\" nzDisabled></label>\r\n                            <span *ngIf=\"item.key\">&nbsp; {{item.key}}</span>\r\n                            <span *ngIf=\"!item.key\">&nbsp; All</span>\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td *ngIf=\"editCache[data.code].edit\">\r\n                <div>\r\n                    <div *ngFor=\"let item of editCache[data.code].data.par1;let y=index\"\r\n                        [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"active-edit\">\r\n                        <label nz-checkbox [(ngModel)]=\"item.active\"></label>\r\n                        <i *ngIf=\"editCache[data.code].data.par1.length > 1\" nz-icon nzType=\"delete\" nzTheme=\"outline\"\r\n                            class=\"delete-par-row\" (click)=\"deleteParRow(editCache[data.code].data.par1, y)\"></i>\r\n                        <br />\r\n                        <br />\r\n                        <nz-select [(ngModel)]=\"item.key\">\r\n                            <nz-option *ngFor=\"let country of listOfCountries\" nzLabel=\"{{country.text}}\"\r\n                                nzValue=\"{{country.value}}\">\r\n                            </nz-option>\r\n                        </nz-select>\r\n                        <br/>\r\n                    </div>\r\n                    <br/>\r\n                    <div class=\"plus-trigger\">\r\n                        <i *ngIf=\"editCache[data.code].data.par1.length < 5\" nz-icon nzType=\"plus-circle\"\r\n                            nzTheme=\"outline\" (click)=\"addParRow(editCache[data.code].data.par1)\" class=\"plus-icon\"></i>\r\n                    </div>\r\n                </div>\r\n            </td>\r\n            <!--Par1.multiplier & par1.duration-->\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.par1\" [nzRenderItem]=\"par1multiplierTmpl\" nzSize=\"small\">\r\n                    <ng-template #par1multiplierTmpl let-item>\r\n                        <nz-list-item nzAlign=\"center\" [ngClass]=\"item.active ? 'row-on' : 'row-off'\">\r\n                            {{item.multiplier}}\r\n                            <br />\r\n                            <br />\r\n                            {{item.duration}}\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td *ngIf=\"editCache[data.code].edit\">\r\n                <div>\r\n                    <div *ngFor=\"let item of editCache[data.code].data.par1;\"\r\n                        [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"field-edit\">\r\n                        <input nz-input nzSize=\"default\" [(ngModel)]=\"item.multiplier\" />\r\n                        <br />\r\n                        <br />\r\n                        <input nz-input nzSize=\"default\" [(ngModel)]=\"item.duration\" />\r\n                    </div>\r\n                </div>\r\n            </td>\r\n            <!--Par2.active & par2.country-->\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.par2\" [nzRenderItem]=\"par2ActiveTmpl\" nzSize=\"small\">\r\n                    <ng-template #par2ActiveTmpl let-item>\r\n                        <nz-list-item [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"activekeyItem\">\r\n                            <label nz-checkbox [(ngModel)]=\"item.active\" nzDisabled></label>\r\n                            <span *ngIf=\"item.key\">&nbsp; {{item.key}}</span>\r\n                            <span *ngIf=\"!item.key\">&nbsp; All</span>\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td *ngIf=\"editCache[data.code].edit\">\r\n                <div>\r\n                    <div *ngFor=\"let item of editCache[data.code].data.par2;let y=index\"\r\n                        [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"active-edit\">\r\n                        <label nz-checkbox [(ngModel)]=\"item.active\"></label>\r\n                        <i *ngIf=\"editCache[data.code].data.par2.length > 1\" nz-icon nzType=\"delete\" nzTheme=\"outline\"\r\n                            class=\"delete-par-row\" (click)=\"deleteParRow(editCache[data.code].data.par2, y)\"></i>\r\n                        <br />\r\n                        <br />\r\n                        <nz-select [(ngModel)]=\"item.key\">\r\n                            <nz-option *ngFor=\"let country of listOfCountries\" nzLabel=\"{{country.text}}\"\r\n                                nzValue=\"{{country.value}}\">\r\n                            </nz-option>\r\n                        </nz-select>\r\n                        <br/>\r\n                    </div>\r\n                    <br/>\r\n                    <div class=\"plus-trigger\">\r\n                        <i *ngIf=\"editCache[data.code].data.par2.length < 5\" nz-icon nzType=\"plus-circle\"\r\n                            nzTheme=\"outline\" (click)=\"addParRow(editCache[data.code].data.par2)\" class=\"plus-icon\"></i>\r\n                    </div>\r\n                </div>\r\n            </td>\r\n            <!--Par2.multiplier & par2.duration-->\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.par2\" [nzRenderItem]=\"par2multiplierTmpl\" nzSize=\"small\">\r\n                    <ng-template #par2multiplierTmpl let-item>\r\n                        <nz-list-item nzAlign=\"center\" [ngClass]=\"item.active ? 'row-on' : 'row-off'\">\r\n                            {{item.multiplier}}\r\n                            <br />\r\n                            <br />\r\n                            {{item.duration}}\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td *ngIf=\"editCache[data.code].edit\">\r\n                <div>\r\n                    <div *ngFor=\"let item of editCache[data.code].data.par2;\"\r\n                        [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"field-edit\">\r\n                        <input nz-input nzSize=\"default\" [(ngModel)]=\"item.multiplier\" />\r\n                        <br />\r\n                        <br />\r\n                        <input nz-input nzSize=\"default\" [(ngModel)]=\"item.duration\" />\r\n                    </div>\r\n                </div>\r\n            </td>\r\n            <!--Par3.active & par3.country-->\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.par3\" [nzRenderItem]=\"par3ActiveTmpl\" nzSize=\"small\">\r\n                    <ng-template #par3ActiveTmpl let-item>\r\n                        <nz-list-item [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"activekeyItem\">\r\n                            <label nz-checkbox [(ngModel)]=\"item.active\" nzDisabled></label>\r\n                            <span *ngIf=\"item.key\">&nbsp; {{item.key}}</span>\r\n                            <span *ngIf=\"!item.key\">&nbsp; All</span>\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td *ngIf=\"editCache[data.code].edit\">\r\n                <div>\r\n                    <div *ngFor=\"let item of editCache[data.code].data.par3;let y=index\"\r\n                        [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"active-edit\">\r\n                        <label nz-checkbox [(ngModel)]=\"item.active\"></label>\r\n                        <i *ngIf=\"editCache[data.code].data.par3.length > 1\" nz-icon nzType=\"delete\" nzTheme=\"outline\"\r\n                            class=\"delete-par-row\" (click)=\"deleteParRow(editCache[data.code].data.par3, y)\"></i>\r\n                        <br />\r\n                        <br />\r\n                        <nz-select [(ngModel)]=\"item.key\">\r\n                            <nz-option *ngFor=\"let country of listOfCountries\" nzLabel=\"{{country.text}}\"\r\n                                nzValue=\"{{country.value}}\">\r\n                            </nz-option>\r\n                        </nz-select>\r\n                        <br/>\r\n                    </div>\r\n                    <br/>\r\n                    <div class=\"plus-trigger\">\r\n                        <i *ngIf=\"editCache[data.code].data.par3.length < 5\" nz-icon nzType=\"plus-circle\"\r\n                            nzTheme=\"outline\" (click)=\"addParRow(editCache[data.code].data.par3)\" class=\"plus-icon\"></i>\r\n                    </div>\r\n                </div>\r\n            </td>\r\n            <!--Par3.multiplier & par3.duration-->\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.par3\" [nzRenderItem]=\"par3multiplierTmpl\" nzSize=\"small\">\r\n                    <ng-template #par3multiplierTmpl let-item>\r\n                        <nz-list-item nzAlign=\"center\" [ngClass]=\"item.active ? 'row-on' : 'row-off'\">\r\n                            {{item.multiplier}}\r\n                            <br />\r\n                            <br />\r\n                            {{item.duration}}\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td *ngIf=\"editCache[data.code].edit\">\r\n                <div>\r\n                    <div *ngFor=\"let item of editCache[data.code].data.par3;\"\r\n                        [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"field-edit\">\r\n                        <input nz-input nzSize=\"default\" [(ngModel)]=\"item.multiplier\" />\r\n                        <br />\r\n                        <br />\r\n                        <input nz-input nzSize=\"default\" [(ngModel)]=\"item.duration\" />\r\n                    </div>\r\n                </div>\r\n            </td>\r\n            <!--Par4.active & par4.country-->\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.par4\" [nzRenderItem]=\"par4ActiveTmpl\" nzSize=\"small\">\r\n                    <ng-template #par4ActiveTmpl let-item>\r\n                        <nz-list-item [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"activekeyItem\">\r\n                            <label nz-checkbox [(ngModel)]=\"item.active\" nzDisabled></label>\r\n                            <span *ngIf=\"item.key\">&nbsp; {{item.key}}</span>\r\n                            <span *ngIf=\"!item.key\">&nbsp; All</span>\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td *ngIf=\"editCache[data.code].edit\">\r\n                <div>\r\n                    <div *ngFor=\"let item of editCache[data.code].data.par4;let y=index\"\r\n                        [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"active-edit\">\r\n                        <label nz-checkbox [(ngModel)]=\"item.active\"></label>\r\n                        <i *ngIf=\"editCache[data.code].data.par4.length > 1\" nz-icon nzType=\"delete\" nzTheme=\"outline\"\r\n                            class=\"delete-par-row\" (click)=\"deleteParRow(editCache[data.code].data.par4, y)\"></i>\r\n                        <br />\r\n                        <br />\r\n                        <nz-select [(ngModel)]=\"item.key\">\r\n                            <nz-option *ngFor=\"let country of listOfCountries\" nzLabel=\"{{country.text}}\"\r\n                                nzValue=\"{{country.value}}\">\r\n                            </nz-option>\r\n                        </nz-select>\r\n                        <br/>\r\n                    </div>\r\n                    <br/>\r\n                    <div class=\"plus-trigger\">\r\n                        <i *ngIf=\"editCache[data.code].data.par4.length < 5\" nz-icon nzType=\"plus-circle\"\r\n                            nzTheme=\"outline\" (click)=\"addParRow(editCache[data.code].data.par4)\" class=\"plus-icon\"></i>\r\n                    </div>\r\n                </div>\r\n            </td>\r\n            <!--Par4.multiplier & par4.duration-->\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.par4\" [nzRenderItem]=\"par4multiplierTmpl\" nzSize=\"small\">\r\n                    <ng-template #par4multiplierTmpl let-item>\r\n                        <nz-list-item nzAlign=\"center\" [ngClass]=\"item.active ? 'row-on' : 'row-off'\">\r\n                            {{item.multiplier}}\r\n                            <br />\r\n                            <br />\r\n                            {{item.duration}}\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td *ngIf=\"editCache[data.code].edit\">\r\n                <div>\r\n                    <div *ngFor=\"let item of editCache[data.code].data.par4;\"\r\n                        [ngClass]=\"item.active ? 'row-on' : 'row-off'\" class=\"field-edit\">\r\n                        <input nz-input nzSize=\"default\" [(ngModel)]=\"item.multiplier\" />\r\n                        <br />\r\n                        <br />\r\n                        <input nz-input nzSize=\"default\" [(ngModel)]=\"item.duration\" />\r\n                    </div>\r\n                </div>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\" class=\"filterCountryColumn\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else tagCounInputTpl\">\r\n                    <div *ngIf=\"data.countries.length > 0\">\r\n                        <nz-tag *ngFor=\"let item of data.countries\">{{item.text}}</nz-tag>\r\n                    </div>\r\n                    <div *ngIf=\"data.countries.length == 0\">\r\n                        <nz-tag>ALL COUNTRIES</nz-tag>\r\n                    </div>\r\n                </ng-container>\r\n                <ng-template #tagCounInputTpl>\r\n                    <nz-select [(ngModel)]=\"editCache[data.code].data.countries\" nzMode=\"multiple\" nzNotFoundContent=\"No matching country.\" class=\"filterSelectCountry\">\r\n                        <nz-option *ngFor=\"let nat of listOfAllNations\" [nzLabel]=\"nat.text\" [nzValue]=\"nat.text\"></nz-option>\r\n                    </nz-select>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\">\r\n                <a nz-popconfirm nzTitle=\"Sure to delete?\" (nzOnConfirm)=\"deleteRow(data.code)\" class=\"actionLink\">\r\n                    <i nz-icon nzType=\"delete\" nzTheme=\"outline\"></i>\r\n                </a>\r\n                <br />\r\n                <div class=\"editable-row-operations\">\r\n                    <ng-container *ngIf=\"!editCache[data.code].edit; else saveTpl\">\r\n                        <a (click)=\"startEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"edit\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-container>\r\n                    <ng-template #saveTpl>\r\n                        <a (click)=\"saveEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"save\" nzTheme=\"outline\"></i><br />\r\n                        </a>\r\n                        <a nz-popconfirm nzTitle=\"Sure to cancel?\" (nzOnConfirm)=\"cancelEdit()\"\r\n                            class=\"actionLink\">\r\n                            <i nz-icon nzType=\"rollback\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-template>\r\n                </div>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/front/front.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/front/front.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"faq-container\">\r\n    <!-- <h1 class=\"title\">FAQ</h1> -->\r\n    <div *ngIf=\"!loading\">\r\n        <div *ngIf=\"displayedData.length > 0\">\r\n            <nz-collapse *ngFor=\"let data of displayedData; let i = index\" nzAccordion class=\"accordion\">\r\n                <nz-collapse-panel class=\"accordion-panel\" [nzHeader]=\"data.question\" [nzExpandedIcon]=\"expandedIcon\" (nzActiveChange)=changeActive(i)>\r\n                    <p class=\"internal-text\" style=\"margin:0;\" [innerHTML]=\"data.answer\">\r\n                    </p>\r\n                    <ng-template #expandedIcon>\r\n                        <i *ngIf=\"actives[i] === false\" class=\"header-icon\" nz-icon nzType=\"plus-square\" nzTheme=\"outline\"></i>\r\n                        <i *ngIf=\"actives[i] === true\" class=\"header-icon\" nz-icon nzType=\"minus-square\" nzTheme=\"outline\"></i>\r\n                    </ng-template>\r\n                </nz-collapse-panel>\r\n            </nz-collapse>\r\n        </div>\r\n        <div class=\"empty-content\" *ngIf=\"displayedData.length <= 0\">\r\n            <nz-empty class=\"empty-container\" nzNotFoundContent=\"\" nzNotFoundImage=\"../assets/empty.svg\"></nz-empty>\r\n        </div>\r\n    </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/livings-notifications/livings-notifications.component.html":
/*!************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/livings-notifications/livings-notifications.component.html ***!
  \************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-table #dataTable nzBordered nzSize=\"middle\" [nzData]=\"dataResult\" [nzPageSize]=\"30\" [nzLoading]=\"loading\"\r\n    nzPaginationPosition=\"both\">\r\n    <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\r\n        <tr>\r\n            <th nzAlign=\"center\">Email</th>\r\n            <th nzAlign=\"center\">Language code</th>\r\n            <th nzAlign=\"center\">Token</th>\r\n            <th nzAlign=\"center\">Filter code</th>\r\n            <th nzAlign=\"center\">Note</th>\r\n            <th nzAlign=\"center\">Installation Date</th>\r\n            <th nzAlign=\"center\" nzShowSort nzSortKey=\"expirationDate\">Expiration Date</th>\r\n            <th nzAlign=\"center\">Notified</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr *ngFor=\"let data of dataTable.data; let i = index\">\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.email}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.languageCode}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.token}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.code}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.note}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\"  *ngIf=\"data.installationDate > 0\">\r\n                {{data.installationDate | date: 'dd/MM/yyyy HH:mm:ss'}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\"  *ngIf=\"data.installationDate == 0\">\r\n                --/--/-- --:--:-- -\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.expirationDate | date: 'dd/MM/yyyy HH:mm:ss'}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <label nz-checkbox [ngModel]=\"data.notified\" [nzDisabled]=\"true\" class=\"checkboxLabel\"></label>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</nz-table>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login/login.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login/login.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\">\r\n    <div class=\"form-container\">\r\n        <nz-card [nzCover]=\"coverTemplate\">\r\n            <input type=\"password\" (keydown.enter)=\"onSubmit()\" (keydown)=\"keyDownFunction($event)\" nz-input\r\n                [(ngModel)]=\"password\" placeholder=\"Insert password\" />\r\n            <br />\r\n            <button nz-button (click)=\"onSubmit()\" nzType=\"primary\" id=\"loginBtn\" type=\"button\">Sign in</button>\r\n            <p *ngIf=\"showError\" id=\"errorMessage\">Wrong Password</p>\r\n        </nz-card>\r\n    </div>\r\n    <ng-template #coverTemplate>\r\n        <div>\r\n            <img src=\"../../../assets/logo-laica.png\" alt=\"logo\" id=\"logo\"><span id=\"version\">{{appVersion}}</span>\r\n        </div>\r\n    </ng-template>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/notifications/notifications.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/notifications/notifications.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-table #dataTable nzBordered nzSize=\"middle\" [nzData]=\"dataResult\" [nzPageSize]=\"30\" [nzLoading]=\"loading\"\r\n    nzPaginationPosition=\"both\">\r\n    <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\r\n        <tr>\r\n            <th nzAlign=\"center\">Email</th>\r\n            <th nzAlign=\"center\">Language code</th>\r\n            <th nzAlign=\"center\">Token</th>\r\n            <th nzAlign=\"center\">Filter code</th>\r\n            <th nzAlign=\"center\">Note</th>\r\n            <th nzAlign=\"center\">Installation Date</th>\r\n            <th nzAlign=\"center\" nzShowSort nzSortKey=\"expirationDate\">Expiration Date</th>\r\n            <th nzAlign=\"center\">Notified</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr *ngFor=\"let data of dataTable.data; let i = index\">\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.email}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.languageCode}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.token}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.code}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.note}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\"  *ngIf=\"data.installationDate > 0\">\r\n                {{data.installationDate | date: 'dd/MM/yyyy HH:mm:ss'}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\"  *ngIf=\"data.installationDate == 0\">\r\n                --/--/-- --:--:-- -\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.expirationDate | date: 'dd/MM/yyyy HH:mm:ss'}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <label nz-checkbox [ngModel]=\"data.notified\" [nzDisabled]=\"true\" class=\"checkboxLabel\"></label>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</nz-table>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/packs/packs.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/packs/packs.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<button nz-button nzType=\"primary\" (click)=\"showForm = !showForm\" [ngClass]=\"showForm ? 'showBtn' : 'hideBtn'\">Add record</button>\r\n<nz-card class=\"addCard\" *ngIf=\"showForm\">\r\n    <h3>Add living</h3>\r\n    <form [formGroup]=\"packGroup\" (ngSubmit)=\"addRow()\">\r\n        <div class=\"gutter-example\">\r\n            <div nz-row [nzGutter]=\"16\">\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Code* : <input nz-input formControlName=\"code\" />\r\n                    Qr* : <input nz-input formControlName=\"qr\" />\r\n                </div>\r\n                <div formGroupName=\"title\">\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        de* : <input nz-input formControlName=\"de\" />\r\n                        el* : <input nz-input formControlName=\"el\" />\r\n                        en* : <input nz-input formControlName=\"en\" />\r\n                        vn* : <input nz-input formControlName=\"vn\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        es* : <input nz-input formControlName=\"es\" />\r\n                        fr* : <input nz-input formControlName=\"fr\" />\r\n                        hu* : <input nz-input formControlName=\"hu\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        it* : <input nz-input formControlName=\"it\" />\r\n                        pl* : <input nz-input formControlName=\"pl\" />\r\n                        pt* : <input nz-input formControlName=\"pt\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        ro* : <input nz-input formControlName=\"ro\" />\r\n                        zh* : <input nz-input formControlName=\"zh\" />\r\n                        zs* : <input nz-input formControlName=\"zs\" />\r\n                    </div>\r\n                    <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                        ar* : <input nz-input formControlName=\"ar\" />\r\n                        cs* : <input nz-input formControlName=\"cs\" />\r\n                        sk* : <input nz-input formControlName=\"sk\" />\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <button nz-button nzType=\"primary\" class=\"addBtn\" [disabled]=\"packGroup.invalid\" style=\"float: right;\">Add living</button>\r\n        </div>\r\n    </form>\r\n</nz-card>\r\n\r\n<nz-table #dataTable nzBordered nzSize=\"middle\" [nzData]=\"dataResult\" [nzPageSize]=\"2\" [nzLoading]=\"loading\"\r\n    nzPaginationPosition=\"both\">\r\n    <thead>\r\n        <tr>\r\n            <th nzAlign=\"center\" rowspan=\"2\">Code</th>\r\n            <th nzAlign=\"center\" colspan=\"2\">Title</th>\r\n            <th nzAlign=\"center\" nzWidth=\"200px\" rowspan=\"2\">Image</th>\r\n            <th nzAlign=\"center\" nzWidth=\"200px\" rowspan=\"2\">Icon</th>\r\n            <th nzAlign=\"center\" nzWidth=\"200px\" rowspan=\"2\">Status</th>\r\n            <th nzAlign=\"center\" nzWidth=\"200px\" rowspan=\"2\">Actions</th>\r\n        </tr>\r\n        <tr>\r\n            <th nzAlign=\"center\">ID</th>\r\n            <th nzAlign=\"center\">Name</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr *ngFor=\"let data of dataTable.data; let i = index\" [ngClass]=\"data.status ? 'row-on' : 'row-off'\">\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.code}}\r\n                <br/>\r\n                <br/>\r\n                <br/>\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else qrInputTpl\">\r\n                    {{data.qr}}\r\n                </ng-container>\r\n                <ng-template #qrInputTpl>\r\n                    <textarea rows=\"3\" type=\"text\" nzSize=\"default\" nz-input\r\n                        [(ngModel)]=\"editCache[data.code].data.qr\"></textarea>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.title\" [nzRenderItem]=\"keyTmpl\" nzSize=\"small\">\r\n                    <ng-template #keyTmpl let-item>\r\n                        <nz-list-item nzAlign=\"center\">\r\n                            {{item.key}}\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td nzAlign=\"center\" *ngIf=\"!editCache[data.code].edit\">\r\n                <nz-list [nzDataSource]=\"data.title\" [nzRenderItem]=\"valueTmpl\" nzSize=\"small\">\r\n                    <ng-template #valueTmpl let-item>\r\n                        <nz-list-item *ngIf=\"item.value\">\r\n                            {{item.value}}\r\n                        </nz-list-item>\r\n                        <nz-list-item *ngIf=\"!item.value\">\r\n                            -\r\n                        </nz-list-item>\r\n                    </ng-template>\r\n                </nz-list>\r\n            </td>\r\n            <td colspan=\"2\" *ngIf=\"editCache[data.code].edit\">\r\n                <div>\r\n                    <div *ngFor=\"let entry of editCache[data.code].data.title; let j=index\">\r\n                        {{entry.key}}:\r\n                        <input nz-input nzSize=\"default\" class=\"inputValue\" [(ngModel)]=\"entry.value\" />\r\n                    </div>\r\n                </div>\r\n            </td>\r\n            <td nzAlign=\"center\">\r\n                <nz-upload nzAction=\"{{uploadURL}}\" nzListType=\"picture-card\"\r\n                    (nzChange)=\"handleChange($event, data.code, 'image')\" [nzName]=\"data.code\"\r\n                    [nzCustomRequest]=\"customReq\" [nzBeforeUpload]=\"beforeUpload\" [nzShowUploadList]=\"false\"\r\n                    [nzType]=\"data.loading ? 'loading' : 'plus'\" width=\"64\" height=\"64\">\r\n                    <ng-container *ngIf=\"!data.image\">\r\n                        <i class=\"upload-icon\" nz-icon [nzType]=\"loading ? 'loading' : 'plus'\"></i>\r\n                        <div class=\"ant-upload-text\">Upload</div>\r\n                    </ng-container>\r\n                    <img *ngIf=\"data.image\" [src]=\"imgPath + data.image\" height=\"64\" />\r\n                </nz-upload>\r\n                <a *ngIf=\"data.image\" (click)=\"editCache[data.code].visibleImage = true\"><i nz-icon nzType=\"eye\"\r\n                        nzTheme=\"outline\"></i> Zoom</a>\r\n                <nz-modal [(nzVisible)]=\"editCache[data.code].visibleImage\" [nzFooter]=\"null\"\r\n                    (nzOnCancel)=\"editCache[data.code].visibleImage=false\" nzWidth=\"770\">\r\n                    <img [src]=\"imgPath + data.image\" width=\"700\">\r\n                </nz-modal>\r\n                </td>\r\n                <td>\r\n                <nz-upload nzAction=\"{{uploadURL}}\" nzListType=\"picture-card\"\r\n                    (nzChange)=\"handleChange($event, data.code, 'icon')\" [nzName]=\"data.code\"\r\n                    [nzCustomRequest]=\"customIconReq\" [nzBeforeUpload]=\"beforeUploadIcon\" [nzShowUploadList]=\"false\"\r\n                    [nzType]=\"data.loading ? 'loading' : 'plus'\" width=\"64\" height=\"64\">\r\n                    <ng-container *ngIf=\"!data.icon\">\r\n                        <i class=\"upload-icon\" nz-icon [nzType]=\"loading ? 'loading' : 'plus'\"></i>\r\n                        <div class=\"ant-upload-text\">Upload</div>\r\n                    </ng-container>\r\n                    <img *ngIf=\"data.icon\" [src]=\"imgPath + data.icon\" height=\"64\" />\r\n                </nz-upload>\r\n                <a *ngIf=\"data.icon\" (click)=\"editCache[data.code].visibleIcon = true\"><i nz-icon nzType=\"eye\"\r\n                        nzTheme=\"outline\"></i> Zoom</a>\r\n                <nz-modal [(nzVisible)]=\"editCache[data.code].visibleIcon\" [nzFooter]=\"null\"\r\n                    (nzOnCancel)=\"editCache[data.code].visibleIcon=false\" nzWidth=\"550\">\r\n                    <img [src]=\"imgPath + data.icon\" width=\"500\">\r\n                </nz-modal>\r\n            </td>\r\n            <td nzAlign=\"center\">\r\n                <nz-switch (click)=\"onClickSwitch(data.code)\" [nzControl]=\"true\" [(ngModel)]=\"data.status\"></nz-switch>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\">\r\n                <a nz-popconfirm nzTitle=\"Sure to delete?\" (nzOnConfirm)=\"deleteRow(data.code)\" class=\"actionLink\">\r\n                    <i nz-icon nzType=\"delete\" nzTheme=\"outline\"></i>\r\n                </a>\r\n                <br />\r\n                <div class=\"editable-row-operations\">\r\n                    <ng-container *ngIf=\"!editCache[data.code].edit; else saveTpl\">\r\n                        <a (click)=\"startEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"edit\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-container>\r\n                    <ng-template #saveTpl>\r\n                        <a (click)=\"saveEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"save\" nzTheme=\"outline\"></i><br />\r\n                        </a>\r\n                        <a nz-popconfirm nzTitle=\"Sure to cancel?\" (nzOnConfirm)=\"cancelEdit()\"\r\n                            class=\"actionLink\">\r\n                            <i nz-icon nzType=\"rollback\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-template>\r\n                </div>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/products/products.component.html":
/*!**********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/products/products.component.html ***!
  \**********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<button nz-button nzType=\"primary\" (click)=\"showForm = !showForm\" [ngClass]=\"showForm ? 'showBtn' : 'hideBtn'\">Add record</button>\r\n<nz-card class=\"addCard\" *ngIf=\"showForm\">\r\n    <h3>Add product</h3>\r\n    <form [formGroup]=\"productGroup\" (ngSubmit)=\"addRow()\">\r\n        <div class=\"gutter-example\">\r\n            <div nz-row [nzGutter]=\"16\">\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Code* : <input nz-input formControlName=\"code\" />\r\n                </div>\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Title* : <input nz-input formControlName=\"title\" />\r\n                </div>\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Category* :\r\n                    <nz-select nzPlaceHolder=\"Select a category\" formControlName=\"catCode\">\r\n                        <nz-option *ngFor=\"let item of categoryValues\" nzLabel=\"{{item.text}}\" nzValue=\"{{item.value}}\">\r\n                        </nz-option>\r\n                    </nz-select>\r\n                </div>\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Protocol* :\r\n                    <nz-select nzPlaceHolder=\"Select a protocol\" formControlName=\"comType\">\r\n                        <nz-option *ngFor=\"let item of protocolValues\" nzLabel=\"{{item}}\" nzValue=\"{{item}}\">\r\n                        </nz-option>\r\n                    </nz-select>\r\n                </div>\r\n                <div nz-col class=\"gutter-row\" [nzSpan]=\"24 / 6\">\r\n                    Required :\r\n                    <nz-select nzPlaceHolder=\"Select a required field\" formControlName=\"required\">\r\n                        <nz-option nzLabel=\"--\" nzValue=\" \"></nz-option>\r\n                        <nz-option *ngFor=\"let item of requiredValues\" nzLabel=\"{{item}}\" nzValue=\"{{item}}\">\r\n                        </nz-option>\r\n                    </nz-select>\r\n                </div>\r\n                <br />\r\n                <button nz-button nzType=\"primary\" [disabled]=\"productGroup.invalid\" class=\"addBtn\">Add product</button>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</nz-card>\r\n<nz-table #dataTable nzBordered nzSize=\"middle\" [nzData]=\"dataResult\" [nzPageSize]=\"7\" [nzLoading]=\"loading\"\r\n    nzPaginationPosition=\"both\">\r\n    <thead>\r\n        <tr>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\">Code</th>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\">Title</th>\r\n            <th nzAlign=\"center\" nzWidth=\"64px\">Image</th>\r\n            <th nzAlign=\"center\" nzWidth=\"64px\">Lotto image</th>\r\n            <th nzAlign=\"center\" nzWidth=\"64px\">Icon</th>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\">Movie</th>\r\n            <th nzAlign=\"center\" nzWidth=\"200px\">Category code</th>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\">Protocol</th>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\">Manual</th>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\">Tutorial link</th>\r\n            <th nzAlign=\"center\" nzWidth=\"150px\">Required</th>\r\n            <th nzAlign=\"center\" nzWidth=\"200px\">Status</th>\r\n            <th nzAlign=\"center\" nzWidth=\"50px\">Actions</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr *ngFor=\"let data of dataTable.data; let i = index\" [ngClass]=\"data.status ? 'row-on' : 'row-off'\">\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.code}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else titleInputTpl\">\r\n                    {{data.title}}\r\n                </ng-container>\r\n                <ng-template #titleInputTpl>\r\n                    <textarea rows=\"3\" type=\"text\" nzSize=\"default\" nz-input\r\n                        [(ngModel)]=\"editCache[data.code].data.title\"></textarea>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzRight=\"0px\" nzAlign=\"center\">\r\n                <nz-upload nzAction=\"{{uploadURL}}\" nzListType=\"picture-card\"\r\n                    (nzChange)=\"handleChange($event, data.code, 'image')\" [nzName]=\"data.code\"\r\n                    [nzCustomRequest]=\"customReq\" [nzBeforeUpload]=\"beforeUpload\" [nzShowUploadList]=\"false\"\r\n                    [nzType]=\"data.loading ? 'loading' : 'plus'\" width=\"64\" height=\"64\">\r\n                    <ng-container *ngIf=\"!data.image\">\r\n                        <i class=\"upload-icon\" nz-icon [nzType]=\"loading ? 'loading' : 'plus'\"></i>\r\n                        <div class=\"ant-upload-text\">Upload</div>\r\n                    </ng-container>\r\n                    <img *ngIf=\"data.image\" [src]=\"imgPath + data.image\" height=\"64\" />\r\n                </nz-upload>\r\n                <a *ngIf=\"data.image\" (click)=\"editCache[data.code].visibleImage = true\"><i nz-icon nzType=\"eye\"\r\n                        nzTheme=\"outline\"></i> Zoom</a>\r\n                <nz-modal [(nzVisible)]=\"editCache[data.code].visibleImage\" [nzFooter]=\"null\"\r\n                    (nzOnCancel)=\"editCache[data.code].visibleImage=false\" nzWidth=\"770\">\r\n                    <img [src]=\"imgPath + data.image\" width=\"700\">\r\n                </nz-modal>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <nz-upload nzAction=\"{{uploadURL}}\" nzListType=\"picture-card\"\r\n                    (nzChange)=\"handleChange($event, data.code, 'image_lotto')\" [nzName]=\"data.code\"\r\n                    [nzCustomRequest]=\"customLottoReq\" [nzBeforeUpload]=\"beforeUpload\" [nzShowUploadList]=\"false\"\r\n                    [nzType]=\"data.loading ? 'loading' : 'plus'\">\r\n                    <ng-container *ngIf=\"!data.imageLotto\">\r\n                        <i class=\"upload-icon\" nz-icon [nzType]=\"loading ? 'loading' : 'plus'\"></i>\r\n                        <div class=\"ant-upload-text\">Upload</div>\r\n                    </ng-container>\r\n                    <img *ngIf=\"data.imageLotto\" [src]=\"imgPath + data.imageLotto\" height=\"64\" />\r\n                </nz-upload>\r\n                <a *ngIf=\"data.imageLotto\" (click)=\"editCache[data.code].visibleLotto = true\"><i nz-icon nzType=\"eye\"\r\n                        nzTheme=\"outline\"></i> Zoom</a>\r\n                <nz-modal [(nzVisible)]=\"editCache[data.code].visibleLotto\" [nzFooter]=\"null\"\r\n                    (nzOnCancel)=\"editCache[data.code].visibleLotto=false\" nzWidth=\"770\">\r\n                    <img [src]=\"imgPath + data.imageLotto\" width=\"700\">\r\n                </nz-modal>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <nz-upload nzAction=\"{{uploadURL}}\" nzListType=\"picture-card\"\r\n                    (nzChange)=\"handleChange($event, data.code, 'icon')\" [nzName]=\"data.code\"\r\n                    [nzCustomRequest]=\"customIconReq\" [nzBeforeUpload]=\"beforeUploadIcon\" [nzShowUploadList]=\"false\"\r\n                    [nzType]=\"data.loading ? 'loading' : 'plus'\">\r\n                    <ng-container *ngIf=\"!data.icon\">\r\n                        <i class=\"upload-icon\" nz-icon [nzType]=\"loading ? 'loading' : 'plus'\"></i>\r\n                        <div class=\"ant-upload-text\">Upload</div>\r\n                    </ng-container>\r\n                    <img *ngIf=\"data.icon\" [src]=\"imgPath + data.icon\" height=\"64\" />\r\n                </nz-upload>\r\n                <a *ngIf=\"data.icon\" (click)=\"editCache[data.code].visibleIcon = true\"><i nz-icon nzType=\"eye\"\r\n                        nzTheme=\"outline\"></i> Zoom</a>\r\n                <nz-modal [(nzVisible)]=\"editCache[data.code].visibleIcon\" [nzFooter]=\"null\"\r\n                    (nzOnCancel)=\"editCache[data.code].visibleIcon=false\" nzWidth=\"550\">\r\n                    <img [src]=\"imgPath + data.icon\" width=\"500\">\r\n                </nz-modal>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <nz-upload nzAction=\"{{uploadPdfURL}}\" nzListType=\"text\" (nzChange)=\"handleMp4Change($event, data.code)\"\r\n                    [nzName]=\"data.code\" [nzCustomRequest]=\"customReq\" [nzBeforeUpload]=\"beforeUploadMp4\"\r\n                    [nzShowUploadList]=\"false\" [nzType]=\"data.loading ? 'loading' : 'plus'\">\r\n                    <button nz-button><i nz-icon nzType=\"upload\"></i><span>Upload</span></button>\r\n                </nz-upload>\r\n                <a *ngIf=\"data.movie\" target=\"_blank\" href=\"{{imgPath + data.movie}}\">{{data.movie}}</a>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else catCodeSelectTpl\">\r\n                    {{data.catCode}}\r\n                </ng-container>\r\n                <ng-template #catCodeSelectTpl>\r\n                    <nz-select class=\"editSelectCategory\" nzPlaceHolder=\"Select a category\"\r\n                        [(ngModel)]=\"editCache[data.code].data.catCode\">\r\n                        <nz-option *ngFor=\"let item of categoryValues\" nzLabel=\"{{item.text}}\" nzValue=\"{{item.value}}\">\r\n                        </nz-option>\r\n                    </nz-select>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else comTypeSelectTpl\">\r\n                    {{data.comType}}\r\n                </ng-container>\r\n                <ng-template #comTypeSelectTpl>\r\n                    <nz-select class=\"editSelectProtocol\" nzPlaceHolder=\"Select a category\"\r\n                        [(ngModel)]=\"editCache[data.code].data.comType\">\r\n                        <nz-option *ngFor=\"let item of protocolValues\" nzLabel=\"{{item}}\" nzValue=\"{{item}}\">\r\n                        </nz-option>\r\n                    </nz-select>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <nz-upload nzAction=\"{{uploadPdfURL}}\" nzListType=\"text\" (nzChange)=\"handlePdfChange($event, data.code)\"\r\n                    [nzName]=\"data.code\" [nzCustomRequest]=\"customReq\" [nzBeforeUpload]=\"beforeUploadPdf\"\r\n                    [nzShowUploadList]=\"false\" [nzType]=\"data.loading ? 'loading' : 'plus'\">\r\n                    <button nz-button><i nz-icon nzType=\"upload\"></i><span>Upload</span></button>\r\n                </nz-upload>\r\n                <a *ngIf=\"data.linkDoc\" target=\"_blank\" href=\"{{pdfPath + data.linkDoc}}\">{{data.linkDoc}}</a>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else tutorialInputTpl\">\r\n                    <a *ngIf=\"data.linkTutorial && data.linkTutorial!='null'\" target=\"_blank\" href=\"{{data.linkTutorial}}\">Link</a>\r\n                </ng-container>\r\n                <ng-template #tutorialInputTpl>\r\n                    <textarea rows=\"7\" type=\"text\" nzSize=\"default\" nz-input\r\n                        [(ngModel)]=\"editCache[data.code].data.linkTutorial\"></textarea>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <ng-container *ngIf=\"!editCache[data.code].edit; else requiredSelectTpl\">\r\n                    {{data.required}}\r\n                </ng-container>\r\n                <ng-template #requiredSelectTpl>\r\n                    <nz-select class=\"editSelectRequired\" nzPlaceHolder=\"Select a required\"\r\n                        [(ngModel)]=\"editCache[data.code].data.required\">\r\n                        <nz-option nzLabel=\"--\" nzValue=\" \"></nz-option>\r\n                        <nz-option *ngFor=\"let item of requiredValues\" nzLabel=\"{{item}}\" nzValue=\"{{item}}\">\r\n                        </nz-option>\r\n                    </nz-select>\r\n                </ng-template>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <nz-switch (click)=\"onClickSwitch(data.code)\" [nzControl]=\"true\" [(ngModel)]=\"data.status\"></nz-switch>\r\n            </td>\r\n            <td nzAlign=\"center\">\r\n                <a nz-popconfirm nzTitle=\"Sure to delete?\" (nzOnConfirm)=\"deleteRow(data.code)\" class=\"actionLink\">\r\n                    <i nz-icon nzType=\"delete\" nzTheme=\"outline\"></i>\r\n                </a>\r\n                <br />\r\n                <div class=\"editable-row-operations\">\r\n                    <ng-container *ngIf=\"!editCache[data.code].edit; else saveTpl\">\r\n                        <a (click)=\"startEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"edit\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-container>\r\n                    <ng-template #saveTpl>\r\n                        <a (click)=\"saveEdit(data.code)\" class=\"actionLink\">\r\n                            <i nz-icon nzType=\"save\" nzTheme=\"outline\"></i><br />\r\n                        </a>\r\n                        <a nz-popconfirm nzTitle=\"Sure to cancel?\" (nzOnConfirm)=\"cancelEdit(data.code)\"\r\n                            class=\"actionLink\">\r\n                            <i nz-icon nzType=\"rollback\" nzTheme=\"outline\"></i>\r\n                        </a>\r\n                    </ng-template>\r\n                </div>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</nz-table>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/users/users.component.html":
/*!****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/users/users.component.html ***!
  \****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nz-card class=\"totalUsers\" *ngIf=\"dataResult\">\r\n    <h2>TOTAL USERS: {{dataResult.length}}</h2>\r\n    <button nz-button nzType=\"primary\" (click)=\"downloadFile()\">Download</button>\r\n</nz-card>\r\n<nz-table #dataTable nzBordered nzSize=\"middle\" [nzData]=\"displayedData\" [nzPageSize]=\"30\" [nzLoading]=\"loading\" nzPaginationPosition=\"both\" [nzSimple]=\"true\">\r\n    <thead (nzSortChange)=\"sort($event)\" nzSingleSort>\r\n        <tr>\r\n            <th nzAlign=\"center\" nzShowSort nzSortKey=\"email\" nzCustomFilter>Email\r\n                <i nz-th-extra class=\"ant-table-filter-icon\" nz-icon nz-dropdown #dropdown=\"nzDropdown\" nzType=\"search\" [nzDropdownMenu]=\"menu\" [class.ant-table-filter-open]=\"dropdown.nzVisible\" nzTrigger=\"click\" nzPlacement=\"bottomRight\" [nzClickHide]=\"false\" nzTableFilter></i>\r\n            </th>\r\n            <th nzAlign=\"center\" nzShowSort nzSortKey=\"nation\">Nation</th>\r\n            <th nzAlign=\"center\" nzShowSort nzSortKey=\"languageCode\">Language code</th>\r\n            <th nzAlign=\"center\">UnitH</th>\r\n            <th nzAlign=\"center\">UnitW</th>\r\n            <th nzAlign=\"center\">Date Format</th>\r\n            <th nzAlign=\"center\">Verified</th>\r\n            <th nzAlign=\"center\">Privacy</th>\r\n            <th nzAlign=\"center\">Marketing</th>\r\n            <th nzAlign=\"center\">Devices</th>\r\n            <th nzAlign=\"center\" nzShowSort nzSortKey=\"lastLogin\">Last login</th>\r\n            <th nzAlign=\"center\">Temp token</th>\r\n            <th nzAlign=\"center\">Superuser</th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr *ngFor=\"let data of dataTable.data; let i = index\">\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.email}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.nation}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.languageCode}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.unitH}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.unitW}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.dateFormat}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <label nz-checkbox [ngModel]=\"data.verified\" (ngModelChange)=\"onVerified(data.email)\" class=\"checkboxLabel\"></label>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <label nz-checkbox [ngModel]=\"data.privacy\" [nzDisabled]=\"true\" class=\"checkboxLabel\"></label>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <label nz-checkbox [ngModel]=\"data.marketing\" [nzDisabled]=\"true\" class=\"checkboxLabel\"></label>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <nz-tag *ngFor=\"let item of data.devices\">{{item}}</nz-tag>\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.lastLogin * 1000 | date: 'dd/MM/yyyy HH:mm:ss'}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                {{data.tokenTemp}}\r\n            </td>\r\n            <td nzLeft=\"0px\" nzAlign=\"center\">\r\n                <nz-switch (click)=\"onClickSwitch(data.email)\" [nzControl]=\"true\" [(ngModel)]=\"data.su\"></nz-switch>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</nz-table>\r\n<nz-dropdown-menu #menu=\"nzDropdownMenu\">\r\n    <div class=\"search-box\">\r\n        <input type=\"text\" nz-input placeholder=\"Search email\" [(ngModel)]=\"searchEmail\" />\r\n        <button nz-button nzSize=\"small\" nzType=\"primary\" (click)=\"find()\" class=\"search-button\">\r\n            Search\r\n        </button>\r\n        <button nz-button nzSize=\"small\" (click)=\"reset()\">Reset</button>\r\n    </div>\r\n</nz-dropdown-menu>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _pages_admin_admin_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./pages/admin/admin-routing.module */ "./src/app/pages/admin/admin-routing.module.ts");
/* harmony import */ var _pages_login_login_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./pages/login/login.component */ "./src/app/pages/login/login.component.ts");





const routes = [
    { path: '**', pathMatch: 'full', redirectTo: '/login' },
    { path: 'login', component: _pages_login_login_component__WEBPACK_IMPORTED_MODULE_4__["LoginComponent"] }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes), _pages_admin_admin_routing_module__WEBPACK_IMPORTED_MODULE_3__["AdminRoutingModule"]],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".content {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvYXBwLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxXQUFXO0VBQ1gsWUFBWTtBQUNkIiwiZmlsZSI6InNyYy9hcHAvYXBwLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY29udGVudCB7XHJcbiAgd2lkdGg6IDEwMCU7XHJcbiAgaGVpZ2h0OiAxMDAlO1xyXG59XHJcbiJdfQ== */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() {
        this.isCollapsed = false;
    }
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _icons_provider_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./icons-provider.module */ "./src/app/icons-provider.module.ts");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_common_locales_it__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/common/locales/it */ "./node_modules/@angular/common/locales/it.js");
/* harmony import */ var _angular_common_locales_it__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_angular_common_locales_it__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _pages_login_login_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./pages/login/login.component */ "./src/app/pages/login/login.component.ts");
/* harmony import */ var _pages_admin_admin_module__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./pages/admin/admin.module */ "./src/app/pages/admin/admin.module.ts");
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./services/auth.service */ "./src/app/services/auth.service.ts");
/* harmony import */ var _guards_auth_guard__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./guards/auth.guard */ "./src/app/guards/auth.guard.ts");
/* harmony import */ var _angular_service_worker__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/service-worker */ "./node_modules/@angular/service-worker/fesm2015/service-worker.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _pages_front_front_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./pages/front/front.component */ "./src/app/pages/front/front.component.ts");



















Object(_angular_common__WEBPACK_IMPORTED_MODULE_10__["registerLocaleData"])(_angular_common_locales_it__WEBPACK_IMPORTED_MODULE_11___default.a);
let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"],
            _pages_login_login_component__WEBPACK_IMPORTED_MODULE_12__["LoginComponent"],
            _pages_front_front_component__WEBPACK_IMPORTED_MODULE_18__["FrontComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_3__["AppRoutingModule"],
            _icons_provider_module__WEBPACK_IMPORTED_MODULE_5__["IconsProviderModule"],
            ng_zorro_antd__WEBPACK_IMPORTED_MODULE_6__["NgZorroAntdModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_8__["HttpClientModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_9__["BrowserAnimationsModule"],
            _pages_admin_admin_module__WEBPACK_IMPORTED_MODULE_13__["AdminModule"],
            _angular_service_worker__WEBPACK_IMPORTED_MODULE_16__["ServiceWorkerModule"].register('ngsw-worker.js', { enabled: _environments_environment__WEBPACK_IMPORTED_MODULE_17__["environment"].production }),
        ],
        providers: [_services_auth_service__WEBPACK_IMPORTED_MODULE_14__["AuthService"], _guards_auth_guard__WEBPACK_IMPORTED_MODULE_15__["AuthGuard"], { provide: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_6__["NZ_I18N"], useValue: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_6__["en_GB"] }],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]],
        exports: [ng_zorro_antd__WEBPACK_IMPORTED_MODULE_6__["NgZorroAntdModule"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/guards/auth.guard.ts":
/*!**************************************!*\
  !*** ./src/app/guards/auth.guard.ts ***!
  \**************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../services/auth.service */ "./src/app/services/auth.service.ts");




let AuthGuard = class AuthGuard {
    constructor(auth, router) {
        this.auth = auth;
        this.router = router;
    }
    canActivate(next, state) {
        if (this.auth.isLoggedIn()) {
            return true;
        }
        else {
            this.router.navigateByUrl('/login');
            return false;
        }
    }
    canActivateChild(next, state) {
        if (this.auth.isLoggedIn()) {
            return true;
        }
        else {
            this.router.navigateByUrl('/login');
            return false;
        }
    }
};
AuthGuard.ctorParameters = () => [
    { type: _services_auth_service__WEBPACK_IMPORTED_MODULE_3__["AuthService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], AuthGuard);



/***/ }),

/***/ "./src/app/icons-provider.module.ts":
/*!******************************************!*\
  !*** ./src/app/icons-provider.module.ts ***!
  \******************************************/
/*! exports provided: IconsProviderModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IconsProviderModule", function() { return IconsProviderModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _ant_design_icons_angular_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ant-design/icons-angular/icons */ "./node_modules/@ant-design/icons-angular/fesm2015/ant-design-icons-angular-icons.js");




const icons = [_ant_design_icons_angular_icons__WEBPACK_IMPORTED_MODULE_3__["MenuFoldOutline"], _ant_design_icons_angular_icons__WEBPACK_IMPORTED_MODULE_3__["MenuUnfoldOutline"], _ant_design_icons_angular_icons__WEBPACK_IMPORTED_MODULE_3__["DashboardOutline"], _ant_design_icons_angular_icons__WEBPACK_IMPORTED_MODULE_3__["FormOutline"]];
let IconsProviderModule = class IconsProviderModule {
};
IconsProviderModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        providers: [
            { provide: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__["NZ_ICONS"], useValue: icons }
        ]
    })
], IconsProviderModule);



/***/ }),

/***/ "./src/app/interfaces/countries.ts":
/*!*****************************************!*\
  !*** ./src/app/interfaces/countries.ts ***!
  \*****************************************/
/*! exports provided: globalNations */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globalNations", function() { return globalNations; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const globalNations = [
    { value: '0', group: 'Africa', text: 'Algeria', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '1', group: 'Africa', text: 'Angola', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '2', group: 'Africa', text: 'Benin', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '3', group: 'Africa', text: 'Botswana', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '4', group: 'Africa', text: 'Burkina', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '5', group: 'Africa', text: 'Burundi', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '6', group: 'Africa', text: 'Cameroon', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '7', group: 'Africa', text: 'Cape Verde', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '8', group: 'Africa', text: 'Central African Republic', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '9', group: 'Africa', text: 'Chad', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '10', group: 'Africa', text: 'Comoros', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '11', group: 'Africa', text: 'Congo, Democratic Republic of', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '12', group: 'Africa', text: 'Djibouti', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '13', group: 'Africa', text: 'Egypt', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '14', group: 'Africa', text: 'Equatorial Guinea', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '15', group: 'Africa', text: 'Eritrea', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '16', group: 'Africa', text: 'Ethiopia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '17', group: 'Africa', text: 'Gabon', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '18', group: 'Africa', text: 'Gambia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '19', group: 'Africa', text: 'Ghana', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '20', group: 'Africa', text: 'Guinea', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '21', group: 'Africa', text: 'Guinea-Bissau', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '22', group: 'Africa', text: 'Ivory Coast', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '23', group: 'Africa', text: 'Kenya', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '24', group: 'Africa', text: 'Lesotho', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '25', group: 'Africa', text: 'Liberia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '26', group: 'Africa', text: 'Libya', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '27', group: 'Africa', text: 'Madagascar', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '28', group: 'Africa', text: 'Malawi', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '29', group: 'Africa', text: 'Mali', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '30', group: 'Africa', text: 'Mauritania', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '31', group: 'Africa', text: 'Mauritius', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '32', group: 'Africa', text: 'Morocco', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '33', group: 'Africa', text: 'Mozambique', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '34', group: 'Africa', text: 'Namibia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '35', group: 'Africa', text: 'Niger', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '36', group: 'Africa', text: 'Nigeria', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '37', group: 'Africa', text: 'Rwanda', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '38', group: 'Africa', text: 'Sao Tome and Principe', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '39', group: 'Africa', text: 'Senegal', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '40', group: 'Africa', text: 'Seychelles', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '41', group: 'Africa', text: 'Sierra Leone', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '42', group: 'Africa', text: 'Somalia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '43', group: 'Africa', text: 'South Africa', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '44', group: 'Africa', text: 'South Sudan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '45', group: 'Africa', text: 'Sudan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '46', group: 'Africa', text: 'Swaziland', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '47', group: 'Africa', text: 'Tanzania', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '48', group: 'Africa', text: 'Togo', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '49', group: 'Africa', text: 'Tunisia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '50', group: 'Africa', text: 'Uganda', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '51', group: 'Africa', text: 'Zambia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '52', group: 'Africa', text: 'Zimbabwe', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - HH:mm:ss' },
    { value: '53', group: 'America', text: 'Antigua and Barbuda', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '54', group: 'America', text: 'Argentina', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '55', group: 'America', text: 'Bahamas', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '56', group: 'America', text: 'Barbados', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '57', group: 'America', text: 'Belize', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '58', group: 'America', text: 'Bolivia', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '59', group: 'America', text: 'Brazil', code: 'pt', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '60', group: 'America', text: 'Canada', code: 'fr', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '61', group: 'America', text: 'Chile', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '62', group: 'America', text: 'Colombia', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '63', group: 'America', text: 'Costa Rica', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '64', group: 'America', text: 'Cuba', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '65', group: 'America', text: 'Dominica', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '66', group: 'America', text: 'Dominican Republic', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '67', group: 'America', text: 'Ecuador', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '68', group: 'America', text: 'El Salvador', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '69', group: 'America', text: 'Grenada', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '70', group: 'America', text: 'Guatemala', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '71', group: 'America', text: 'Guyana', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '72', group: 'America', text: 'Haiti', code: 'fr', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '73', group: 'America', text: 'Honduras', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '74', group: 'America', text: 'Jamaica', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '75', group: 'America', text: 'Mexico', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '76', group: 'America', text: 'Nicaragua', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '77', group: 'America', text: 'Panama', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '78', group: 'America', text: 'Paraguay', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '79', group: 'America', text: 'Peru', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '80', group: 'America', text: 'Saint Kitts and Nevis', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '81', group: 'America', text: 'Saint Lucia', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '82', group: 'America', text: 'Saint Vincent and the Grenadines', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '83', group: 'America', text: 'Suriname', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '84', group: 'America', text: 'Trinidad and Tobago', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '85', group: 'America', text: 'United States', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '86', group: 'America', text: 'Uruguay', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '87', group: 'America', text: 'Venezuela', code: 'es', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '88', group: 'Asia', text: 'Afghanistan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '89', group: 'Asia', text: 'Bahrain', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '90', group: 'Asia', text: 'Bangladesh', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '91', group: 'Asia', text: 'Bhutan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '92', group: 'Asia', text: 'Brunei', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '93', group: 'Asia', text: 'Burma (Myanmar)', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '94', group: 'Asia', text: 'Cambodia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '95', group: 'Asia', text: 'China', code: 'zh', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '96', group: 'Asia', text: 'East Timor', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '97', group: 'Asia', text: 'India', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '98', group: 'Asia', text: 'Indonesia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '99', group: 'Asia', text: 'Iran', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '100', group: 'Asia', text: 'Iraq', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '101', group: 'Asia', text: 'Israel', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '102', group: 'Asia', text: 'Japan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '103', group: 'Asia', text: 'Jordan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '104', group: 'Asia', text: 'Kazakhstan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '105', group: 'Asia', text: 'Korea, North', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '106', group: 'Asia', text: 'Korea, South', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '107', group: 'Asia', text: 'Kuwait', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '108', group: 'Asia', text: 'Kyrgyzstan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '109', group: 'Asia', text: 'Laos', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '110', group: 'Asia', text: 'Lebanon', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '111', group: 'Asia', text: 'Malaysia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '112', group: 'Asia', text: 'Maldives', code: 'fr', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '113', group: 'Asia', text: 'Mongolia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '114', group: 'Asia', text: 'Nepal', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '115', group: 'Asia', text: 'Oman', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '116', group: 'Asia', text: 'Pakistan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '117', group: 'Asia', text: 'Philippines', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '118', group: 'Asia', text: 'Qatar', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '119', group: 'Asia', text: 'Russian Federation', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '120', group: 'Asia', text: 'Saudi Arabia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '121', group: 'Asia', text: 'Singapore', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '122', group: 'Asia', text: 'Sri Lanka', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '123', group: 'Asia', text: 'Syria', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '124', group: 'Asia', text: 'Tajikistan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '125', group: 'Asia', text: 'Thailand', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '126', group: 'Asia', text: 'Turkey', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '127', group: 'Asia', text: 'Turkmenistan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '128', group: 'Asia', text: 'United Arab Emirates', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '129', group: 'Asia', text: 'Uzbekistan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '130', group: 'Asia', text: 'Vietnam', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '131', group: 'Asia', text: 'Yemen', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '132', group: 'Europe', text: 'Albania', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '133', group: 'Europe', text: 'Andorra', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '134', group: 'Europe', text: 'Armenia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '135', group: 'Europe', text: 'Austria', code: 'de', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '136', group: 'Europe', text: 'Azerbaijan', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '137', group: 'Europe', text: 'Belarus', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '138', group: 'Europe', text: 'Belgium', code: 'fr', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '139', group: 'Europe', text: 'Bosnia and Herzegovina', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '140', group: 'Europe', text: 'Bulgaria', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '141', group: 'Europe', text: 'Croatia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '142', group: 'Europe', text: 'Cyprus', code: 'el', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '143', group: 'Europe', text: 'Czech Republic', code: 'cs', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '144', group: 'Europe', text: 'Denmark', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '145', group: 'Europe', text: 'Estonia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '146', group: 'Europe', text: 'Finland', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '147', group: 'Europe', text: 'France', code: 'fr', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '148', group: 'Europe', text: 'Georgia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '149', group: 'Europe', text: 'Germany', code: 'de', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '150', group: 'Europe', text: 'Greece', code: 'el', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '151', group: 'Europe', text: 'Hungary', code: 'hu', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '152', group: 'Europe', text: 'Iceland', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '153', group: 'Europe', text: 'Ireland', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '154', group: 'Europe', text: 'Italy', code: 'it', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '155', group: 'Europe', text: 'Latvia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '156', group: 'Europe', text: 'Liechtenstein', code: 'de', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '157', group: 'Europe', text: 'Lithuania', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '158', group: 'Europe', text: 'Luxembourg', code: 'fr', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '159', group: 'Europe', text: 'Macedonia', code: 'el', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '160', group: 'Europe', text: 'Malta', code: 'el', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '161', group: 'Europe', text: 'Moldova', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '162', group: 'Europe', text: 'Monaco', code: 'fr', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '163', group: 'Europe', text: 'Montenegro', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '164', group: 'Europe', text: 'Netherlands', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '165', group: 'Europe', text: 'Norway', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '166', group: 'Europe', text: 'Poland', code: 'pl', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '167', group: 'Europe', text: 'Portugal', code: 'pt', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '168', group: 'Europe', text: 'Romania', code: 'ro', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '169', group: 'Europe', text: 'San Marino', code: 'it', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '170', group: 'Europe', text: 'Serbia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '171', group: 'Europe', text: 'Slovakia', code: 'sk', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '172', group: 'Europe', text: 'Slovenia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '173', group: 'Europe', text: 'Spain', code: 'es', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '174', group: 'Europe', text: 'Sweden', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '175', group: 'Europe', text: 'Switzerland', code: 'de', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '176', group: 'Europe', text: 'Ukraine', code: 'en', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '177', group: 'Europe', text: 'United Kingdom', code: 'en', unitH: 'in', unitW: 'lb', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '178', group: 'Europe', text: 'Vatican City', code: 'it', unitH: 'cm', unitW: 'kg', date: 'dd/MM/yyyy - HH:mm:ss' },
    { value: '179', group: 'Oceania', text: 'Australia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '180', group: 'Oceania', text: 'Fiji', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '181', group: 'Oceania', text: 'Kiribati', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '182', group: 'Oceania', text: 'Marshall Islands', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '183', group: 'Oceania', text: 'Micronesia', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '184', group: 'Oceania', text: 'Nauru', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '185', group: 'Oceania', text: 'New Zealand', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '186', group: 'Oceania', text: 'Palau', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '187', group: 'Oceania', text: 'Papua New Guinea', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '188', group: 'Oceania', text: 'Samoa', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '189', group: 'Oceania', text: 'Solomon Islands', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '190', group: 'Oceania', text: 'Tonga', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '191', group: 'Oceania', text: 'Tuvalu', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
    { value: '192', group: 'Oceania', text: 'Vanuatu', code: 'en', unitH: 'cm', unitW: 'kg', date: 'MM/dd/yyyy - hh:mm:ss' },
];


/***/ }),

/***/ "./src/app/pages/admin/admin-routing.module.ts":
/*!*****************************************************!*\
  !*** ./src/app/pages/admin/admin-routing.module.ts ***!
  \*****************************************************/
/*! exports provided: AdminRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdminRoutingModule", function() { return AdminRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _admin_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./admin.component */ "./src/app/pages/admin/admin.component.ts");
/* harmony import */ var _categories_categories_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../categories/categories.component */ "./src/app/pages/categories/categories.component.ts");
/* harmony import */ var _products_products_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../products/products.component */ "./src/app/pages/products/products.component.ts");
/* harmony import */ var src_app_guards_auth_guard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/guards/auth.guard */ "./src/app/guards/auth.guard.ts");
/* harmony import */ var _users_users_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../users/users.component */ "./src/app/pages/users/users.component.ts");
/* harmony import */ var _adv_adv_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../adv/adv.component */ "./src/app/pages/adv/adv.component.ts");
/* harmony import */ var _filters_filters_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../filters/filters.component */ "./src/app/pages/filters/filters.component.ts");
/* harmony import */ var _notifications_notifications_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../notifications/notifications.component */ "./src/app/pages/notifications/notifications.component.ts");
/* harmony import */ var _faq_faq_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../faq/faq.component */ "./src/app/pages/faq/faq.component.ts");
/* harmony import */ var _front_front_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../front/front.component */ "./src/app/pages/front/front.component.ts");
/* harmony import */ var _packs_packs_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../packs/packs.component */ "./src/app/pages/packs/packs.component.ts");
/* harmony import */ var _livings_notifications_livings_notifications_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../livings-notifications/livings-notifications.component */ "./src/app/pages/livings-notifications/livings-notifications.component.ts");















const routes = [
    { path: 'admin', component: _admin_component__WEBPACK_IMPORTED_MODULE_3__["AdminComponent"], canActivate: [src_app_guards_auth_guard__WEBPACK_IMPORTED_MODULE_6__["AuthGuard"]], canActivateChild: [src_app_guards_auth_guard__WEBPACK_IMPORTED_MODULE_6__["AuthGuard"]],
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'categories' },
            { path: 'categories', component: _categories_categories_component__WEBPACK_IMPORTED_MODULE_4__["CategoriesComponent"] },
            { path: 'products', component: _products_products_component__WEBPACK_IMPORTED_MODULE_5__["ProductsComponent"] },
            { path: 'users', component: _users_users_component__WEBPACK_IMPORTED_MODULE_7__["UsersComponent"] },
            { path: 'adv', component: _adv_adv_component__WEBPACK_IMPORTED_MODULE_8__["AdvComponent"] },
            { path: 'filters', component: _filters_filters_component__WEBPACK_IMPORTED_MODULE_9__["FiltersComponent"] },
            { path: 'filters-notifications', component: _notifications_notifications_component__WEBPACK_IMPORTED_MODULE_10__["NotificationsComponent"] },
            { path: 'faq', component: _faq_faq_component__WEBPACK_IMPORTED_MODULE_11__["FaqComponent"] },
            { path: 'livings', component: _packs_packs_component__WEBPACK_IMPORTED_MODULE_13__["PacksComponent"] },
            { path: 'livings-notifications', component: _livings_notifications_livings_notifications_component__WEBPACK_IMPORTED_MODULE_14__["LivingsNotificationsComponent"] },
        ]
    },
    { path: 'front/faq', component: _front_front_component__WEBPACK_IMPORTED_MODULE_12__["FrontComponent"] }
];
let AdminRoutingModule = class AdminRoutingModule {
};
AdminRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forChild(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AdminRoutingModule);



/***/ }),

/***/ "./src/app/pages/admin/admin.component.scss":
/*!**************************************************!*\
  !*** ./src/app/pages/admin/admin.component.scss ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host {\n  display: flex;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.menu-sidebar {\n  position: relative;\n  z-index: 10;\n  min-height: 100vh;\n  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);\n}\n\n.header-trigger, .logout-trigger {\n  height: 64px;\n  padding: 20px 24px;\n  font-size: 20px;\n  cursor: pointer;\n  transition: all 0.3s, padding 0s;\n}\n\n.header-trigger i, .logout-trigger i {\n  vertical-align: calc(20px - 0.125em);\n}\n\n.header-trigger {\n  float: left;\n}\n\n.header-trigger .trigger {\n  color: #ffffff;\n}\n\n.logout-trigger {\n  float: right;\n  margin-right: 50px;\n}\n\n.logout-trigger .poweroff {\n  color: #ffffff;\n}\n\n.header-trigger:hover .trigger {\n  color: #1890ff;\n}\n\n.logout-trigger:hover .poweroff {\n  color: red;\n}\n\n.sidebar-logo {\n  position: relative;\n  height: 64px;\n  overflow: hidden;\n  line-height: 64px;\n  background: #001529;\n  transition: all 0.3s;\n  text-align: center;\n}\n\n.sidebar-logo img {\n  display: inline-block;\n  height: 32px;\n  vertical-align: middle;\n}\n\n.sidebar-title-header {\n  text-align: center;\n  overflow: hidden;\n}\n\n.sidebar-title-header h1 {\n  display: inline-block;\n  margin: 0 0 20px 0;\n  color: #fff;\n  font-weight: 600;\n  font-size: 18px;\n  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;\n  vertical-align: middle;\n}\n\nnz-header {\n  padding: 0;\n  width: 100%;\n  z-index: 2;\n}\n\n.app-header {\n  position: relative;\n  height: 64px;\n  padding: 0;\n  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);\n}\n\nnz-content {\n  margin: 24px;\n}\n\n.inner-content {\n  padding: 24px;\n  background: #fff;\n  height: auto;\n}\n\nnz-footer {\n  background-color: #001529;\n  color: #ffffff;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/pages/admin/admin.component.ts":
/*!************************************************!*\
  !*** ./src/app/pages/admin/admin.component.ts ***!
  \************************************************/
/*! exports provided: AdminComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdminComponent", function() { return AdminComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_auth_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/auth.service */ "./src/app/services/auth.service.ts");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/shared/global.service */ "./src/app/shared/global.service.ts");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");






let AdminComponent = class AdminComponent {
    constructor(auth, dataService, global, message) {
        this.auth = auth;
        this.dataService = dataService;
        this.global = global;
        this.message = message;
        this.isCollapsed = false;
    }
    ngOnInit() {
        this.appVersion = this.global.appVersion;
        this.dataService.getKey().subscribe(result => {
            for (let i = 0; i < result.length; i++) {
                this.global.saveKey(result[i].key);
            }
        }, error => {
            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
            console.log('GET KEY: ', error);
        });
    }
    /*
    * @desc logout from application
    * @return void
    */
    onSubmitLogout() {
        this.auth.logout();
    }
};
AdminComponent.ctorParameters = () => [
    { type: src_app_services_auth_service__WEBPACK_IMPORTED_MODULE_2__["AuthService"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_4__["GlobalService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_5__["NzMessageService"] }
];
AdminComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-admin',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./admin.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/admin/admin.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./admin.component.scss */ "./src/app/pages/admin/admin.component.scss")).default]
    })
], AdminComponent);



/***/ }),

/***/ "./src/app/pages/admin/admin.module.ts":
/*!*********************************************!*\
  !*** ./src/app/pages/admin/admin.module.ts ***!
  \*********************************************/
/*! exports provided: AdminModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdminModule", function() { return AdminModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _admin_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./admin-routing.module */ "./src/app/pages/admin/admin-routing.module.ts");
/* harmony import */ var _admin_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./admin.component */ "./src/app/pages/admin/admin.component.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var src_app_icons_provider_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/icons-provider.module */ "./src/app/icons-provider.module.ts");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _categories_categories_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../categories/categories.component */ "./src/app/pages/categories/categories.component.ts");
/* harmony import */ var _products_products_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../products/products.component */ "./src/app/pages/products/products.component.ts");
/* harmony import */ var src_app_services_auth_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/app/services/auth.service */ "./src/app/services/auth.service.ts");
/* harmony import */ var src_app_guards_auth_guard__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/app/guards/auth.guard */ "./src/app/guards/auth.guard.ts");
/* harmony import */ var _users_users_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../users/users.component */ "./src/app/pages/users/users.component.ts");
/* harmony import */ var _adv_adv_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../adv/adv.component */ "./src/app/pages/adv/adv.component.ts");
/* harmony import */ var _filters_filters_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../filters/filters.component */ "./src/app/pages/filters/filters.component.ts");
/* harmony import */ var _notifications_notifications_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../notifications/notifications.component */ "./src/app/pages/notifications/notifications.component.ts");
/* harmony import */ var _faq_faq_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../faq/faq.component */ "./src/app/pages/faq/faq.component.ts");
/* harmony import */ var ngx_quill__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ngx-quill */ "./node_modules/ngx-quill/fesm2015/ngx-quill.js");
/* harmony import */ var _packs_packs_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../packs/packs.component */ "./src/app/pages/packs/packs.component.ts");
/* harmony import */ var _livings_notifications_livings_notifications_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../livings-notifications/livings-notifications.component */ "./src/app/pages/livings-notifications/livings-notifications.component.ts");























let AdminModule = class AdminModule {
};
AdminModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_admin_component__WEBPACK_IMPORTED_MODULE_4__["AdminComponent"],
            _categories_categories_component__WEBPACK_IMPORTED_MODULE_11__["CategoriesComponent"],
            _products_products_component__WEBPACK_IMPORTED_MODULE_12__["ProductsComponent"],
            _users_users_component__WEBPACK_IMPORTED_MODULE_15__["UsersComponent"],
            _adv_adv_component__WEBPACK_IMPORTED_MODULE_16__["AdvComponent"],
            _filters_filters_component__WEBPACK_IMPORTED_MODULE_17__["FiltersComponent"],
            _notifications_notifications_component__WEBPACK_IMPORTED_MODULE_18__["NotificationsComponent"],
            _faq_faq_component__WEBPACK_IMPORTED_MODULE_19__["FaqComponent"],
            _packs_packs_component__WEBPACK_IMPORTED_MODULE_21__["PacksComponent"],
            _livings_notifications_livings_notifications_component__WEBPACK_IMPORTED_MODULE_22__["LivingsNotificationsComponent"]
        ],
        imports: [_angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _admin_routing_module__WEBPACK_IMPORTED_MODULE_3__["AdminRoutingModule"],
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_5__["BrowserModule"],
            src_app_icons_provider_module__WEBPACK_IMPORTED_MODULE_6__["IconsProviderModule"],
            ng_zorro_antd__WEBPACK_IMPORTED_MODULE_7__["NgZorroAntdModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_8__["FormsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_9__["HttpClientModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_10__["BrowserAnimationsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_8__["ReactiveFormsModule"],
            ngx_quill__WEBPACK_IMPORTED_MODULE_20__["QuillModule"].forRoot({
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike']
                    ],
                },
                theme: 'snow'
            }),
        ],
        exports: [_admin_component__WEBPACK_IMPORTED_MODULE_4__["AdminComponent"]],
        providers: [src_app_services_auth_service__WEBPACK_IMPORTED_MODULE_13__["AuthService"], src_app_guards_auth_guard__WEBPACK_IMPORTED_MODULE_14__["AuthGuard"], { provide: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_7__["NZ_I18N"], useValue: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_7__["en_GB"] }],
    })
], AdminModule);



/***/ }),

/***/ "./src/app/pages/adv/adv.component.scss":
/*!**********************************************!*\
  !*** ./src/app/pages/adv/adv.component.scss ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".resetBtn {\n  margin-top: 20px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvYWR2L0M6XFxVc2Vyc1xcYWNvYnJcXERvY3VtZW50c1xcVmlzdWFsIFN0dWRpbyAyMDE5XFxQcm9qZWN0c1xcbGFpY2Eub2NhLmFwcGFkbWluL3NyY1xcYXBwXFxwYWdlc1xcYWR2XFxhZHYuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3BhZ2VzL2Fkdi9hZHYuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxnQkFBQTtBQ0NKIiwiZmlsZSI6InNyYy9hcHAvcGFnZXMvYWR2L2Fkdi5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5yZXNldEJ0biB7XHJcbiAgICBtYXJnaW4tdG9wOiAyMHB4O1xyXG59IiwiLnJlc2V0QnRuIHtcbiAgbWFyZ2luLXRvcDogMjBweDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/pages/adv/adv.component.ts":
/*!********************************************!*\
  !*** ./src/app/pages/adv/adv.component.ts ***!
  \********************************************/
/*! exports provided: AdvComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdvComponent", function() { return AdvComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/shared/global.service */ "./src/app/shared/global.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");








let AdvComponent = class AdvComponent {
    constructor(globalService, dataService, http, message, fb) {
        this.globalService = globalService;
        this.dataService = dataService;
        this.http = http;
        this.message = message;
        this.fb = fb;
        this.editCache = {};
        this.listOfLanguages = this.globalService.advLanguagesCode;
        this.listOfStatus = [{ 'value': true, 'text': 'Active' }, { 'value': false, 'text': 'No active' }];
        this.listOfSearchLanguages = [];
        this.imgPath = this.globalService.imgPath + 'adv/';
        this.uploadURL = this.globalService.uploadURL + 'changeAdvImages.php';
        this.loading = true;
        this.showForm = false;
        this.filterFunc = (item) => {
            const hasStatus = ((typeof this.searchStatus !== 'undefined') && (this.searchStatus !== null)
                // tslint:disable-next-line: triple-equals
                ? (item.status == this.searchStatus) : true);
            const hasLanguage = (this.listOfSearchLanguages.length
                ? this.listOfSearchLanguages.some(language => item.languageCode.indexOf(language) !== -1) : true);
            return hasStatus && hasLanguage;
        };
        /*
        * @desc change icon or image action. save icon/image as "dataResult.code-icon/image" in this.imgPath
        * @param item -> uploaded icon name
        * @return void
        */
        this.customReq = (item) => {
            // Create a FormData here to store files and other parameters.
            const formData = new FormData();
            formData.append('file', item.file);
            formData.append('field', 'adv');
            formData.append('filename', item.name);
            formData.append('ext', item.file.name.substr(item.file.name.lastIndexOf('.')));
            const req = new _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpRequest"]('POST', item.action, formData, {
                reportProgress: true
            });
            // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
            return this.http.request(req).subscribe((event) => {
                if (event.type === _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpEventType"].UploadProgress) {
                    if (event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    item.onProgress(event, item.file);
                }
                else if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpResponse"]) {
                    item.onSuccess(event.body, item.file, event);
                }
            }, err => {
                item.onError(err, item.file);
            });
        };
        /*
        * @desc check if uploaded image/icon is valid before insert into database and save
        * @param file -> uploaded image/icon
        * @return boolean, true if valid, false otherwise
        */
        this.beforeUpload = (file) => {
            return new rxjs__WEBPACK_IMPORTED_MODULE_7__["Observable"]((observer) => {
                // CHECK EXTENSION TYPES
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                if (!isJPG && !isPNG) {
                    this.message.create('error', 'Only .png and .jpg files are supported', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                // CHECK SIZE file max size -> 2MB
                const isLt2M = file.size < 2097152;
                if (!isLt2M) {
                    this.message.create('error', 'File size must be under 2MB', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                observer.next((isJPG || isPNG) && isLt2M);
                observer.complete();
            });
        };
    }
    ngOnInit() {
        this.dataService.getTable('adv').subscribe(result => {
            this.dataResult = result;
            this.displayedData = this.dataResult;
            this.updateEditCache();
            this.loading = false;
        }, error => {
            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
            console.log('GET TABLE: ', error);
            this.loading = false;
        });
        this.advGroup = this.fb.group({
            title: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
            languageCode: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', []),
            dateStart: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"](null, [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
            dateEnd: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"](null, [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
            link: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', []),
        });
    }
    /*
    * @desc build editCache as a (not deep) copy of dataResult array used for edit functions
    * @param -
    * @return void
    */
    updateEditCache() {
        this.dataResult.forEach(item => {
            this.editCache[item.code] = {
                visibleImage: false,
                loading: false,
                edit: false,
                data: Object.assign({}, item)
            };
        });
        this.displayedData = this.dataResult;
    }
    /*
    * @desc filt dataResult in function of item's languages or status
    * @param listOfLanguages -> array of inputed languages
    * @param status -> 1||0
    * @return void
    */
    filter(listOfLanguages, status) {
        this.listOfSearchLanguages = listOfLanguages;
        this.searchStatus = status;
        this.displayedData = this.dataResult.filter(item => this.filterFunc(item));
    }
    /*
    * @desc reset selected filters
    * @param -
    * @return void
    */
    resetFilters() {
        this.listOfStatus = [{ 'value': true, 'text': 'Active' }, { 'value': false, 'text': 'No active' }];
        this.listOfLanguages = this.globalService.advLanguagesCode;
        this.listOfSearchLanguages = [];
        this.searchStatus = null;
        this.filter(this.listOfSearchLanguages, this.searchStatus);
    }
    /*
    * @desc start edit action
    * @param code -> dataResult item's code
    * @return void
    */
    startEdit(code) {
        this.editCache[code].edit = true;
    }
    /*
    * @desc cancel edit action. Reset editCache
    * @param -
    * @return void
    */
    cancelEdit(code) {
        const index = this.dataResult.findIndex(item => item.code === code);
        this.editCache[code] = {
            visibleImage: false,
            data: Object.assign({}, this.dataResult[index]),
            loading: false,
            edit: false
        };
    }
    /*
    * @desc save edit action. call dataService, find and replace edited record in the database
    * @param code -> dataResult item's code
    * @return void
    */
    saveEdit(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex(item => item.code === code);
            Object.assign(this.dataResult[index], this.editCache[code].data);
            this.editCache[code].edit = false;
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + this.dataResult[index].title + this.dataResult[index].languageCode + this.dataResult[index].link);
            const formData = new FormData();
            formData.append('table', 'adv');
            formData.append('code', code);
            formData.append('title', this.dataResult[index].title);
            formData.append('language', this.dataResult[index].languageCode);
            formData.append('link', this.dataResult[index].link);
            formData.append('dateStart', ((this.dataResult[index].dateStart) / 1000).toString());
            formData.append('dateEnd', ((this.dataResult[index].dateEnd) / 1000).toString());
            formData.append('checkKey', checkSumKey);
            // call data service, find and REPLACE records
            this.dataService.editTable(formData).subscribe(result => {
                this.message.create('success', 'Record edited successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('EDIT: ', error);
            });
        });
    }
    /*
    * @desc delete action. Find and delete record in the database
    * @param code -> dataResult item's code
    * @return void
    */
    deleteRow(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.dataResult = this.dataResult.filter(d => d.code !== code);
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblAdv');
            const formData = new FormData();
            formData.append('table', 'TblAdv');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            // call data service, DELETE record
            this.dataService.deleteRowTable(formData).subscribe(result => {
                this.message.create('success', 'Record deleted successfully', { nzDuration: 5000 });
                this.updateEditCache();
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('DELETE: ', error);
            });
        });
    }
    /*
    * @desc add action. add record in the database
    * @param -
    * @return void
    */
    addRow() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (this.advGroup.invalid) {
                this.message.create('error', 'All * fields are required', { nzDuration: 5000 });
            }
            else {
                const dateStart = (Math.trunc((this.advGroup.value.dateStart.getTime()) / 1000)).toString();
                const dateEnd = (Math.trunc((this.advGroup.value.dateEnd.getTime()) / 1000)).toString();
                const checkSumKey = yield this.globalService.encryptDataGlobal(this.advGroup.value.title + this.advGroup.value.languageCode + this.advGroup.value.link);
                const formData = new FormData();
                formData.append('table', 'adv');
                formData.append('title', this.advGroup.value.title);
                formData.append('languageCode', this.advGroup.value.languageCode);
                formData.append('dateStart', dateStart);
                formData.append('dateEnd', dateEnd);
                formData.append('link', this.advGroup.value.link);
                formData.append('checkKey', checkSumKey);
                this.dataService.addRowToTable(formData).subscribe(result => {
                    this.message.create('success', 'Row added successfully', { nzDuration: 5000 });
                    // refresh editCache and dataResult with a new row
                    this.ngOnInit();
                }, error => {
                    this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                    console.log('ADD: ', error);
                });
            }
        });
    }
    /*
    * @desc change state action. Find and change record's status in the database
    * @param code -> dataResult item's code
    * @return void
    */
    onClickSwitch(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex(item => item.code === code);
            this.dataResult[index].status = !this.dataResult[index].status;
            this.editCache[code].data.status = !this.editCache[code].data.status;
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblAdv');
            const formData = new FormData();
            formData.append('table', 'TblAdv');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            this.dataService.editStatus(formData).subscribe(result => {
                this.message.create('success', 'Status changed successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('CHANGE SWITCH: ', error);
            });
        });
    }
    /*
    * @desc edit/add image and icon name action. find and add/edit image and icon in database
    * @param info -> uploaded file;
    * @param code -> dataResult.code;
    * @param field -> "image" || "icon";
    * @return void
    */
    handleChange(info, code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            switch (info.file.status) {
                case 'uploading':
                    this.editCache[code].loading = true;
                    break;
                case 'done':
                    const data = this.editCache[code].data;
                    const fileExtension = info.file.name.substr(info.file.name.lastIndexOf('.'));
                    const index = this.dataResult.findIndex(item => item.code === code);
                    // ****************************************IMAGE UPDATING
                    // CUSTOMIZED IMAGE NAME
                    data.image = 'adv' + data.code + fileExtension;
                    const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + 'image' + data.image);
                    // ENTER HERE WHEN:
                    // 1- data.image doesn't exists
                    // 2- upload a new image with different extension
                    if (!this.dataResult[index].image.includes(data.image)) {
                        const formData = new FormData();
                        formData.append('table', 'TblAdv');
                        formData.append('code', data.code);
                        formData.append('file', data.image);
                        formData.append('field', 'image');
                        formData.append('checkKey', checkSumKey);
                        this.dataService.uploadFiles(formData).subscribe(result => {
                            this.message.create('success', 'Image added successfully', { nzDuration: 5000 });
                            this.updateEditCache();
                        }, error => {
                            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                            console.log('UPLOAD FILE: ', error);
                        });
                    }
                    else {
                        this.message.create('success', 'Image changed successfully', { nzDuration: 5000 });
                        // REFRESH URL
                        data.image += '?random+\=' + Math.random();
                        this.editCache[code].loading = true;
                    }
                    // ASSIGN EDITED PICTURE
                    Object.assign(this.dataResult[index], this.editCache[code].data);
                    this.editCache[code].loading = false;
                    break;
                case 'error':
                    this.message.create('error', 'An error occured', { nzDuration: 5000 });
                    console.log('HANDLE CHANGE: ', info.file.status, info.file, code);
                    break;
            }
        });
    }
};
AdvComponent.ctorParameters = () => [
    { type: src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_5__["GlobalService"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClient"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] }
];
AdvComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-adv',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./adv.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/adv/adv.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./adv.component.scss */ "./src/app/pages/adv/adv.component.scss")).default]
    })
], AdvComponent);



/***/ }),

/***/ "./src/app/pages/categories/categories.component.scss":
/*!************************************************************!*\
  !*** ./src/app/pages/categories/categories.component.scss ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".addBtn {\n  margin-top: 15px;\n}\n\n.addCard {\n  margin-bottom: 15px;\n}\n\n.actionLink {\n  font-size: 18px;\n}\n\n.inputValue {\n  width: 200px;\n  margin-left: 50px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvY2F0ZWdvcmllcy9DOlxcVXNlcnNcXGFjb2JyXFxEb2N1bWVudHNcXFZpc3VhbCBTdHVkaW8gMjAxOVxcUHJvamVjdHNcXGxhaWNhLm9jYS5hcHBhZG1pbi9zcmNcXGFwcFxccGFnZXNcXGNhdGVnb3JpZXNcXGNhdGVnb3JpZXMuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3BhZ2VzL2NhdGVnb3JpZXMvY2F0ZWdvcmllcy5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLGdCQUFBO0FDQ0o7O0FERUE7RUFDSSxtQkFBQTtBQ0NKOztBREVBO0VBQ0ksZUFBQTtBQ0NKOztBREVBO0VBQ0ksWUFBQTtFQUNBLGlCQUFBO0FDQ0oiLCJmaWxlIjoic3JjL2FwcC9wYWdlcy9jYXRlZ29yaWVzL2NhdGVnb3JpZXMuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuYWRkQnRuIHtcclxuICAgIG1hcmdpbi10b3A6IDE1cHg7XHJcbn1cclxuXHJcbi5hZGRDYXJkIHtcclxuICAgIG1hcmdpbi1ib3R0b206IDE1cHg7XHJcbn1cclxuXHJcbi5hY3Rpb25MaW5rIHtcclxuICAgIGZvbnQtc2l6ZTogMThweDtcclxufVxyXG5cclxuLmlucHV0VmFsdWV7XHJcbiAgICB3aWR0aDogMjAwcHg7IFxyXG4gICAgbWFyZ2luLWxlZnQ6IDUwcHg7XHJcbn1cclxuIiwiLmFkZEJ0biB7XG4gIG1hcmdpbi10b3A6IDE1cHg7XG59XG5cbi5hZGRDYXJkIHtcbiAgbWFyZ2luLWJvdHRvbTogMTVweDtcbn1cblxuLmFjdGlvbkxpbmsge1xuICBmb250LXNpemU6IDE4cHg7XG59XG5cbi5pbnB1dFZhbHVlIHtcbiAgd2lkdGg6IDIwMHB4O1xuICBtYXJnaW4tbGVmdDogNTBweDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/pages/categories/categories.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/pages/categories/categories.component.ts ***!
  \**********************************************************/
/*! exports provided: CategoriesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CategoriesComponent", function() { return CategoriesComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/shared/global.service */ "./src/app/shared/global.service.ts");







let CategoriesComponent = class CategoriesComponent {
    constructor(globalService, dataService, message, fb, http) {
        this.globalService = globalService;
        this.dataService = dataService;
        this.message = message;
        this.fb = fb;
        this.http = http;
        this.editCache = {};
        this.uploadURL = this.globalService.uploadURL + 'changeCategoryImages.php';
        this.imgPath = this.globalService.imgPath + 'categories/';
        this.loading = true;
        this.showForm = false;
        /*
        * @desc change icon action. save icon as "dataResult.code-icon" in this.imgPath
        * @param item -> uploaded icon name
        * @return void
        */
        this.customIconReq = (item) => {
            // Create a FormData here to store files and other parameters.
            const formData = new FormData();
            formData.append('file', item.file);
            formData.append('field', 'icon');
            formData.append('filename', item.name);
            formData.append('ext', item.file.name.substr(item.file.name.lastIndexOf('.')));
            const req = new _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpRequest"]('POST', item.action, formData, {
                reportProgress: true
            });
            // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
            return this.http.request(req).subscribe((event) => {
                if (event.type === _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpEventType"].UploadProgress) {
                    if (event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    item.onProgress(event, item.file);
                }
                else if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpResponse"]) {
                    item.onSuccess(event.body, item.file, event);
                }
            }, err => {
                item.onError(err, item.file);
            });
        };
        /*
        * @desc change image action. save icon as "dataResult.code-img" in this.imgPath
        * @param item -> uploaded image name
        * @return void
        */
        this.customImageReq = (item) => {
            // Create a FormData here to store files and other parameters.
            const formData = new FormData();
            formData.append('file', item.file);
            formData.append('field', 'img');
            formData.append('filename', item.name);
            formData.append('ext', item.file.name.substr(item.file.name.lastIndexOf('.')));
            const req = new _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpRequest"]('POST', item.action, formData, {
                reportProgress: true
            });
            // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
            return this.http.request(req).subscribe((event) => {
                if (event.type === _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpEventType"].UploadProgress) {
                    if (event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    item.onProgress(event, item.file);
                }
                else if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpResponse"]) {
                    item.onSuccess(event.body, item.file, event);
                }
            }, err => {
                item.onError(err, item.file);
            });
        };
        /*
        * @desc check if uploaded image/icon is valid before insert into database and save
        * @param file -> uploaded image/icon
        * @return boolean, true if valid, false otherwise
        */
        this.beforeUpload = (file) => {
            if (file.type !== 'image/svg+xml') {
                this.message.create('error', 'FILE TYPE: only .svg files are supported', { nzDuration: 5000 });
                return false;
            }
            // file max size -> 2MB
            if (file.size > 2097152) {
                this.message.create('error', 'FILE SIZE: file size must be under 2MB', { nzDuration: 5000 });
                return false;
            }
            return true;
        };
    }
    /*
    * Get table content on Component init
    */
    ngOnInit() {
        this.loading = true;
        this.dataService.getTable('categories').subscribe(result => {
            this.dataResult = result;
            this.updateEditCache();
            this.loading = false;
        }, error => {
            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
            console.log('GET TABLE: ', error);
            this.loading = false;
        });
        this.categoryGroup = this.fb.group({
            code: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
            title: this.fb.group({
                de: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                el: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                en: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                es: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                fr: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                hu: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                it: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                pl: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                pt: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                ro: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                zh: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                zs: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                ar: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                cs: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                sk: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
                vn: new _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required]),
            })
        });
    }
    /*
    * @desc build editCache as a (not deep) copy of dataResult array used for edit functions
    * @param -
    * @return void
    */
    updateEditCache() {
        this.dataResult.forEach(item => {
            this.editCache[item.code] = {
                visibleImage: false,
                visibleIcon: false,
                loading: false,
                edit: false,
                data: {
                    code: item.code.valueOf(),
                    icon: item.icon.valueOf(),
                    image: item.image.valueOf(),
                    status: item.status.valueOf(),
                    title: this.updateTitleCache(item.title)
                }
            };
        });
    }
    /*
    * @desc build editCache.title as a (not deep) copy of dataResult.title array
    * @param itemTitle -> dataResult[i].title array
    * @return void
    */
    updateTitleCache(itemTitle) {
        const title = [];
        itemTitle.forEach(titleItem => {
            title.push({
                key: titleItem.key.valueOf(),
                value: titleItem.value.valueOf()
            });
        });
        return title;
    }
    /*
    * @desc start edit action
    * @param code -> dataResult item's code
    * @return void
    */
    startEdit(code) {
        this.editCache[code].edit = true;
    }
    /*
    * @desc cancel edit action. Reset editCache
    * @param -
    * @return void
    */
    cancelEdit() {
        this.updateEditCache();
    }
    /*
    * @desc save edit action. call dataService, find and replace edited record in the database
    * @param code -> dataResult item's code
    * @return void
    */
    saveEdit(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex(item => item.code === code);
            Object.assign(this.dataResult[index], this.editCache[code].data);
            this.editCache[code].edit = false;
            // build a title string
            let title = '{';
            for (let i = 0; i < this.dataResult[index].title.length; i++) {
                title = title + '"' + this.dataResult[index].title[i].key + '":"' +
                    this.dataResult[index].title[i].value.toString() + '"';
                if (i < this.dataResult[index].title.length - 1) {
                    title = title + ',';
                }
            }
            title = title + '}';
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + title);
            const formData = new FormData();
            formData.append('table', 'categories');
            formData.append('code', code);
            formData.append('title', title);
            formData.append('checkKey', checkSumKey);
            // call data service, find and REPLACE records
            this.dataService.editTable(formData).subscribe(result => {
                this.message.create('success', 'Record edited successfully', { nzDuration: 5000 });
                this.updateEditCache();
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('EDIT: ', error);
            });
        });
    }
    /*
    * @desc delete action. Find and delete record in the database
    * @param code -> dataResult item's code
    * @return void
    */
    deleteRow(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.dataResult = this.dataResult.filter(d => d.code !== code);
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblCategories');
            const formData = new FormData();
            formData.append('table', 'TblCategories');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            // call data service, DELETE record
            this.dataService.deleteRowTable(formData).subscribe(result => {
                this.message.create('success', 'Record deleted successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'An error occured', { nzDuration: 5000 });
                console.log('DELETE: ', error);
            });
        });
    }
    /*
    * @desc change state action. Find and change record's status in the database
    * @param code -> dataResult item's code
    * @return void
    */
    onClickSwitch(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex(item => item.code === code);
            this.dataResult[index].status = !this.dataResult[index].status;
            this.editCache[code].data.status = !this.editCache[code].data.status;
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblCategories');
            const formData = new FormData();
            formData.append('table', 'TblCategories');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            this.dataService.editStatus(formData).subscribe(result => {
                this.message.create('success', 'Status changed successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('CHANGE SWITCH: ', error);
            });
        });
    }
    /*
    * @desc add action. add record in the database
    * @param -
    * @return void
    */
    addRow() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            // IF FORM INPUT CODE ALREADY EXISTS -> SHOW ERROR
            const codeIndex = this.dataResult.findIndex(item => item.code === this.categoryGroup.value.code);
            if (codeIndex > -1) {
                this.message.create('error', 'Category\'s code already exists', { nzDuration: 5000 });
            }
            else if (this.categoryGroup.invalid) {
                this.message.create('error', 'All * fields are required', { nzDuration: 5000 });
            }
            else {
                // create a string {\n "de" : "--"\n "it" : "--"\n ....\n}
                const find = '",';
                const re = new RegExp(find, 'g');
                let title = (JSON.stringify(this.categoryGroup.value.title).replace(re, '",\n\t'));
                title = title.replace('{', '{\n\t');
                title = title.replace('}', '\n}');
                const checkSumKey = yield this.globalService.encryptDataGlobal(this.categoryGroup.value.code + title);
                const formData = new FormData();
                formData.append('table', 'categories');
                formData.append('code', this.categoryGroup.value.code);
                formData.append('title', title);
                formData.append('checkKey', checkSumKey);
                this.dataService.addRowToTable(formData).subscribe(result => {
                    this.message.create('success', 'Row added successfully', { nzDuration: 5000 });
                    // refresh editCache and dataResult with a new row
                    this.ngOnInit();
                }, error => {
                    this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                    console.log('ADD: ', error);
                });
            }
        });
    }
    /*
    * @desc edit/add image and icon name action. find and add/edit image and icon in database
    * @param info -> uploaded file;
    * @param code -> dataResult.code;
    * @param field -> "image" || "icon";
    * @return void
    */
    handleChange(info, code, field) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            switch (info.file.status) {
                case 'uploading':
                    this.editCache[code].loading = true;
                    break;
                case 'done':
                    const data = this.editCache[code].data;
                    // ****************************************ICON UPDATING
                    if (field === 'icon') {
                        if (typeof data.icon === 'undefined' || data.icon === '') {
                            // CUSTOMIZED ICON NAME
                            data.icon = data.code + '-icon' + '.svg';
                            const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + field + data.icon);
                            const formData = new FormData();
                            formData.append('table', 'TblCategories');
                            formData.append('code', data.code);
                            formData.append('file', data.icon);
                            formData.append('field', 'icon');
                            formData.append('checkKey', checkSumKey);
                            this.dataService.uploadFiles(formData).subscribe(result => {
                                this.message.create('success', 'Icon added successfully', { nzDuration: 5000 });
                            }, error => {
                                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                                console.log('UPLOAD FILE: ', error);
                            });
                        }
                        else {
                            this.message.create('success', 'Icon changed successfully', { nzDuration: 5000 });
                            // REFRESH URL
                            data.icon += '?random+\=' + Math.random();
                            this.editCache[code].loading = true;
                        }
                        // ASSIGN EDITED ICON
                        const index = this.dataResult.findIndex(item => item.code === code);
                        Object.assign(this.dataResult[index], this.editCache[code].data);
                        this.editCache[code].loading = false;
                        break;
                    }
                    else if (field === 'image') {
                        if (typeof data.image === 'undefined' || data.image === '') {
                            // CUSTOMIZED IMAGE NAME
                            data.image = data.code + '-img' + '.svg';
                            const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + field + data.image);
                            const formData = new FormData();
                            formData.append('table', 'TblCategories');
                            formData.append('code', data.code);
                            formData.append('file', data.image);
                            formData.append('field', 'image');
                            formData.append('checkKey', checkSumKey);
                            this.dataService.uploadFiles(formData).subscribe(result => {
                                this.message.create('success', 'Image added successfully', { nzDuration: 5000 });
                                this.updateEditCache();
                            }, error => {
                                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                                console.log('UPLOAD FILE: ', error);
                            });
                        }
                        else {
                            // REFRESH URL
                            data.image += '?random+\=' + Math.random();
                            this.editCache[code].loading = true;
                        }
                        // ASSIGN EDITED IMAGE
                        const index = this.dataResult.findIndex(item => item.code === code);
                        Object.assign(this.dataResult[index], this.editCache[code].data);
                        this.editCache[code].loading = false;
                        break;
                    }
                case 'error':
                    this.message.create('error', 'An error occured', { nzDuration: 5000 });
                    console.log('HANDLE CHANGE: ', info.file.status, info.file, code);
                    break;
            }
        });
    }
};
CategoriesComponent.ctorParameters = () => [
    { type: src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_6__["GlobalService"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpClient"] }
];
CategoriesComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-categories',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./categories.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/categories/categories.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./categories.component.scss */ "./src/app/pages/categories/categories.component.scss")).default]
    })
], CategoriesComponent);



/***/ }),

/***/ "./src/app/pages/faq/faq.component.scss":
/*!**********************************************!*\
  !*** ./src/app/pages/faq/faq.component.scss ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".langQuestion {\n  margin-bottom: 1rem;\n}\n\n.addBtn {\n  float: right;\n}\n\n.inputRow {\n  margin-bottom: 1rem;\n}\n\n.answerText div {\n  height: 100px !important;\n}\n\n.completedTab {\n  font-weight: bold;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvZmFxL0M6XFxVc2Vyc1xcYWNvYnJcXERvY3VtZW50c1xcVmlzdWFsIFN0dWRpbyAyMDE5XFxQcm9qZWN0c1xcbGFpY2Eub2NhLmFwcGFkbWluL3NyY1xcYXBwXFxwYWdlc1xcZmFxXFxmYXEuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3BhZ2VzL2ZhcS9mYXEuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxtQkFBQTtBQ0NKOztBREVBO0VBQ0ksWUFBQTtBQ0NKOztBREVBO0VBQ0ksbUJBQUE7QUNDSjs7QURFQTtFQUNJLHdCQUFBO0FDQ0o7O0FERUE7RUFDSSxpQkFBQTtBQ0NKIiwiZmlsZSI6InNyYy9hcHAvcGFnZXMvZmFxL2ZhcS5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5sYW5nUXVlc3Rpb24ge1xyXG4gICAgbWFyZ2luLWJvdHRvbTogMXJlbTtcclxufVxyXG5cclxuLmFkZEJ0biB7XHJcbiAgICBmbG9hdDogcmlnaHQ7XHJcbn1cclxuXHJcbi5pbnB1dFJvdyB7XHJcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xyXG59XHJcblxyXG4uYW5zd2VyVGV4dCBkaXZ7XHJcbiAgICBoZWlnaHQ6IDEwMHB4ICFpbXBvcnRhbnQ7XHJcbn1cclxuXHJcbi5jb21wbGV0ZWRUYWIge1xyXG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XHJcbn0iLCIubGFuZ1F1ZXN0aW9uIHtcbiAgbWFyZ2luLWJvdHRvbTogMXJlbTtcbn1cblxuLmFkZEJ0biB7XG4gIGZsb2F0OiByaWdodDtcbn1cblxuLmlucHV0Um93IHtcbiAgbWFyZ2luLWJvdHRvbTogMXJlbTtcbn1cblxuLmFuc3dlclRleHQgZGl2IHtcbiAgaGVpZ2h0OiAxMDBweCAhaW1wb3J0YW50O1xufVxuXG4uY29tcGxldGVkVGFiIHtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG59Il19 */");

/***/ }),

/***/ "./src/app/pages/faq/faq.component.ts":
/*!********************************************!*\
  !*** ./src/app/pages/faq/faq.component.ts ***!
  \********************************************/
/*! exports provided: FaqComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FaqComponent", function() { return FaqComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/shared/global.service */ "./src/app/shared/global.service.ts");






let FaqComponent = class FaqComponent {
    constructor(globalService, dataService, message, fb) {
        this.globalService = globalService;
        this.dataService = dataService;
        this.message = message;
        this.fb = fb;
        this.editCache = {};
        this.loading = true;
    }
    ngOnInit() {
        this.loading = true;
        this.dataService.getTable('faq').subscribe(result => {
            this.dataResult = result;
            this.updateEditCache();
            this.loading = false;
        }, error => {
            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
            console.log('GET TABLE: ', error);
            this.loading = false;
        });
        this.faqGroup = this.fb.group({
            code: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]),
            question: this.fb.group({
                de: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                el: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                en: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                es: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                fr: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                hu: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                it: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                pl: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                pt: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                ro: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                zh: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                zs: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                ar: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                cs: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                sk: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                vn: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"]('')
            }),
            answer: this.fb.group({
                de: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                el: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                en: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                es: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                fr: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                hu: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                it: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                pl: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                pt: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                ro: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                zh: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                zs: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                ar: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                cs: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                sk: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"](''),
                vn: new _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormControl"]('')
            })
        });
    }
    /*
    * @desc build editCache as a (not deep) copy of dataResult array used for edit functions
    * @param -
    * @return void
    */
    updateEditCache() {
        this.dataResult.forEach(item => {
            this.editCache[item.code] = {
                visibleImage: false,
                visibleIcon: false,
                loading: false,
                edit: false,
                data: {
                    code: item.code.valueOf(),
                    question: this.updateLanguageCache(item.question),
                    answer: this.updateLanguageCache(item.answer),
                }
            };
        });
    }
    /*
    * @desc build editCache.title as a (not deep) copy of dataResult.title array
    * @param itemTitle -> dataResult[i].title array
    * @return void
    */
    updateLanguageCache(itemTitle) {
        const title = [];
        itemTitle.forEach(titleItem => {
            title.push({
                key: titleItem.key.valueOf(),
                value: titleItem.value.valueOf()
            });
        });
        return title;
    }
    /*
    * @desc start edit action
    * @param code -> dataResult item's code
    * @return void
    */
    startEdit(code) {
        this.editCache[code].edit = true;
    }
    /*
    * @desc cancel edit action. Reset editCache
    * @param -
    * @return void
    */
    cancelEdit() {
        this.updateEditCache();
    }
    /*
    * @desc save edit action. call dataService, find and replace edited record in the database
    * @param code -> dataResult item's code
    * @return void
    */
    saveEdit(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex(item => item.code === code);
            Object.assign(this.dataResult[index], this.editCache[code].data);
            this.editCache[code].edit = false;
            // build a question string
            let q = '{';
            for (let i = 0; i < this.dataResult[index].question.length; i++) {
                q = q + '"' + this.dataResult[index].question[i].key + '":"' +
                    this.dataResult[index].question[i].value.toString() + '"';
                if (i < this.dataResult[index].question.length - 1) {
                    q = q + ',';
                }
            }
            q = q + '}';
            // build a question string
            let a = '{';
            for (let i = 0; i < this.dataResult[index].answer.length; i++) {
                a = a + '"' + this.dataResult[index].answer[i].key + '":"' +
                    this.dataResult[index].answer[i].value.toString() + '"';
                if (i < this.dataResult[index].answer.length - 1) {
                    a = a + ',';
                }
            }
            a = a + '}';
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + q);
            const formData = new FormData();
            formData.append('table', 'faqs');
            formData.append('code', code);
            formData.append('question', q);
            formData.append('answer', a);
            formData.append('checkKey', checkSumKey);
            // call data service, find and REPLACE records
            this.dataService.editTable(formData).subscribe(result => {
                this.message.create('success', 'Record edited successfully', { nzDuration: 5000 });
                this.updateEditCache();
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('EDIT: ', error);
            });
        });
    }
    /*
      * @desc delete action. Find and delete record in the database
      * @param code -> dataResult item's code
      * @return void
      */
    deleteRow(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.dataResult = this.dataResult.filter(d => d.code !== code);
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblFaq');
            const formData = new FormData();
            formData.append('table', 'TblFaq');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            // call data service, DELETE record
            this.dataService.deleteRowTable(formData).subscribe(result => {
                this.message.create('success', 'Record deleted successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'An error occured', { nzDuration: 5000 });
                console.log('DELETE: ', error);
            });
        });
    }
    /*
    * @desc add action. add record in the database
    * @param -
    * @return void
    */
    addRow() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            // IF FORM INPUT CODE ALREADY EXISTS -> SHOW ERROR
            const codeIndex = this.dataResult.findIndex(item => item.code === this.faqGroup.value.code);
            if (codeIndex > -1) {
                this.message.create('error', 'Faq\'s code already exists', { nzDuration: 5000 });
            }
            else if (this.faqGroup.invalid) {
                this.message.create('error', 'All * fields are required', { nzDuration: 5000 });
            }
            else {
                // create a string {\n "de" : "--"\n "it" : "--"\n ....\n}
                const find = '",';
                const re = new RegExp(find, 'g');
                let q = (JSON.stringify(this.faqGroup.value.question));
                let a = (JSON.stringify(this.faqGroup.value.answer));
                const checkSumKey = yield this.globalService.encryptDataGlobal(this.faqGroup.value.code + q);
                const formData = new FormData();
                formData.append('table', 'faqs');
                formData.append('code', this.faqGroup.value.code);
                formData.append('question', q);
                formData.append('answer', a);
                formData.append('checkKey', checkSumKey);
                this.dataService.addRowToTable(formData).subscribe(result => {
                    this.message.create('success', 'Row added successfully', { nzDuration: 5000 });
                    // refresh editCache and dataResult with a new row
                    this.ngOnInit();
                }, error => {
                    this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                    console.log('ADD: ', error);
                });
            }
        });
    }
};
FaqComponent.ctorParameters = () => [
    { type: src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_5__["GlobalService"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_4__["DataService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] }
];
FaqComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-faq',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./faq.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/faq/faq.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./faq.component.scss */ "./src/app/pages/faq/faq.component.scss")).default]
    })
], FaqComponent);



/***/ }),

/***/ "./src/app/pages/filters/filters.component.scss":
/*!******************************************************!*\
  !*** ./src/app/pages/filters/filters.component.scss ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".active-edit {\n  padding-top: 28px;\n}\n\n.field-edit {\n  padding-top: 17px;\n}\n\n.plus-trigger {\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.plus-trigger:hover .plus-icon {\n  color: #1890ff;\n}\n\n.delete-par-row {\n  cursor: pointer;\n  padding-left: 5px;\n}\n\n.delete-par-row:hover {\n  color: #1890ff;\n}\n\n.add-filter-label {\n  padding-top: 25px;\n  text-align: right;\n}\n\n.activekeyItem {\n  height: 67px;\n}\n\n.filterSelectCountry {\n  min-width: 150px;\n}\n\n.filterCountryColumn {\n  width: 300px;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/pages/filters/filters.component.ts":
/*!****************************************************!*\
  !*** ./src/app/pages/filters/filters.component.ts ***!
  \****************************************************/
/*! exports provided: FiltersComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FiltersComponent", function() { return FiltersComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/shared/global.service */ "./src/app/shared/global.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _interfaces_countries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../interfaces/countries */ "./src/app/interfaces/countries.ts");









let FiltersComponent = class FiltersComponent {
    constructor(globalService, dataService, message, http, fb) {
        this.globalService = globalService;
        this.dataService = dataService;
        this.message = message;
        this.http = http;
        this.fb = fb;
        this.editCache = {};
        this.uploadURL = this.globalService.uploadURL + 'changeFilterImages.php';
        this.imgPath = this.globalService.imgPath + 'filters/';
        this.loading = true;
        this.listOfCountries = this.globalService.filterCountryCode;
        this.showForm = false;
        this.listOfAllNations = _interfaces_countries__WEBPACK_IMPORTED_MODULE_8__["globalNations"];
        /*
        * @desc change icon action. save icon as "dataResult.code_thb" in this.imgPath
        * @param item -> uploaded icon name
        * @return void
        */
        this.customIconReq = (item) => {
            // Create a FormData here to store files and other parameters.
            const formData = new FormData();
            formData.append('file', item.file);
            formData.append('field', '\_thb');
            formData.append('filename', item.name);
            formData.append('ext', item.file.name.substr(item.file.name.lastIndexOf('.')));
            const req = new _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpRequest"]('POST', item.action, formData, {
                reportProgress: true
            });
            // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
            return this.http.request(req).subscribe((event) => {
                if (event.type === _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpEventType"].UploadProgress) {
                    if (event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    item.onProgress(event, item.file);
                }
                else if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpResponse"]) {
                    item.onSuccess(event.body, item.file, event);
                }
            }, err => {
                item.onError(err, item.file);
            });
        };
        /*
        * @desc change image action. save icon as "dataResult.code" in this.imgPath
        * @param item -> uploaded image name
        * @return void
        */
        this.customReq = (item) => {
            // Create a FormData here to store files and other parameters.
            const formData = new FormData();
            formData.append('file', item.file);
            formData.append('field', '');
            formData.append('filename', item.name);
            formData.append('ext', item.file.name.substr(item.file.name.lastIndexOf('.')));
            const req = new _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpRequest"]('POST', item.action, formData, {
                reportProgress: true
            });
            // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
            return this.http.request(req).subscribe((event) => {
                if (event.type === _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpEventType"].UploadProgress) {
                    if (event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    item.onProgress(event, item.file);
                }
                else if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpResponse"]) {
                    item.onSuccess(event.body, item.file, event);
                }
            }, err => {
                item.onError(err, item.file);
            });
        };
        /*
        * @desc check if uploaded image is valid before insert into database and save
        * @param file -> uploaded image
        * @return boolean, true if valid, false otherwise
        */
        this.beforeUpload = (file) => {
            return new rxjs__WEBPACK_IMPORTED_MODULE_6__["Observable"]((observer) => {
                // CHECK EXTENSION TYPES
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                if (!isJPG && !isPNG) {
                    this.message.create('error', 'Only .png and .jpg files are supported', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                // CHECK SIZE file max size -> 2MB
                const isLt2M = file.size < 2097152;
                if (!isLt2M) {
                    this.message.create('error', 'File size must be under 2MB', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                observer.next((isJPG || isPNG) && isLt2M);
                observer.complete();
            });
        };
        /*
        * @desc check if uploaded icon is valid before insert into database and save
        * @param file -> uploaded icon
        * @return boolean, true if valid, false otherwise
        */
        this.beforeUploadIcon = (file) => {
            return new rxjs__WEBPACK_IMPORTED_MODULE_6__["Observable"]((observer) => {
                // CHECK EXTENSION TYPES
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                if (!isJPG && !isPNG) {
                    this.message.create('error', 'Only .png and .jpg files are supported', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                // CHECK SIZE file max size -> 2MB
                const isLt2M = file.size < 2097152;
                if (!isLt2M) {
                    this.message.create('error', 'File size must be under 2MB', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                // CHECK DIMENSION
                this.checkIconDimension(file, 512, 512).then(dimensionRes => {
                    if (!dimensionRes) {
                        this.message.create('error', 'File dimension must be 512x512', { nzDuration: 5000 });
                        observer.complete();
                        return;
                    }
                    observer.next((isJPG || isPNG) && isLt2M && dimensionRes);
                    observer.complete();
                });
            });
        };
    }
    ngOnInit() {
        this.loading = true;
        this.dataService.getTable('filters').subscribe(result => {
            this.dataResult = result;
            this.dataResult.forEach(data => {
                const countryArray = data.countries;
                data.countries = [];
                countryArray.forEach(nat => {
                    data.countries.push(this.listOfAllNations[this.listOfAllNations.findIndex(search => search.value === nat)]);
                });
            });
            this.updateEditCache();
            this.loading = false;
        }, error => {
            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
            this.loading = false;
            console.log('GET TABLE: ', error);
        });
        this.filterGroup = this.fb.group({
            code: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
            qr: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
            title: this.fb.group({
                de: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                el: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                en: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                es: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                fr: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                hu: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                it: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                pl: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                pt: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                ro: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                zh: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                zs: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                ar: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                cs: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                sk: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
                vn: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
            }),
            param_1: this.fb.array([
                this.fb.group({
                    key: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                    active: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](false),
                    multiplier: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                    duration: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                })
            ]),
            param_2: this.fb.array([
                this.fb.group({
                    key: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                    active: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](false),
                    multiplier: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                    duration: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                })
            ]),
            param_3: this.fb.array([
                this.fb.group({
                    key: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                    active: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](false),
                    multiplier: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                    duration: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                })
            ]),
            param_4: this.fb.array([
                this.fb.group({
                    key: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                    active: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](false),
                    multiplier: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                    duration: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
                })
            ]),
        });
    }
    get param1() {
        return this.filterGroup.get('param_1');
    }
    get param2() {
        return this.filterGroup.get('param_2');
    }
    get param3() {
        return this.filterGroup.get('param_3');
    }
    get param4() {
        return this.filterGroup.get('param_4');
    }
    /*
    * @desc dinamically push a row on add form's param array
    * @param par -> "param1"||"param2"||"param3"||"param4"
    * @return void
    */
    addParamToForm(par) {
        const param = this.filterGroup.get(par);
        param.push(this.fb.group({
            active: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](false, [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
            key: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"](''),
            multiplier: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
            duration: new _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]),
        }));
    }
    /*
    * @desc dinamically remove a row on add form's param array
    * @param par -> "param1"||"param2"||"param3"||"param4"
    * @param index -> par's row index
    * @return void
    */
    deleteParamToForm(index, par) {
        const param = this.filterGroup.get(par);
        param.removeAt(index);
    }
    /*
    * @desc build editCache as a (not deep) copy of dataResult array used for edit functions
    * @param -
    * @return void
    */
    updateEditCache() {
        this.dataResult.forEach(item => {
            this.editCache[item.code] = {
                visibleImage: false,
                visibleIcon: false,
                loading: false,
                edit: false,
                data: {
                    code: item.code.valueOf(),
                    qr: item.qr.valueOf(),
                    title: this.updateTitleCache(item.title),
                    image: item.image.valueOf(),
                    icon: item.icon.valueOf(),
                    par1: this.updateParamCache(item.par1),
                    par2: this.updateParamCache(item.par2),
                    par3: this.updateParamCache(item.par3),
                    par4: this.updateParamCache(item.par4),
                    status: item.status.valueOf(),
                    countries: this.updateCountriesCache(item.countries)
                }
            };
        });
    }
    updateCountriesCache(countries) {
        const countryText = [];
        countries.forEach(item => {
            countryText.push(item.text);
        });
        return countryText;
    }
    /*
    * @desc build editCache.title as a (not deep) copy of dataResult.title array
    * @param itemTitle -> dataResult[i].title array
    * @return void
    */
    updateTitleCache(itemTitle) {
        const title = [];
        itemTitle.forEach(titleItem => {
            title.push({
                key: titleItem.key.valueOf(),
                value: titleItem.value.valueOf()
            });
        });
        return title;
    }
    /*
    * @desc build editCache.param as a (not deep) copy of dataResult.param array
    * @param itemParam -> dataResult[i].param array
    * @return void
    */
    updateParamCache(itemParam) {
        const par = [];
        itemParam.forEach(paramItem => {
            par.push({
                key: paramItem.key.valueOf(),
                active: paramItem.active.valueOf(),
                multiplier: paramItem.multiplier.valueOf(),
                duration: paramItem.duration.valueOf()
            });
        });
        return par;
    }
    /*
    * @desc start edit action
    * @param code -> dataResult item's code
    * @return void
    */
    startEdit(code) {
        this.editCache[code].edit = true;
    }
    /*
    * @desc cancel edit action. Reset editCache
    * @param -
    * @return void
    */
    cancelEdit() {
        this.updateEditCache();
    }
    /*
    * @desc save edit action. call dataService, find and replace edited record in the database
    * @param code -> dataResult item's code
    * @return void
    */
    saveEdit(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (!this.validateEditParam(this.editCache[code].data.par1) ||
                !this.validateEditParam(this.editCache[code].data.par2) ||
                !this.validateEditParam(this.editCache[code].data.par3) ||
                !this.validateEditParam(this.editCache[code].data.par4)) {
                return;
            }
            const index = this.dataResult.findIndex(item => item.code === code);
            const countryArray = this.editCache[code].data.countries;
            this.editCache[code].data.countries = [];
            countryArray.forEach(nat => {
                const i = this.listOfAllNations.findIndex(search => search.text === nat);
                if (i !== -1) {
                    this.editCache[code].data.countries.push(this.listOfAllNations[i]);
                }
            });
            Object.assign(this.dataResult[index], this.editCache[code].data);
            this.editCache[code].edit = false;
            // build a title string
            let title = '{';
            for (let i = 0; i < this.dataResult[index].title.length; i++) {
                title = title + '"' + this.dataResult[index].title[i].key + '":"' +
                    this.dataResult[index].title[i].value.toString() + '"';
                if (i < this.dataResult[index].title.length - 1) {
                    title = title + ',';
                }
            }
            title = title + '}';
            const par1 = this.buildParamString(this.dataResult[index].par1);
            const par2 = this.buildParamString(this.dataResult[index].par2);
            const par3 = this.buildParamString(this.dataResult[index].par3);
            const par4 = this.buildParamString(this.dataResult[index].par4);
            let countriesIDs = '[';
            this.dataResult[index].countries.forEach((data, index, array) => {
                countriesIDs = countriesIDs + '"' + data.value + '"';
                if (index !== array.length - 1) {
                    countriesIDs = countriesIDs + ',';
                }
            });
            countriesIDs = countriesIDs + ']';
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + title + par1 + par2 + par3 + par4);
            const formData = new FormData();
            formData.append('table', 'filters');
            formData.append('code', code);
            formData.append('qr', this.dataResult[index].qr);
            formData.append('title', title);
            formData.append('par1', par1);
            formData.append('par2', par2);
            formData.append('par3', par3);
            formData.append('par4', par4);
            formData.append('countries', countriesIDs);
            formData.append('checkKey', checkSumKey);
            // call data service, find and REPLACE records
            this.dataService.editTable(formData).subscribe(result => {
                this.message.create('success', 'Record edited successfully', { nzDuration: 5000 });
                this.updateEditCache();
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('EDIT: ', error);
            });
        });
    }
    /*
    * @desc check if edited parameters are valid
    * @param data -> checked param
    * @return boolean: true if param is valid, false otherwise
    */
    validateEditParam(data) {
        for (let i = 0; i < data.length; i++) {
            if (!data[i].multiplier || !data[i].duration) {
                this.message.create('error', 'Parameter must be not empty', { nzDuration: 5000 });
                return false;
            }
        }
        return true;
    }
    /*
    * @desc build a string from param json
    * @param par -> dataResult.param
    * @return string of param json
    */
    buildParamString(par) {
        let result = '{';
        for (let i = 0; i < par.length; i++) {
            const active = par[i].active ? '1' : '0';
            result = result + '"' + par[i].key + '":{"active":"' +
                active + '","multiplier":"' + par[i].multiplier + '","duration":"' +
                par[i].duration + '"}';
            if (i < par.length - 1) {
                result = result + ',';
            }
        }
        result = result + '}';
        return result;
    }
    /*
    * @desc delete action. Find and delete record in the database
    * @param code -> dataResult item's code
    * @return void
    */
    deleteRow(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.dataResult = this.dataResult.filter(d => d.code !== code);
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblFilters');
            const formData = new FormData();
            formData.append('table', 'TblFilters');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            // call data service, DELETE record
            this.dataService.deleteRowTable(formData).subscribe(result => {
                this.message.create('success', 'Record deleted successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'An error occured', { nzDuration: 5000 });
                console.log('DELETE: ', error);
            });
        });
    }
    /*
    * @desc change state action. Find and change record's status in the database
    * @param code -> dataResult item's code
    * @return void
    */
    onClickSwitch(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex(item => item.code === code);
            this.dataResult[index].status = !this.dataResult[index].status;
            this.editCache[code].data.status = !this.editCache[code].data.status;
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblFilters');
            const formData = new FormData();
            formData.append('table', 'TblFilters');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            this.dataService.editStatus(formData).subscribe(result => {
                this.message.create('success', 'Status changed successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('CHANGE SWITCH: ', error);
            });
        });
    }
    /*
    * @desc add action. add record in the database
    * @param -
    * @return void
    */
    addRow() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            // IF FORM INPUT CODE ALREADY EXISTS -> SHOW ERROR
            const codeIndex = this.dataResult.findIndex(item => item.code === this.filterGroup.value.code);
            if (codeIndex > -1) {
                this.message.create('error', 'Filter\'s code already exists', { nzDuration: 5000 });
            }
            else if (this.filterGroup.invalid) {
                this.message.create('error', 'All * fields are required', { nzDuration: 5000 });
            }
            else {
                const title = (JSON.stringify(this.filterGroup.value.title));
                const par1 = this.buildParamString(this.filterGroup.value.param_1);
                const par2 = this.buildParamString(this.filterGroup.value.param_2);
                const par3 = this.buildParamString(this.filterGroup.value.param_3);
                const par4 = this.buildParamString(this.filterGroup.value.param_4);
                const checkSumKey = yield this.globalService.encryptDataGlobal(this.filterGroup.value.code + this.filterGroup.value.qr + title + par1 + par2 + par3 + par4);
                const formData = new FormData();
                formData.append('table', 'filters');
                formData.append('code', this.filterGroup.value.code);
                formData.append('qr', this.filterGroup.value.qr);
                formData.append('title', title);
                formData.append('par1', par1);
                formData.append('par2', par2);
                formData.append('par3', par3);
                formData.append('par4', par4);
                formData.append('checkKey', checkSumKey);
                this.dataService.addRowToTable(formData).subscribe(result => {
                    this.message.create('success', 'Row added successfully', { nzDuration: 5000 });
                    // refresh editCache and dataResult with a new row
                    this.ngOnInit();
                }, error => {
                    this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                    console.log('ADD: ', error);
                });
            }
        });
    }
    /*
    * @desc edit/add image and icon name action. find and add/edit image and icon in database
    * @param info -> uploaded file;
    * @param code -> dataResult.code;
    * @param field -> "image" || "icon";
    * @return void
    */
    handleChange(info, code, field) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            switch (info.file.status) {
                case 'uploading':
                    this.editCache[code].loading = true;
                    break;
                case 'done':
                    const data = this.editCache[code].data;
                    const fileExtension = info.file.name.substr(info.file.name.lastIndexOf('.'));
                    const index = this.dataResult.findIndex(item => item.code === code);
                    // ****************************************ICON UPDATING
                    if (field === 'icon') {
                        // CUSTOMIZED ICON NAME
                        data.icon = data.code + '\_thb' + fileExtension;
                        const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + field + data.icon);
                        // ENTER HERE WHEN:
                        // 1- data.icon doesn't exists
                        // 2- upload a new icon with different extension
                        if (!this.dataResult[index].icon.includes(data.icon)) {
                            const formData = new FormData();
                            formData.append('table', 'TblFilters');
                            formData.append('code', data.code);
                            formData.append('file', data.icon);
                            formData.append('field', 'icon');
                            formData.append('checkKey', checkSumKey);
                            this.dataService.uploadFiles(formData).subscribe(result => {
                                this.message.create('success', 'Icon added successfully', { nzDuration: 5000 });
                            }, error => {
                                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                                console.log('UPLOAD FILE: ', error);
                            });
                        }
                        else {
                            this.message.create('success', 'Icon changed successfully', { nzDuration: 5000 });
                            // REFRESH URL
                            data.icon += '?random+\=' + Math.random();
                            this.editCache[code].loading = true;
                        }
                    }
                    else if (field === 'image') {
                        // CUSTOMIZED IMAGE NAME
                        data.image = data.code + fileExtension;
                        const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + field + data.image);
                        // ENTER HERE WHEN:
                        // 1- data.image doesn't exists
                        // 2- upload a new image with different extension
                        if (!this.dataResult[index].image.includes(data.image)) {
                            const formData = new FormData();
                            formData.append('table', 'TblFilters');
                            formData.append('code', data.code);
                            formData.append('file', data.image);
                            formData.append('field', 'image');
                            formData.append('checkKey', checkSumKey);
                            this.dataService.uploadFiles(formData).subscribe(result => {
                                this.message.create('success', 'Image added successfully', { nzDuration: 5000 });
                                this.updateEditCache();
                            }, error => {
                                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                                console.log('UPLOAD FILE: ', error);
                            });
                        }
                        else {
                            this.message.create('success', 'Image changed successfully', { nzDuration: 5000 });
                            // REFRESH URL
                            data.image += '?random+\=' + Math.random();
                            this.editCache[code].loading = true;
                        }
                    }
                    // ASSIGN EDITED PICTURE
                    Object.assign(this.dataResult[index], this.editCache[code].data);
                    this.editCache[code].loading = false;
                    break;
                case 'error':
                    this.message.create('error', 'An error occured', { nzDuration: 5000 });
                    console.log('HANDLE CHANGE: ', info.file.status, info.file, code);
                    break;
            }
        });
    }
    checkIconDimension(file, maxW, maxH) {
        return new Promise(resolve => {
            const img = new Image(); // create image
            img.src = window.URL.createObjectURL(file);
            img.onload = () => {
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                window.URL.revokeObjectURL(img.src);
                resolve(width === maxW && height === maxH);
            };
        });
    }
    /*
    * @desc dinamically add a param's row while edit
    * @param par -> "param1"||"param2"||"param3"||"param4"
    * @return void
    */
    addParRow(par) {
        if (par.length < 5) {
            par.push({ key: '', active: false, multiplier: '', duration: '' });
        }
    }
    /*
    * @desc dinamically remove a param's row while edit
    * @param par -> "param1"||"param2"||"param3"||"param4"
    * @param index -> par's row index
    * @return void
    */
    deleteParRow(par, index) {
        par.splice(index, 1);
        console.log(par);
    }
};
FiltersComponent.ctorParameters = () => [
    { type: src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_4__["GlobalService"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpClient"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormBuilder"] }
];
FiltersComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-filters',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./filters.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/filters/filters.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./filters.component.scss */ "./src/app/pages/filters/filters.component.scss")).default]
    })
], FiltersComponent);



/***/ }),

/***/ "./src/app/pages/front/front.component.scss":
/*!**************************************************!*\
  !*** ./src/app/pages/front/front.component.scss ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2Zyb250L2Zyb250LmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/pages/front/front.component.ts":
/*!************************************************!*\
  !*** ./src/app/pages/front/front.component.ts ***!
  \************************************************/
/*! exports provided: FrontComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FrontComponent", function() { return FrontComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");





let FrontComponent = class FrontComponent {
    constructor(activatedRoute, router, dataService, message) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.dataService = dataService;
        this.message = message;
        this.displayedData = [];
        this.loading = true;
        this.actives = [];
    }
    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params['lang']) {
                this.lang = params['lang'];
            }
            else {
                this.router.navigateByUrl('/login');
            }
        });
        this.loading = true;
        this.dataService.getTable('faq').subscribe(result => {
            console.log(result);
            this.dataResult = result;
            this.dataResult.forEach(data => {
                data.question.forEach(q => {
                    if (q.key == this.lang && q.value) {
                        data.answer.forEach(a => {
                            if (a.key == this.lang && a.value) {
                                this.displayedData.push({
                                    question: q.value,
                                    answer: a.value
                                });
                                this.actives.push(false);
                            }
                        });
                    }
                });
            });
            this.loading = false;
            console.log('DD', this.displayedData);
        }, error => {
            this.message.create('error', 'An error occured', { nzDuration: 5000 });
            console.log('GET TABLE: ', error);
            this.loading = false;
        });
    }
    changeActive(i) {
        this.actives[i] = !this.actives[i];
    }
};
FrontComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_4__["NzMessageService"] }
];
FrontComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-front',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./front.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/front/front.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./front.component.scss */ "./src/app/pages/front/front.component.scss")).default]
    })
], FrontComponent);



/***/ }),

/***/ "./src/app/pages/livings-notifications/livings-notifications.component.scss":
/*!**********************************************************************************!*\
  !*** ./src/app/pages/livings-notifications/livings-notifications.component.scss ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL2xpdmluZ3Mtbm90aWZpY2F0aW9ucy9saXZpbmdzLW5vdGlmaWNhdGlvbnMuY29tcG9uZW50LnNjc3MifQ== */");

/***/ }),

/***/ "./src/app/pages/livings-notifications/livings-notifications.component.ts":
/*!********************************************************************************!*\
  !*** ./src/app/pages/livings-notifications/livings-notifications.component.ts ***!
  \********************************************************************************/
/*! exports provided: LivingsNotificationsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LivingsNotificationsComponent", function() { return LivingsNotificationsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");




let LivingsNotificationsComponent = class LivingsNotificationsComponent {
    constructor(dataService, message) {
        this.dataService = dataService;
        this.message = message;
        this.sortName = null;
        this.sortValue = null;
        this.listOfSearchName = [];
        this.loading = true;
    }
    /*
    * Get table content on Component init
    */
    ngOnInit() {
        this.loading = true;
        this.dataService.getTable('livingsnotifications').subscribe(result => {
            this.dataResult = result;
            this.sortedData = [
                ...this.dataResult
            ];
            this.loading = false;
        }, error => {
            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
            this.loading = false;
            console.log('GET TABLE: ', error);
        });
    }
    /*
    * @desc assign to this.sortName and this.sortValue the inputed name and value
    * @param sort -> contains selected key and value
    * @return void
    */
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        this.search();
    }
    /*
    * @desc sort and filt displayed data from name and value
    * @param -
    * @return void
    */
    search() {
        const filterFunc = (item) => (this.listOfSearchName.length ? this.listOfSearchName.some(email => item.email.indexOf(email) !== -1) : true);
        const data = this.sortedData.filter(item => filterFunc(item));
        /* sort data */
        if (this.sortName && this.sortValue) {
            this.dataResult = data.sort((a, b) => this.sortValue === 'ascend'
                ? a[this.sortName] > b[this.sortName]
                    ? 1
                    : -1
                : b[this.sortName] > a[this.sortName]
                    ? 1
                    : -1);
        }
        else {
            this.dataResult = data;
        }
    }
};
LivingsNotificationsComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_3__["DataService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_2__["NzMessageService"] }
];
LivingsNotificationsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-livings-notifications',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./livings-notifications.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/livings-notifications/livings-notifications.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./livings-notifications.component.scss */ "./src/app/pages/livings-notifications/livings-notifications.component.scss")).default]
    })
], LivingsNotificationsComponent);



/***/ }),

/***/ "./src/app/pages/login/login.component.scss":
/*!**************************************************!*\
  !*** ./src/app/pages/login/login.component.scss ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container {\n  text-align: center;\n  width: 100%;\n  height: 100%;\n}\n\n.form-container > input {\n  width: 200px;\n}\n\nnz-card {\n  margin: 200px auto 0 auto;\n  width: 600px;\n  font-size: 25px;\n}\n\nnz-card input {\n  text-align: center;\n}\n\nnz-card #logo {\n  width: 40%;\n  height: auto;\n  margin: 50px auto 30px auto;\n}\n\nnz-card #version {\n  font-size: 14px;\n}\n\nnz-card #loginBtn {\n  width: 250px;\n  height: 50px;\n  margin-top: 30px;\n  font-size: 30px;\n  background-color: #004080;\n}\n\nnz-card #errorMessage {\n  color: red;\n  margin-top: 20px;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/pages/login/login.component.ts":
/*!************************************************!*\
  !*** ./src/app/pages/login/login.component.ts ***!
  \************************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_auth_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../services/auth.service */ "./src/app/services/auth.service.ts");
/* harmony import */ var _node_modules_js_sha256__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../node_modules/js-sha256 */ "./node_modules/js-sha256/src/sha256.js");
/* harmony import */ var _node_modules_js_sha256__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_js_sha256__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/shared/global.service */ "./src/app/shared/global.service.ts");






let LoginComponent = class LoginComponent {
    constructor(router, auth, globalService) {
        this.router = router;
        this.auth = auth;
        this.globalService = globalService;
    }
    ngOnInit() {
        this.appVersion = this.globalService.appVersion;
        this.password = '';
        this.showError = false;
    }
    /*
    * @desc check if inputed psw is valid
    * @return void
    */
    onSubmit() {
        const formData = new FormData();
        formData.append('login', Object(_node_modules_js_sha256__WEBPACK_IMPORTED_MODULE_4__["sha256"])(this.password));
        this.auth.checkLogin(formData).subscribe(result => {
            this.auth.sendToken('1');
            this.router.navigateByUrl('/admin');
            this.globalService.saveKey(Object(_node_modules_js_sha256__WEBPACK_IMPORTED_MODULE_4__["sha256"])(this.password));
        }, error => {
            this.showError = true;
            console.log('LOGIN: ', error);
        });
    }
    keyDownFunction(event) {
        if (event.keyCode === 13) {
            this.onSubmit();
        }
    }
};
LoginComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services_auth_service__WEBPACK_IMPORTED_MODULE_3__["AuthService"] },
    { type: src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_5__["GlobalService"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-login',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.scss */ "./src/app/pages/login/login.component.scss")).default]
    })
], LoginComponent);



/***/ }),

/***/ "./src/app/pages/notifications/notifications.component.scss":
/*!******************************************************************!*\
  !*** ./src/app/pages/notifications/notifications.component.scss ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL25vdGlmaWNhdGlvbnMvbm90aWZpY2F0aW9ucy5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/pages/notifications/notifications.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/pages/notifications/notifications.component.ts ***!
  \****************************************************************/
/*! exports provided: NotificationsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationsComponent", function() { return NotificationsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");




let NotificationsComponent = class NotificationsComponent {
    constructor(dataService, message) {
        this.dataService = dataService;
        this.message = message;
        this.sortName = null;
        this.sortValue = null;
        this.listOfSearchName = [];
        this.loading = true;
    }
    /*
    * Get table content on Component init
    */
    ngOnInit() {
        this.loading = true;
        this.dataService.getTable('notifications').subscribe(result => {
            this.dataResult = result;
            this.sortedData = [
                ...this.dataResult
            ];
            this.loading = false;
        }, error => {
            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
            this.loading = false;
            console.log('GET TABLE: ', error);
        });
    }
    /*
    * @desc assign to this.sortName and this.sortValue the inputed name and value
    * @param sort -> contains selected key and value
    * @return void
    */
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        this.search();
    }
    /*
    * @desc sort and filt displayed data from name and value
    * @param -
    * @return void
    */
    search() {
        const filterFunc = (item) => (this.listOfSearchName.length ? this.listOfSearchName.some(email => item.email.indexOf(email) !== -1) : true);
        const data = this.sortedData.filter(item => filterFunc(item));
        /* sort data */
        if (this.sortName && this.sortValue) {
            this.dataResult = data.sort((a, b) => this.sortValue === 'ascend'
                ? a[this.sortName] > b[this.sortName]
                    ? 1
                    : -1
                : b[this.sortName] > a[this.sortName]
                    ? 1
                    : -1);
        }
        else {
            this.dataResult = data;
        }
    }
};
NotificationsComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] }
];
NotificationsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-notifications',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./notifications.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/notifications/notifications.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./notifications.component.scss */ "./src/app/pages/notifications/notifications.component.scss")).default]
    })
], NotificationsComponent);



/***/ }),

/***/ "./src/app/pages/packs/packs.component.scss":
/*!**************************************************!*\
  !*** ./src/app/pages/packs/packs.component.scss ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3BhY2tzL3BhY2tzLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/pages/packs/packs.component.ts":
/*!************************************************!*\
  !*** ./src/app/pages/packs/packs.component.ts ***!
  \************************************************/
/*! exports provided: PacksComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PacksComponent", function() { return PacksComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/shared/global.service */ "./src/app/shared/global.service.ts");








let PacksComponent = class PacksComponent {
    constructor(globalService, dataService, message, http, fb) {
        this.globalService = globalService;
        this.dataService = dataService;
        this.message = message;
        this.http = http;
        this.fb = fb;
        this.editCache = {};
        this.uploadURL = this.globalService.uploadURL + 'changePackImages.php';
        this.imgPath = this.globalService.imgPath + 'livings/';
        this.loading = true;
        this.showForm = false;
        /*
        * @desc change icon action. save icon as "dataResult.code_thb" in this.imgPath
        * @param item -> uploaded icon name
        * @return void
        */
        this.customIconReq = (item) => {
            // Create a FormData here to store files and other parameters.
            const formData = new FormData();
            formData.append('file', item.file);
            formData.append('field', '\_thb');
            formData.append('filename', item.name);
            formData.append('ext', item.file.name.substr(item.file.name.lastIndexOf('.')));
            const req = new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpRequest"]('POST', item.action, formData, {
                reportProgress: true
            });
            // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
            return this.http.request(req).subscribe((event) => {
                if (event.type === _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpEventType"].UploadProgress) {
                    if (event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    item.onProgress(event, item.file);
                }
                else if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpResponse"]) {
                    item.onSuccess(event.body, item.file, event);
                }
            }, err => {
                item.onError(err, item.file);
            });
        };
        /*
        * @desc change image action. save icon as "dataResult.code" in this.imgPath
        * @param item -> uploaded image name
        * @return void
        */
        this.customReq = (item) => {
            // Create a FormData here to store files and other parameters.
            const formData = new FormData();
            formData.append('file', item.file);
            formData.append('field', '');
            formData.append('filename', item.name);
            formData.append('ext', item.file.name.substr(item.file.name.lastIndexOf('.')));
            const req = new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpRequest"]('POST', item.action, formData, {
                reportProgress: true
            });
            // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
            return this.http.request(req).subscribe((event) => {
                if (event.type === _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpEventType"].UploadProgress) {
                    if (event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    item.onProgress(event, item.file);
                }
                else if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpResponse"]) {
                    item.onSuccess(event.body, item.file, event);
                }
            }, err => {
                item.onError(err, item.file);
            });
        };
        /*
        * @desc check if uploaded image is valid before insert into database and save
        * @param file -> uploaded image
        * @return boolean, true if valid, false otherwise
        */
        this.beforeUpload = (file) => {
            return new rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"]((observer) => {
                // CHECK EXTENSION TYPES
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                if (!isJPG && !isPNG) {
                    this.message.create('error', 'Only .png and .jpg files are supported', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                // CHECK SIZE file max size -> 2MB
                const isLt2M = file.size < 2097152;
                if (!isLt2M) {
                    this.message.create('error', 'File size must be under 2MB', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                observer.next((isJPG || isPNG) && isLt2M);
                observer.complete();
            });
        };
        /*
        * @desc check if uploaded icon is valid before insert into database and save
        * @param file -> uploaded icon
        * @return boolean, true if valid, false otherwise
        */
        this.beforeUploadIcon = (file) => {
            return new rxjs__WEBPACK_IMPORTED_MODULE_5__["Observable"]((observer) => {
                // CHECK EXTENSION TYPES
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                if (!isJPG && !isPNG) {
                    this.message.create('error', 'Only .png and .jpg files are supported', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                // CHECK SIZE file max size -> 2MB
                const isLt2M = file.size < 2097152;
                if (!isLt2M) {
                    this.message.create('error', 'File size must be under 2MB', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                // CHECK DIMENSION
                this.checkIconDimension(file, 512, 512).then(dimensionRes => {
                    if (!dimensionRes) {
                        this.message.create('error', 'File dimension must be 512x512', { nzDuration: 5000 });
                        observer.complete();
                        return;
                    }
                    observer.next((isJPG || isPNG) && isLt2M && dimensionRes);
                    observer.complete();
                });
            });
        };
    }
    ngOnInit() {
        this.loading = true;
        this.dataService.getTable('living').subscribe(result => {
            this.dataResult = result;
            this.updateEditCache();
            this.loading = false;
        }, error => {
            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
            this.loading = false;
            console.log('GET TABLE: ', error);
        });
        this.packGroup = this.fb.group({
            code: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
            qr: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
            title: this.fb.group({
                de: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                el: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                en: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                es: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                fr: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                hu: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                it: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                pl: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                pt: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                ro: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                zh: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                zs: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                ar: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                cs: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                sk: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
                vn: new _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]),
            })
        });
    }
    /*
    * @desc build editCache as a (not deep) copy of dataResult array used for edit functions
    * @param -
    * @return void
    */
    updateEditCache() {
        this.dataResult.forEach(item => {
            this.editCache[item.code] = {
                visibleImage: false,
                visibleIcon: false,
                loading: false,
                edit: false,
                data: {
                    code: item.code.valueOf(),
                    qr: item.qr.valueOf(),
                    icon: item.icon.valueOf(),
                    image: item.image.valueOf(),
                    status: item.status.valueOf(),
                    title: this.updateTitleCache(item.title)
                }
            };
        });
    }
    /*
    * @desc build editCache.title as a (not deep) copy of dataResult.title array
    * @param itemTitle -> dataResult[i].title array
    * @return void
    */
    updateTitleCache(itemTitle) {
        const title = [];
        itemTitle.forEach(titleItem => {
            title.push({
                key: titleItem.key.valueOf(),
                value: titleItem.value.valueOf()
            });
        });
        return title;
    }
    /*
    * @desc start edit action
    * @param code -> dataResult item's code
    * @return void
    */
    startEdit(code) {
        this.editCache[code].edit = true;
    }
    /*
    * @desc cancel edit action. Reset editCache
    * @param -
    * @return void
    */
    cancelEdit() {
        this.updateEditCache();
    }
    /*
    * @desc save edit action. call dataService, find and replace edited record in the database
    * @param code -> dataResult item's code
    * @return void
    */
    saveEdit(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex(item => item.code === code);
            Object.assign(this.dataResult[index], this.editCache[code].data);
            this.editCache[code].edit = false;
            // build a title string
            let title = '{';
            for (let i = 0; i < this.dataResult[index].title.length; i++) {
                title = title + '"' + this.dataResult[index].title[i].key + '":"' +
                    this.dataResult[index].title[i].value.toString() + '"';
                if (i < this.dataResult[index].title.length - 1) {
                    title = title + ',';
                }
            }
            title = title + '}';
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + title);
            const formData = new FormData();
            formData.append('table', 'livings');
            formData.append('code', code);
            formData.append('qr', this.dataResult[index].qr);
            formData.append('title', title);
            formData.append('checkKey', checkSumKey);
            // call data service, find and REPLACE records
            this.dataService.editTable(formData).subscribe(result => {
                this.message.create('success', 'Record edited successfully', { nzDuration: 5000 });
                this.updateEditCache();
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('EDIT: ', error);
            });
        });
    }
    /*
      * @desc delete action. Find and delete record in the database
      * @param code -> dataResult item's code
      * @return void
      */
    deleteRow(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.dataResult = this.dataResult.filter(d => d.code !== code);
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblLivings');
            const formData = new FormData();
            formData.append('table', 'TblLivings');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            // call data service, DELETE record
            this.dataService.deleteRowTable(formData).subscribe(result => {
                this.message.create('success', 'Record deleted successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'An error occured', { nzDuration: 5000 });
                console.log('DELETE: ', error);
            });
        });
    }
    /*
    * @desc change state action. Find and change record's status in the database
    * @param code -> dataResult item's code
    * @return void
    */
    onClickSwitch(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex(item => item.code === code);
            this.dataResult[index].status = !this.dataResult[index].status;
            this.editCache[code].data.status = !this.editCache[code].data.status;
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblLivings');
            const formData = new FormData();
            formData.append('table', 'TblLivings');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            this.dataService.editStatus(formData).subscribe(result => {
                this.message.create('success', 'Status changed successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('CHANGE SWITCH: ', error);
            });
        });
    }
    /*
    * @desc add action. add record in the database
    * @param -
    * @return void
    */
    addRow() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            // IF FORM INPUT CODE ALREADY EXISTS -> SHOW ERROR
            const codeIndex = this.dataResult.findIndex(item => item.code === this.packGroup.value.code);
            if (codeIndex > -1) {
                this.message.create('error', 'Pack\'s code already exists', { nzDuration: 5000 });
            }
            else if (this.packGroup.invalid) {
                this.message.create('error', 'All * fields are required', { nzDuration: 5000 });
            }
            else {
                const title = (JSON.stringify(this.packGroup.value.title));
                const checkSumKey = yield this.globalService.encryptDataGlobal(this.packGroup.value.code + this.packGroup.value.qr + title);
                const formData = new FormData();
                formData.append('table', 'livings');
                formData.append('code', this.packGroup.value.code);
                formData.append('qr', this.packGroup.value.qr);
                formData.append('title', title);
                formData.append('checkKey', checkSumKey);
                this.dataService.addRowToTable(formData).subscribe(result => {
                    this.message.create('success', 'Row added successfully', { nzDuration: 5000 });
                    // refresh editCache and dataResult with a new row
                    this.ngOnInit();
                }, error => {
                    this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                    console.log('ADD: ', error);
                });
            }
        });
    }
    /*
    * @desc edit/add image and icon name action. find and add/edit image and icon in database
    * @param info -> uploaded file;
    * @param code -> dataResult.code;
    * @param field -> "image" || "icon";
    * @return void
    */
    handleChange(info, code, field) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            switch (info.file.status) {
                case 'uploading':
                    this.editCache[code].loading = true;
                    break;
                case 'done':
                    const data = this.editCache[code].data;
                    const fileExtension = info.file.name.substr(info.file.name.lastIndexOf('.'));
                    const index = this.dataResult.findIndex(item => item.code === code);
                    // ****************************************ICON UPDATING
                    if (field === 'icon') {
                        // CUSTOMIZED ICON NAME
                        data.icon = data.code + '\_thb' + fileExtension;
                        const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + field + data.icon);
                        // ENTER HERE WHEN:
                        // 1- data.icon doesn't exists
                        // 2- upload a new icon with different extension
                        if (!this.dataResult[index].icon.includes(data.icon)) {
                            const formData = new FormData();
                            formData.append('table', 'TblLivings');
                            formData.append('code', data.code);
                            formData.append('file', data.icon);
                            formData.append('field', 'icon');
                            formData.append('checkKey', checkSumKey);
                            this.dataService.uploadFiles(formData).subscribe(result => {
                                this.message.create('success', 'Icon added successfully', { nzDuration: 5000 });
                            }, error => {
                                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                                console.log('UPLOAD FILE: ', error);
                            });
                        }
                        else {
                            this.message.create('success', 'Icon changed successfully', { nzDuration: 5000 });
                            // REFRESH URL
                            data.icon += '?random+\=' + Math.random();
                            this.editCache[code].loading = true;
                        }
                    }
                    else if (field === 'image') {
                        // CUSTOMIZED IMAGE NAME
                        data.image = data.code + fileExtension;
                        const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + field + data.image);
                        // ENTER HERE WHEN:
                        // 1- data.image doesn't exists
                        // 2- upload a new image with different extension
                        if (!this.dataResult[index].image.includes(data.image)) {
                            const formData = new FormData();
                            formData.append('table', 'TblLivings');
                            formData.append('code', data.code);
                            formData.append('file', data.image);
                            formData.append('field', 'image');
                            formData.append('checkKey', checkSumKey);
                            this.dataService.uploadFiles(formData).subscribe(result => {
                                this.message.create('success', 'Image added successfully', { nzDuration: 5000 });
                                this.updateEditCache();
                            }, error => {
                                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                                console.log('UPLOAD FILE: ', error);
                            });
                        }
                        else {
                            this.message.create('success', 'Image changed successfully', { nzDuration: 5000 });
                            // REFRESH URL
                            data.image += '?random+\=' + Math.random();
                            this.editCache[code].loading = true;
                        }
                    }
                    // ASSIGN EDITED PICTURE
                    Object.assign(this.dataResult[index], this.editCache[code].data);
                    this.editCache[code].loading = false;
                    break;
                case 'error':
                    this.message.create('error', 'An error occured', { nzDuration: 5000 });
                    console.log('HANDLE CHANGE: ', info.file.status, info.file, code);
                    break;
            }
        });
    }
    checkIconDimension(file, maxW, maxH) {
        return new Promise(resolve => {
            const img = new Image(); // create image
            img.src = window.URL.createObjectURL(file);
            img.onload = () => {
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                window.URL.revokeObjectURL(img.src);
                resolve(width === maxW && height === maxH);
            };
        });
    }
};
PacksComponent.ctorParameters = () => [
    { type: src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_7__["GlobalService"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_6__["DataService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_4__["NzMessageService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] }
];
PacksComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-packs',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./packs.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/packs/packs.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./packs.component.scss */ "./src/app/pages/packs/packs.component.scss")).default]
    })
], PacksComponent);



/***/ }),

/***/ "./src/app/pages/products/products.component.scss":
/*!********************************************************!*\
  !*** ./src/app/pages/products/products.component.scss ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".addCard {\n  margin-bottom: 15px;\n}\n\n.editSelectCategory {\n  width: 150px;\n}\n\n.editSelectRequired {\n  width: 100px;\n}\n\n.editSelectProtocol {\n  width: 50px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvcHJvZHVjdHMvQzpcXFVzZXJzXFxhY29iclxcRG9jdW1lbnRzXFxWaXN1YWwgU3R1ZGlvIDIwMTlcXFByb2plY3RzXFxsYWljYS5vY2EuYXBwYWRtaW4vc3JjXFxhcHBcXHBhZ2VzXFxwcm9kdWN0c1xccHJvZHVjdHMuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3BhZ2VzL3Byb2R1Y3RzL3Byb2R1Y3RzLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksbUJBQUE7QUNDSjs7QURFQTtFQUNJLFlBQUE7QUNDSjs7QURDQTtFQUNJLFlBQUE7QUNFSjs7QURDQTtFQUNJLFdBQUE7QUNFSiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3Byb2R1Y3RzL3Byb2R1Y3RzLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmFkZENhcmQge1xyXG4gICAgbWFyZ2luLWJvdHRvbTogMTVweDtcclxufVxyXG5cclxuLmVkaXRTZWxlY3RDYXRlZ29yeSB7XHJcbiAgICB3aWR0aDogMTUwcHg7XHJcbn1cclxuLmVkaXRTZWxlY3RSZXF1aXJlZCB7XHJcbiAgICB3aWR0aDogMTAwcHg7XHJcbn1cclxuXHJcbi5lZGl0U2VsZWN0UHJvdG9jb2wge1xyXG4gICAgd2lkdGg6IDUwcHg7XHJcbn0iLCIuYWRkQ2FyZCB7XG4gIG1hcmdpbi1ib3R0b206IDE1cHg7XG59XG5cbi5lZGl0U2VsZWN0Q2F0ZWdvcnkge1xuICB3aWR0aDogMTUwcHg7XG59XG5cbi5lZGl0U2VsZWN0UmVxdWlyZWQge1xuICB3aWR0aDogMTAwcHg7XG59XG5cbi5lZGl0U2VsZWN0UHJvdG9jb2wge1xuICB3aWR0aDogNTBweDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/pages/products/products.component.ts":
/*!******************************************************!*\
  !*** ./src/app/pages/products/products.component.ts ***!
  \******************************************************/
/*! exports provided: ProductsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProductsComponent", function() { return ProductsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/shared/global.service */ "./src/app/shared/global.service.ts");








let ProductsComponent = class ProductsComponent {
    constructor(globalService, dataService, message, http, fb) {
        this.globalService = globalService;
        this.dataService = dataService;
        this.message = message;
        this.http = http;
        this.fb = fb;
        this.protocolValues = ['a', 'b', 'c', 'd', 'e'];
        this.requiredValues = ['target', 'memory'];
        this.categoryValues = [];
        this.editCache = {};
        this.imgPath = this.globalService.imgPath + 'products/'; // same movie
        this.uploadURL = this.globalService.uploadURL + 'changeProductImages.php';
        this.pdfPath = this.globalService.imgPath + 'products/';
        this.uploadPdfURL = this.globalService.uploadURL + 'changeProductImages.php';
        this.loading = true;
        this.showForm = false;
        /*
        * @desc change icon action. save icon as "dataResult.code_thb" in this.imgPath
        * @param item -> uploaded icon name
        * @return void
        */
        this.customIconReq = (item) => {
            // Create a FormData here to store files and other parameters.
            const formData = new FormData();
            formData.append('file', item.file);
            formData.append('field', '\_thb');
            formData.append('filename', item.name);
            formData.append('ext', item.file.name.substr(item.file.name.lastIndexOf('.')));
            const req = new _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpRequest"]('POST', item.action, formData, {
                reportProgress: true
            });
            // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
            return this.http.request(req).subscribe((event) => {
                if (event.type === _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpEventType"].UploadProgress) {
                    if (event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    item.onProgress(event, item.file);
                }
                else if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpResponse"]) {
                    item.onSuccess(event.body, item.file, event);
                }
            }, err => {
                item.onError(err, item.file);
            });
        };
        /*
        * @desc change image action. save image as "dataResult.code" in this.imgPath
        * @param item -> uploaded icon name
        * @return void
        */
        this.customReq = (item) => {
            // Create a FormData here to store files and other parameters.
            const formData = new FormData();
            formData.append('file', item.file);
            formData.append('field', '');
            formData.append('filename', item.name);
            formData.append('ext', item.file.name.substr(item.file.name.lastIndexOf('.')));
            const req = new _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpRequest"]('POST', item.action, formData, {
                reportProgress: true
            });
            // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
            return this.http.request(req).subscribe((event) => {
                if (event.type === _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpEventType"].UploadProgress) {
                    if (event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    item.onProgress(event, item.file);
                }
                else if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpResponse"]) {
                    item.onSuccess(event.body, item.file, event);
                }
            }, err => {
                item.onError(err, item.file);
            });
        };
        /*
        * @desc change lotto_image action. save lotto_image as "dataResult.code_label" in this.imgPath
        * @param item -> uploaded icon name
        * @return void
        */
        this.customLottoReq = (item) => {
            // Create a FormData here to store files and other parameters.
            const formData = new FormData();
            formData.append('file', item.file);
            formData.append('field', '\_label');
            formData.append('filename', item.name);
            formData.append('ext', item.file.name.substr(item.file.name.lastIndexOf('.')));
            const req = new _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpRequest"]('POST', item.action, formData, {
                reportProgress: true
            });
            // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
            return this.http.request(req).subscribe((event) => {
                if (event.type === _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpEventType"].UploadProgress) {
                    if (event.total > 0) {
                        event.percent = (event.loaded / event.total) * 100;
                    }
                    item.onProgress(event, item.file);
                }
                else if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpResponse"]) {
                    item.onSuccess(event.body, item.file, event);
                }
            }, err => {
                item.onError(err, item.file);
            });
        };
        /*
        * @desc check if uploaded image is valid before insert into database and save
        * @param file -> uploaded image
        * @return boolean, true if valid, false otherwise
        */
        this.beforeUpload = (file) => {
            return new rxjs__WEBPACK_IMPORTED_MODULE_6__["Observable"]((observer) => {
                // CHECK EXTENSION TYPES
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                if (!isJPG && !isPNG) {
                    this.message.create('error', 'Only .png and .jpg files are supported', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                // CHECK SIZE file max size -> 2MB
                const isLt2M = file.size < 2097152;
                if (!isLt2M) {
                    this.message.create('error', 'File size must be under 2MB', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                observer.next((isJPG || isPNG) && isLt2M);
                observer.complete();
            });
        };
        /*
        * @desc check if uploaded icon is valid before insert into database and save
        * @param file -> uploaded icon
        * @return boolean, true if valid, false otherwise
        */
        this.beforeUploadIcon = (file) => {
            return new rxjs__WEBPACK_IMPORTED_MODULE_6__["Observable"]((observer) => {
                // CHECK EXTENSION TYPES
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                if (!isJPG && !isPNG) {
                    this.message.create('error', 'Only .png and .jpg files are supported', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                // CHECK SIZE file max size -> 2MB
                const isLt2M = file.size < 2097152;
                if (!isLt2M) {
                    this.message.create('error', 'File size must be under 2MB', { nzDuration: 5000 });
                    observer.complete();
                    return;
                }
                // CHECK DIMENSION
                this.checkIconDimension(file, 512, 512).then(dimensionRes => {
                    if (!dimensionRes) {
                        this.message.create('error', 'File dimension must be 512x512', { nzDuration: 5000 });
                        observer.complete();
                        return;
                    }
                    observer.next((isJPG || isPNG) && isLt2M && dimensionRes);
                    observer.complete();
                });
            });
        };
        /*
        * @desc check if uploaded pdf is valid before insert into database and save
        * @param file -> uploaded pdf
        * @return boolean, true if valid, false otherwise
        */
        this.beforeUploadPdf = (file) => {
            if (file.type !== 'application/pdf') {
                this.message.create('error', 'Only .pdf files are supported', { nzDuration: 5000 });
                return false;
            }
            // file max size -> 10MB
            if (file.size > 104885760) {
                this.message.create('error', 'File size must be under 10MB', { nzDuration: 5000 });
                return false;
            }
            return true;
        };
        /*
        * @desc check if uploaded mp4 is valid before insert into database and save
        * @param file -> uploaded mp4
        * @return boolean, true if valid, false otherwise
        */
        this.beforeUploadMp4 = (file) => {
            if (file.type !== 'video/mp4') {
                this.message.create('error', 'Only .mp4 files are supported', { nzDuration: 5000 });
                return false;
            }
            // file max size -> 2MB
            if (file.size > 2097152) {
                this.message.create('error', 'File size must be under 2MB', { nzDuration: 5000 });
                return false;
            }
            return true;
        };
    }
    /*
    * Get table content on Component init
    */
    ngOnInit() {
        this.loading = true;
        this.dataService.getTable('products').subscribe(result => {
            this.dataResult = result;
            this.updateEditCache();
            this.loading = false;
        }, error => {
            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
            console.log('GET TABLE: ', error);
            this.loading = false;
        });
        this.productGroup = this.fb.group({
            code: new _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_5__["Validators"].required]),
            title: new _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormControl"]('', [_angular_forms__WEBPACK_IMPORTED_MODULE_5__["Validators"].required]),
            catCode: new _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormControl"](null, [_angular_forms__WEBPACK_IMPORTED_MODULE_5__["Validators"].required]),
            comType: new _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormControl"](null, [_angular_forms__WEBPACK_IMPORTED_MODULE_5__["Validators"].required]),
            required: new _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormControl"](null),
        });
        this.dataService.getCategoriesTitle().subscribe(result => {
            for (let i = 0; i < result.length; i++) {
                this.categoryValues.push({ 'value': result[i].catCode, 'text': result[i].catTitle });
            }
        }, error => {
            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
            console.log('GET CATEGORIES TITLE: ', error);
        });
    }
    /*
    * @desc build editCache as a (not deep) copy of dataResult array used for edit functions
    * @param -
    * @return void
    */
    updateEditCache() {
        this.dataResult.forEach(item => {
            this.editCache[item.code] = {
                visibleImage: false,
                visibleIcon: false,
                visibleLotto: false,
                loading: false,
                edit: false,
                data: Object.assign({}, item)
            };
        });
    }
    /*
    * @desc start edit action
    * @param code -> dataResult item's code
    * @return void
    */
    startEdit(code) {
        this.editCache[code].edit = true;
    }
    /*
    * @desc cancel edit action. Reset editCache
    * @param -
    * @return void
    */
    cancelEdit(code) {
        const index = this.dataResult.findIndex(item => item.code === code);
        this.editCache[code] = {
            visibleImage: false,
            visibleIcon: false,
            visibleLotto: false,
            data: Object.assign({}, this.dataResult[index]),
            loading: false,
            edit: false
        };
    }
    /*
    * @desc save edit action. call dataService, find and replace edited record in the database
    * @param code -> dataResult item's code
    * @return void
    */
    saveEdit(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex(item => item.code === code);
            Object.assign(this.dataResult[index], this.editCache[code].data);
            this.editCache[code].edit = false;
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + this.dataResult[index].title +
                this.dataResult[index].catCode + this.dataResult[index].comType +
                this.dataResult[index].required);
            const formData = new FormData();
            formData.append('table', 'products');
            formData.append('code', code);
            formData.append('title', this.dataResult[index].title);
            formData.append('catCode', this.dataResult[index].catCode);
            formData.append('comType', this.dataResult[index].comType);
            formData.append('linkTutorial', this.dataResult[index].linkTutorial);
            formData.append('required', this.dataResult[index].required);
            formData.append('checkKey', checkSumKey);
            // call data service, find and REPLACE records
            this.dataService.editTable(formData).subscribe(result => {
                this.message.create('success', 'Record edited successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('EDIT: ', error);
            });
        });
    }
    /*
    * @desc delete action. Find and delete record in the database
    * @param code -> dataResult item's code
    * @return void
    */
    deleteRow(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.dataResult = this.dataResult.filter(d => d.code !== code);
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblProducts');
            const formData = new FormData();
            formData.append('table', 'TblProducts');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            // call data service, DELETE record
            this.dataService.deleteRowTable(formData).subscribe(result => {
                this.message.create('success', 'Record deleted successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('DELETE: ', error);
            });
        });
    }
    /*
    * @desc add action. add record in the database
    * @param -
    * @return void
    */
    addRow() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            // IF FORM INPUT CODE ALREADY EXISTS -> SHOW ERROR
            const codeIndex = this.dataResult.findIndex(item => item.code === this.productGroup.value.code);
            if (codeIndex > -1) {
                this.message.create('error', 'Product\'s code already exists', { nzDuration: 5000 });
            }
            else if (this.productGroup.invalid) {
                this.message.create('error', 'All * fields are required', { nzDuration: 5000 });
            }
            else {
                const checkSumKey = yield this.globalService.encryptDataGlobal(this.productGroup.value.code +
                    this.productGroup.value.title + this.productGroup.value.catCode + this.productGroup.value.comType +
                    this.productGroup.value.required);
                const formData = new FormData();
                formData.append('table', 'products');
                formData.append('code', this.productGroup.value.code);
                formData.append('title', this.productGroup.value.title);
                formData.append('catCode', this.productGroup.value.catCode);
                formData.append('comType', this.productGroup.value.comType);
                formData.append('required', this.productGroup.value.required);
                formData.append('checkKey', checkSumKey);
                // call data service, ADD record
                this.dataService.addRowToTable(formData).subscribe(result => {
                    this.message.create('success', 'Row added successfully', { nzDuration: 5000 });
                    // refresh editCache and dataResult with a new row
                    this.ngOnInit();
                }, error => {
                    this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                    console.log('ADD: ', error);
                });
            }
        });
    }
    /*
    * @desc change state action. Find and change record's status in the database
    * @param code -> dataResult item's code
    * @return void
    */
    onClickSwitch(code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex(item => item.code === code);
            this.dataResult[index].status = !this.dataResult[index].status;
            this.editCache[code].data.status = !this.editCache[code].data.status;
            const checkSumKey = yield this.globalService.encryptDataGlobal(code + 'TblProducts');
            const formData = new FormData();
            formData.append('table', 'TblProducts');
            formData.append('code', code);
            formData.append('checkKey', checkSumKey);
            this.dataService.editStatus(formData).subscribe(result => {
                this.message.create('success', 'Status changed successfully', { nzDuration: 5000 });
            }, error => {
                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                console.log('CHANGE SWITCH: ', error);
            });
        });
    }
    /*
    * @desc edit/add image and icon name action. find and add/edit image and icon in database
    * @param info -> uploaded file;
    * @param code -> dataResult.code;
    * @param field -> "image" || "icon" || "image_lotto";
    * @return void
    */
    handleChange(info, code, field) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            switch (info.file.status) {
                case 'uploading':
                    this.editCache[code].loading = true;
                    break;
                case 'done':
                    const data = this.editCache[code].data;
                    const fileExtension = info.file.name.substr(info.file.name.lastIndexOf('.'));
                    const index = this.dataResult.findIndex(item => item.code === code);
                    // ****************************************ICON UPDATING
                    if (field === 'icon') {
                        // CUSTOMIZED ICON NAME
                        data.icon = data.code + '\_thb' + fileExtension;
                        const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + field + data.icon);
                        // ENTER HERE WHEN:
                        // 1- data.icon doesn't exists
                        // 2- upload a new icon with different extension
                        if (!this.dataResult[index].icon.includes(data.icon)) {
                            const formData = new FormData();
                            formData.append('table', 'TblProducts');
                            formData.append('code', data.code);
                            formData.append('file', data.icon);
                            formData.append('field', 'icon');
                            formData.append('checkKey', checkSumKey);
                            this.dataService.uploadFiles(formData).subscribe(result => {
                                this.message.create('success', 'Icon added successfully', { nzDuration: 5000 });
                            }, error => {
                                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                                console.log('UPLOAD FILE: ', error);
                            });
                        }
                        else {
                            this.message.create('success', 'Icon changed successfully', { nzDuration: 5000 });
                            // REFRESH URL
                            data.icon += '?random+\=' + Math.random();
                            this.editCache[code].loading = true;
                        }
                    }
                    else if (field === 'image') {
                        // CUSTOMIZED IMAGE NAME
                        data.image = data.code + fileExtension;
                        const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + field + data.image);
                        // ENTER HERE WHEN:
                        // 1- data.image doesn't exists
                        // 2- upload a new image with different extension
                        if (!this.dataResult[index].image.includes(data.image)) {
                            const formData = new FormData();
                            formData.append('table', 'TblProducts');
                            formData.append('code', data.code);
                            formData.append('file', data.image);
                            formData.append('field', 'image');
                            formData.append('checkKey', checkSumKey);
                            this.dataService.uploadFiles(formData).subscribe(result => {
                                this.message.create('success', 'Image added successfully', { nzDuration: 5000 });
                                this.updateEditCache();
                            }, error => {
                                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                                console.log('UPLOAD FILE: ', error);
                            });
                        }
                        else {
                            this.message.create('success', 'Image changed successfully', { nzDuration: 5000 });
                            // REFRESH URL
                            data.image += '?random+\=' + Math.random();
                            this.editCache[code].loading = true;
                        }
                    }
                    else if (field === 'image_lotto') {
                        data.imageLotto = data.code + '\_label' + fileExtension;
                        const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + field + data.imageLotto);
                        // ENTER HERE WHEN:
                        // 1- data.imageLotto doesn't exists
                        // 2- upload a new lottoimage with different extension
                        if (!this.dataResult[index].imageLotto.includes(data.imageLotto)) {
                            const formData = new FormData();
                            formData.append('table', 'TblProducts');
                            formData.append('code', data.code);
                            formData.append('file', data.imageLotto);
                            formData.append('field', 'image_lotto');
                            formData.append('checkKey', checkSumKey);
                            this.dataService.uploadFiles(formData).subscribe(result => {
                                this.message.create('success', 'Image added successfully', { nzDuration: 5000 });
                                this.updateEditCache();
                            }, error => {
                                this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                                console.log('UPLOAD FILE: ', error);
                            });
                        }
                        else {
                            this.message.create('success', 'Lotto image changed successfully', { nzDuration: 5000 });
                            // REFRESH URL
                            data.imageLotto += '?random+\=' + Math.random();
                            this.editCache[code].loading = true;
                        }
                    }
                    // ASSIGN EDITED PICTURE
                    Object.assign(this.dataResult[index], this.editCache[code].data);
                    this.editCache[code].loading = false;
                    break;
                case 'error':
                    this.message.create('error', 'An error occured', { nzDuration: 5000 });
                    console.log('HANDLE CHANGE: ', info.file.status, info.file, code);
                    break;
            }
        });
    }
    // CHECK UPLOAD DIMENSION
    checkIconDimension(file, maxW, maxH) {
        return new Promise(resolve => {
            const img = new Image(); // create image
            img.src = window.URL.createObjectURL(file);
            img.onload = () => {
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                window.URL.revokeObjectURL(img.src);
                resolve(width === maxW && height === maxH);
            };
        });
    }
    /*
    * @desc edit/add pdf name action. find and add/edit pdf in database
    * @param info -> uploaded file;
    * @param code -> dataResult.code;
    * @return void
    */
    // ****************************************PDF DOCUMENT UPDATING
    handlePdfChange(info, code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            switch (info.file.status) {
                case 'uploading':
                    this.editCache[code].loading = true;
                    break;
                case 'done':
                    const data = this.editCache[code].data;
                    // ****************************************ICON UPDATING
                    if (typeof data.linkDoc === undefined || data.linkDoc === '' || data.linkDoc === null) {
                        // CUSTOMIZED DOC NAME
                        data.linkDoc = data.code + '.pdf'; // only .pdf
                        const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + 'link_doc' + data.linkDoc);
                        const formData = new FormData();
                        formData.append('table', 'TblProducts');
                        formData.append('code', data.code);
                        formData.append('file', data.linkDoc);
                        formData.append('field', 'link_doc');
                        formData.append('checkKey', checkSumKey);
                        this.dataService.uploadFiles(formData).subscribe(result => {
                            this.message.create('success', 'Document added successfully', { nzDuration: 5000 });
                        }, error => {
                            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                            console.log('UPLOAD PDF: ' + error);
                        });
                    }
                    else {
                        this.message.create('success', 'Document changed successfully', { nzDuration: 5000 });
                        // REFRESH URL
                        this.editCache[code].loading = true;
                    }
                    // ASSIGN EDITED DOC
                    const index = this.dataResult.findIndex(item => item.code === code);
                    Object.assign(this.dataResult[index], this.editCache[code].data);
                    this.editCache[code].loading = false;
                    break;
                case 'error':
                    this.message.create('error', 'An error occured', { nzDuration: 5000 });
                    console.log('HANDLE CHANGE', info.file.status, info.file, code);
                    break;
            }
        });
    }
    /*
    * @desc edit/add video name action. find and add/edit video in database
    * @param info -> uploaded file;
    * @param code -> dataResult.code;
    * @return void
    */
    handleMp4Change(info, code) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            switch (info.file.status) {
                case 'uploading':
                    this.editCache[code].loading = true;
                    break;
                case 'done':
                    const data = this.editCache[code].data;
                    // ****************************************ICON UPDATING
                    if (typeof data.movie === undefined || data.movie === '' || data.movie === null) {
                        // CUSTOMIZED DOC NAME
                        data.movie = data.code + '.mp4'; // only .mp4
                        const checkSumKey = yield this.globalService.encryptDataGlobal(data.code + 'movie' + data.movie);
                        const formData = new FormData();
                        formData.append('table', 'TblProducts');
                        formData.append('code', data.code);
                        formData.append('file', data.movie);
                        formData.append('field', 'movie');
                        formData.append('checkKey', checkSumKey);
                        this.dataService.uploadFiles(formData).subscribe(result => {
                            this.message.create('success', 'Document added successfully', { nzDuration: 5000 });
                        }, error => {
                            this.message.create('error', 'A backend error occured', { nzDuration: 5000 });
                            console.log('UPLOAD MP4: ', error);
                        });
                    }
                    else {
                        this.message.create('success', 'Document changed successfully', { nzDuration: 5000 });
                        // REFRESH URL
                        this.editCache[code].loading = true;
                    }
                    // ASSIGN EDITED DOC
                    const index = this.dataResult.findIndex(item => item.code === code);
                    Object.assign(this.dataResult[index], this.editCache[code].data);
                    this.editCache[code].loading = false;
                    break;
                case 'error':
                    console.log('HANDLE CHANGE: ', info.file.status, info.file, code);
                    this.message.create('error', 'An error occured', { nzDuration: 5000 });
                    break;
            }
        });
    }
};
ProductsComponent.ctorParameters = () => [
    { type: src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_7__["GlobalService"] },
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClient"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"] }
];
ProductsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-products',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./products.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/products/products.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./products.component.scss */ "./src/app/pages/products/products.component.scss")).default]
    })
], ProductsComponent);



/***/ }),

/***/ "./src/app/pages/users/users.component.scss":
/*!**************************************************!*\
  !*** ./src/app/pages/users/users.component.scss ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".totalUsers {\n  margin-bottom: 15px;\n}\n\n.search-box {\n  padding: 8px;\n}\n\n.search-box input {\n  width: 188px;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.search-box button {\n  width: 90px;\n}\n\n.search-button {\n  margin-right: 8px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvdXNlcnMvQzpcXFVzZXJzXFxhY29iclxcRG9jdW1lbnRzXFxWaXN1YWwgU3R1ZGlvIDIwMTlcXFByb2plY3RzXFxsYWljYS5vY2EuYXBwYWRtaW4vc3JjXFxhcHBcXHBhZ2VzXFx1c2Vyc1xcdXNlcnMuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3BhZ2VzL3VzZXJzL3VzZXJzLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksbUJBQUE7QUNDSjs7QURFQTtFQUNJLFlBQUE7QUNDSjs7QURFRTtFQUNFLFlBQUE7RUFDQSxrQkFBQTtFQUNBLGNBQUE7QUNDSjs7QURFRTtFQUNFLFdBQUE7QUNDSjs7QURFRTtFQUNFLGlCQUFBO0FDQ0oiLCJmaWxlIjoic3JjL2FwcC9wYWdlcy91c2Vycy91c2Vycy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi50b3RhbFVzZXJzIHtcclxuICAgIG1hcmdpbi1ib3R0b206IDE1cHg7XHJcbn1cclxuXHJcbi5zZWFyY2gtYm94IHtcclxuICAgIHBhZGRpbmc6IDhweDtcclxuICB9XHJcblxyXG4gIC5zZWFyY2gtYm94IGlucHV0IHtcclxuICAgIHdpZHRoOiAxODhweDtcclxuICAgIG1hcmdpbi1ib3R0b206IDhweDtcclxuICAgIGRpc3BsYXk6IGJsb2NrO1xyXG4gIH1cclxuXHJcbiAgLnNlYXJjaC1ib3ggYnV0dG9uIHtcclxuICAgIHdpZHRoOiA5MHB4O1xyXG4gIH1cclxuXHJcbiAgLnNlYXJjaC1idXR0b24ge1xyXG4gICAgbWFyZ2luLXJpZ2h0OiA4cHg7XHJcbiAgfSIsIi50b3RhbFVzZXJzIHtcbiAgbWFyZ2luLWJvdHRvbTogMTVweDtcbn1cblxuLnNlYXJjaC1ib3gge1xuICBwYWRkaW5nOiA4cHg7XG59XG5cbi5zZWFyY2gtYm94IGlucHV0IHtcbiAgd2lkdGg6IDE4OHB4O1xuICBtYXJnaW4tYm90dG9tOiA4cHg7XG4gIGRpc3BsYXk6IGJsb2NrO1xufVxuXG4uc2VhcmNoLWJveCBidXR0b24ge1xuICB3aWR0aDogOTBweDtcbn1cblxuLnNlYXJjaC1idXR0b24ge1xuICBtYXJnaW4tcmlnaHQ6IDhweDtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/pages/users/users.component.ts":
/*!************************************************!*\
  !*** ./src/app/pages/users/users.component.ts ***!
  \************************************************/
/*! exports provided: UsersComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UsersComponent", function() { return UsersComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/data.service */ "./src/app/services/data.service.ts");
/* harmony import */ var ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ng-zorro-antd */ "./node_modules/ng-zorro-antd/fesm2015/ng-zorro-antd.js");
/* harmony import */ var src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/shared/global.service */ "./src/app/shared/global.service.ts");
/* harmony import */ var xlsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! xlsx */ "./node_modules/xlsx/xlsx.js");
/* harmony import */ var xlsx__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(xlsx__WEBPACK_IMPORTED_MODULE_5__);






let UsersComponent = class UsersComponent {
    constructor(dataService, message, globalService) {
        this.dataService = dataService;
        this.message = message;
        this.globalService = globalService;
        this.sortName = null;
        this.sortValue = null;
        this.searchEmail = "";
        this.visibleSearch = false;
        this.listOfSearchName = [];
        this.loading = true;
    }
    /*
     * Get table content on Component init
     */
    ngOnInit() {
        this.loading = true;
        this.dataService.getTablePiece("1").subscribe((result1) => {
            this.dataService.getTablePiece("2").subscribe((result2) => {
                this.dataResult = result1.concat(result2);
                this.displayedData = [...this.dataResult];
                this.sortedData = [...this.displayedData];
                this.loading = false;
            }, (error) => {
                this.message.create("error", "A backend error occured", { nzDuration: 5000 });
                this.loading = false;
                console.log("GET TABLE: ", error);
            });
        }, (error) => {
            this.message.create("error", "A backend error occured", { nzDuration: 5000 });
            this.loading = false;
            console.log("GET TABLE: ", error);
        });
    }
    /*
     * @desc assign to this.sortName and this.sortValue the inputed name and value
     * @param -
     * @return void
     */
    sort(sort) {
        this.sortName = sort.key;
        this.sortValue = sort.value;
        this.search();
    }
    /*
     * @desc sort and filt displayed data from name and value
     * @param sort -> contains selected key and value
     * @return void
     */
    search() {
        /* filter data */
        const filterFunc = (item) => this.listOfSearchName.length ? this.listOfSearchName.some((email) => item.email.indexOf(email) !== -1) : true;
        const data = this.displayedData.filter((item) => filterFunc(item));
        /* sort data */
        if (this.sortName && this.sortValue) {
            this.displayedData = data.sort((a, b) => this.sortValue === "ascend"
                ? a[this.sortName] > b[this.sortName]
                    ? 1
                    : -1
                : b[this.sortName] > a[this.sortName]
                    ? 1
                    : -1);
        }
        else {
            this.displayedData = data;
        }
    }
    /*
     * @desc change state action. Find and change record's status in the database
     * @param code -> dataResult item's code
     * @return void
     */
    onClickSwitch(email) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex((item) => item.email === email);
            this.dataResult[index].su = !this.dataResult[index].su;
            const checkSumKey = yield this.globalService.encryptDataGlobal(email + "TblUsers");
            const formData = new FormData();
            formData.append("table", "TblUsers");
            formData.append("code", email);
            formData.append("checkKey", checkSumKey);
            this.dataService.editStatus(formData).subscribe((result) => {
                this.message.create("success", "User changed successfully", { nzDuration: 5000 });
            }, (error) => {
                this.message.create("error", "A backend error occured", { nzDuration: 5000 });
                console.log("CHANGE SWITCH: ", error);
            });
        });
    }
    onVerified(email) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const index = this.dataResult.findIndex((item) => item.email === email);
            this.dataResult[index].verified = !this.dataResult[index].verified;
            const checkSumKey = yield this.globalService.encryptDataGlobal(email + "TblUsers");
            const formData = new FormData();
            formData.append("table", "TblUsers");
            formData.append("code", email);
            formData.append("checkKey", checkSumKey);
            this.dataService.editVerified(formData).subscribe((result) => {
                this.message.create("success", "User changed successfully", { nzDuration: 5000 });
            }, (error) => {
                this.message.create("error", "A backend error occured", { nzDuration: 5000 });
                console.log("VERIFIED ERROR: ", error);
            });
        });
    }
    reset() {
        this.searchEmail = "";
        this.find();
    }
    find() {
        this.visibleSearch = false;
        this.displayedData = this.dataResult.filter((item) => item.email.indexOf(this.searchEmail) !== -1);
    }
    downloadFile() {
        let excelData = this.dataResult;
        for (let i = 0; i < excelData.length; i++) {
            delete excelData[i].tokenTemp;
            delete excelData[i].devices;
        }
        console.log(excelData);
        const worksheet = xlsx__WEBPACK_IMPORTED_MODULE_5__["utils"].json_to_sheet(excelData);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        xlsx__WEBPACK_IMPORTED_MODULE_5__["writeFile"](workbook, this.toExportFileName("users"));
    }
    toExportFileName(excelFileName) {
        return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
    }
};
UsersComponent.ctorParameters = () => [
    { type: src_app_services_data_service__WEBPACK_IMPORTED_MODULE_2__["DataService"] },
    { type: ng_zorro_antd__WEBPACK_IMPORTED_MODULE_3__["NzMessageService"] },
    { type: src_app_shared_global_service__WEBPACK_IMPORTED_MODULE_4__["GlobalService"] }
];
UsersComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "app-users",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./users.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/users/users.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./users.component.scss */ "./src/app/pages/users/users.component.scss")).default]
    })
], UsersComponent);



/***/ }),

/***/ "./src/app/services/auth.service.ts":
/*!******************************************!*\
  !*** ./src/app/services/auth.service.ts ***!
  \******************************************/
/*! exports provided: AuthService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthService", function() { return AuthService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _shared_global_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../shared/global.service */ "./src/app/shared/global.service.ts");







let AuthService = class AuthService {
    constructor(myRoute, http, global) {
        this.myRoute = myRoute;
        this.http = http;
        this.global = global;
        this.baseUrl = this.global.phpPath;
    }
    /*
    * @desc set a token in a sessionStorage variable
    * @param token -> token value
    * @return void
    */
    sendToken(token) {
        sessionStorage.setItem('LoggedInUser', token);
    }
    /*
    * @desc get the token in sessionStorage
    * @param -
    * @return boolean: true if user is logged-in, false otherwise
    */
    getToken() {
        return sessionStorage.getItem('LoggedInUser');
    }
    /*
    * @desc get the token in sessionStorage
    * @param -
    * @return boolean: true if user is logged-in, false otherwise
    */
    isLoggedIn() {
        return this.getToken() !== null;
    }
    /*
    * @desc remove a token in a sessionStorage variable and navigate in login page
    * @param -
    * @return void
    */
    logout() {
        sessionStorage.removeItem('LoggedInUser');
        this.myRoute.navigate(['login']);
    }
    /*
    * @desc call backend and check if inputed password is the same key storaged in database
    * @param formData -> contains inputed password
    * @return Observable<Error | any>, error if key is different, any otherwise
    */
    checkLogin(formData) {
        const header = new _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpHeaders"]();
        header.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl + '/checkLogin.php', formData, { headers: header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["throwError"])(details);
            }
        }));
    }
};
AuthService.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _shared_global_service__WEBPACK_IMPORTED_MODULE_6__["GlobalService"] }
];
AuthService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AuthService);



/***/ }),

/***/ "./src/app/services/data.service.ts":
/*!******************************************!*\
  !*** ./src/app/services/data.service.ts ***!
  \******************************************/
/*! exports provided: DataService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataService", function() { return DataService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _shared_global_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../shared/global.service */ "./src/app/shared/global.service.ts");






let DataService = class DataService {
    constructor(http, global) {
        this.http = http;
        this.global = global;
        this.header = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]();
        this.baseUrl = this.global.phpPath;
    }
    /*
     * @desc call backend and get requested table
     * @param request -> requested table
     * @return Observable<Error | any>, any if table exists, error otherwise
     */
    getTable(request) {
        this.header.append("Content-Type", "application/json");
        return this.http.post(this.baseUrl + "/getTable.php", request, { headers: this.header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
        }));
    }
    getTablePiece(request) {
        this.header.append("Content-Type", "application/json");
        return this.http.post(this.baseUrl + "/getTable.php", "users" + request, { headers: this.header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
        }));
    }
    /*
     * @desc call backend and edit requested table's row
     * @param formData -> contains request
     * @return Observable<Error | any>, any if it works, error otherwise
     */
    editTable(formData) {
        this.header.append("Content-Type", "application/json");
        return this.http.post(this.baseUrl + "/editRow.php", formData, { headers: this.header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
        }));
    }
    /*
     * @desc call backend and edit requested table's row's status
     * @param formData -> contains request
     * @return Observable<Error | any>, any if it works, error otherwise
     */
    editStatus(formData) {
        this.header.append("Content-Type", "application/json");
        return this.http.post(this.baseUrl + "/changeStatus.php", formData, { headers: this.header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
        }));
    }
    /*
     * @desc call backend and edit requested table's row's status
     * @param formData -> contains request
     * @return Observable<Error | any>, any if it works, error otherwise
     */
    editVerified(formData) {
        this.header.append("Content-Type", "application/json");
        return this.http.post(this.baseUrl + "/changeVerified.php", formData, { headers: this.header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
        }));
    }
    /*
     * @desc call backend and edit requested table's row's files-name
     * @param formData -> contains request
     * @return Observable<Error | any>, any if it works, error otherwise
     */
    uploadFiles(formData) {
        this.header.append("Content-Type", "application/json");
        return this.http.post(this.baseUrl + "/uploadFile.php", formData, { headers: this.header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
        }));
    }
    /*
     * @desc call backend and delete requested table's row
     * @param formData -> contains request
     * @return Observable<Error | any>, any if it works, error otherwise
     */
    deleteRowTable(formData) {
        this.header.append("Content-Type", "application/json");
        return this.http.post(this.baseUrl + "/deleteRow.php", formData, { headers: this.header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
        }));
    }
    /*
     * @desc call backend and add row in requested table
     * @param formData -> contains request
     * @return Observable<Error | any>, any if it works, error otherwise
     */
    addRowToTable(formData) {
        this.header.append("Content-Type", "application/json");
        return this.http.post(this.baseUrl + "/addRow.php", formData, { headers: this.header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
        }));
    }
    /*
     * @desc call backend and get categories title json
     * @param formData -> contains request
     * @return Observable<Error | any>, any if it works, error otherwise
     */
    getCategoriesTitle() {
        this.header.append("Content-Type", "application/json");
        return this.http.get(this.baseUrl + "/getCategoriesTitle.php", { headers: this.header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
        }));
    }
    /*
     * @desc call backend and get key storaged in it
     * @param -
     * @return Observable<Error | any>, any if it works, error otherwise
     */
    getKey() {
        this.header.append("Content-Type", "application/json");
        return this.http.get(this.baseUrl + "/getKey.php", { headers: this.header }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
            else {
                // A backend error occured (err.status = 500)
                const details = { detail: err.error, status: err.status };
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])(details);
            }
        }));
    }
};
DataService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _shared_global_service__WEBPACK_IMPORTED_MODULE_5__["GlobalService"] }
];
DataService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: "root",
    })
], DataService);



/***/ }),

/***/ "./src/app/shared/global.service.ts":
/*!******************************************!*\
  !*** ./src/app/shared/global.service.ts ***!
  \******************************************/
/*! exports provided: GlobalService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalService", function() { return GlobalService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var crc_crc32__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! crc/crc32 */ "./node_modules/crc/crc32.js");
/* harmony import */ var sodium_plus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! sodium-plus */ "./node_modules/sodium-plus/index.js");
/* harmony import */ var sodium_plus__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(sodium_plus__WEBPACK_IMPORTED_MODULE_3__);




let GlobalService = class GlobalService {
    constructor() {
        this.appVersion = "v23.04.26";
        this.productCatValues = [];
        this.advLanguagesCode = [];
        this.filterCountryCode = [];
        this.allLanguages = [];
        // only for online mode
        this.phpPath = "/php";
        this.uploadURL = "/php/";
        this.imgPath = "https://app.laica.it/assets/";
        // only for developer mode
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
            // this.phpPath = "https://appadmin.laica.it/php";
            // this.uploadURL = "https://appadmin.laica.it/php/";
            this.phpPath = "http://localhost:3000/php";
            this.uploadURL = "http://localhost:3000/php/";
            //this.imgPath = "http://localhost:3000/assets/";
        }
        this.advLanguagesCode = [
            { value: "", text: "ALL LANGUAGE" },
            { value: "de", text: "German" },
            { value: "el", text: "Greek" },
            { value: "en", text: "English" },
            { value: "fr", text: "French" },
            { value: "es", text: "Spanish" },
            { value: "hu", text: "Hungarian" },
            { value: "it", text: "Italian" },
            { value: "pl", text: "Polish" },
            { value: "ro", text: "Romanian" },
            { value: "zh", text: "Chinese" },
            { value: "pt", text: "Portuguese" },
            { value: "vn", text: "Vietnamese" },
        ];
        this.filterCountryCode = [
            { value: "", text: "ALL COUNTRIES" },
            { value: "de", text: "Germany" },
            { value: "el", text: "Greece" },
            { value: "en", text: "England" },
            { value: "fr", text: "France" },
            { value: "es", text: "Spain" },
            { value: "hu", text: "Hungary" },
            { value: "it", text: "Italy" },
            { value: "pl", text: "Poland" },
            { value: "ro", text: "Romania" },
            { value: "zh", text: "China" },
            { value: "pt", text: "Portugal" },
            { value: "vn", text: "Vietnam" },
        ];
        this.allLanguages = [
            { value: "de", text: "German" },
            { value: "el", text: "Greek" },
            { value: "en", text: "English" },
            { value: "fr", text: "French" },
            { value: "es", text: "Spanish" },
            { value: "hu", text: "Hungarian" },
            { value: "it", text: "Italian" },
            { value: "pl", text: "Polish" },
            { value: "ro", text: "Romanian" },
            { value: "zh", text: "Chinese" },
            { value: "pt", text: "Portuguese" },
            { value: "vn", text: "Vietnamese" },
            { value: "zs", text: "Chinese (Simplified)" },
            { value: "ar", text: "Arabic" },
            { value: "cs", text: "Czech" },
            { value: "sk", text: "Slovak" },
        ];
    }
    saveKey(data) {
        this.keyBuffer = Buffer.from(data, "utf8");
    }
    /*
     * @desc encrypt request before a service is called
     * @param data -> decrypted data
     * @return encrypted data
     */
    encryptDataGlobal(data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const crc32Key = Object(crc_crc32__WEBPACK_IMPORTED_MODULE_2__["default"])(data);
            const base64Key = btoa(crc32Key);
            if (!this.sodium) {
                this.sodium = yield sodium_plus__WEBPACK_IMPORTED_MODULE_3__["SodiumPlus"].auto();
            }
            const nonce = yield this.sodium.randombytes_buf(24);
            const keyPair = new sodium_plus__WEBPACK_IMPORTED_MODULE_3__["CryptographyKey"](this.keyBuffer);
            const sKey = yield this.sodium.crypto_box_secretkey(keyPair);
            const pKey = yield this.sodium.crypto_box_publickey(keyPair);
            const encrypted = yield this.sodium.crypto_box(base64Key, nonce, sKey, pKey);
            return nonce.toString("hex") + encrypted.toString("hex");
        });
    }
};
GlobalService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: "root",
    })
], GlobalService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\Users\acobr\Documents\Visual Studio 2019\Projects\laica.oca.appadmin\src\main.ts */"./src/main.ts");


/***/ }),

/***/ 1:
/*!********************!*\
  !*** fs (ignored) ***!
  \********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 10:
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 11:
/*!************************!*\
  !*** stream (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/*!**********************!*\
  !*** path (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/*!********************!*\
  !*** os (ignored) ***!
  \********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 4:
/*!********************!*\
  !*** fs (ignored) ***!
  \********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 5:
/*!**********************!*\
  !*** path (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 6:
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 7:
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 8:
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 9:
/*!********************!*\
  !*** fs (ignored) ***!
  \********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map